  if ( window.innerWidth >= 780 && document.querySelector('.multiple-items-left') != null  || window.innerWidth >= 780 && document.querySelector('.product-gallery') != null )  {
/*! jQuery v3.6.0 | (c) OpenJS Foundation and other contributors | jquery.org/license */ //window.innerWidth >= 780 &&
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(C,e){"use strict";var t=[],r=Object.getPrototypeOf,s=t.slice,g=t.flat?function(e){return t.flat.call(e)}:function(e){return t.concat.apply([],e)},u=t.push,i=t.indexOf,n={},o=n.toString,v=n.hasOwnProperty,a=v.toString,l=a.call(Object),y={},m=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},x=function(e){return null!=e&&e===e.window},E=C.document,c={type:!0,src:!0,nonce:!0,noModule:!0};function b(e,t,n){var r,i,o=(n=n||E).createElement("script");if(o.text=e,t)for(r in c)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function w(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[o.call(e)]||"object":typeof e}var f="3.6.0",S=function(e,t){return new S.fn.init(e,t)};function p(e){var t=!!e&&"length"in e&&e.length,n=w(e);return!m(e)&&!x(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}S.fn=S.prototype={jquery:f,constructor:S,length:0,toArray:function(){return s.call(this)},get:function(e){return null==e?s.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=S.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return S.each(this,e)},map:function(n){return this.pushStack(S.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(s.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(S.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(S.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:u,sort:t.sort,splice:t.splice},S.extend=S.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||m(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(S.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||S.isPlainObject(n)?n:{},i=!1,a[t]=S.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},S.extend({expando:"jQuery"+(f+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==o.call(e))&&(!(t=r(e))||"function"==typeof(n=v.call(t,"constructor")&&t.constructor)&&a.call(n)===l)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){b(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(p(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},makeArray:function(e,t){var n=t||[];return null!=e&&(p(Object(e))?S.merge(n,"string"==typeof e?[e]:e):u.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:i.call(t,e,n)},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(p(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g(a)},guid:1,support:y}),"function"==typeof Symbol&&(S.fn[Symbol.iterator]=t[Symbol.iterator]),S.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var d=function(n){var e,d,b,o,i,h,f,g,w,u,l,T,C,a,E,v,s,c,y,S="sizzle"+1*new Date,p=n.document,k=0,r=0,m=ue(),x=ue(),A=ue(),N=ue(),j=function(e,t){return e===t&&(l=!0),0},D={}.hasOwnProperty,t=[],q=t.pop,L=t.push,H=t.push,O=t.slice,P=function(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return-1},R="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",M="[\\x20\\t\\r\\n\\f]",I="(?:\\\\[\\da-fA-F]{1,6}"+M+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",W="\\["+M+"*("+I+")(?:"+M+"*([*^$|!~]?=)"+M+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+I+"))|)"+M+"*\\]",F=":("+I+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+W+")*)|.*)\\)|)",B=new RegExp(M+"+","g"),$=new RegExp("^"+M+"+|((?:^|[^\\\\])(?:\\\\.)*)"+M+"+$","g"),_=new RegExp("^"+M+"*,"+M+"*"),z=new RegExp("^"+M+"*([>+~]|"+M+")"+M+"*"),U=new RegExp(M+"|>"),X=new RegExp(F),V=new RegExp("^"+I+"$"),G={ID:new RegExp("^#("+I+")"),CLASS:new RegExp("^\\.("+I+")"),TAG:new RegExp("^("+I+"|[*])"),ATTR:new RegExp("^"+W),PSEUDO:new RegExp("^"+F),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+M+"*(even|odd|(([+-]|)(\\d*)n|)"+M+"*(?:([+-]|)"+M+"*(\\d+)|))"+M+"*\\)|)","i"),bool:new RegExp("^(?:"+R+")$","i"),needsContext:new RegExp("^"+M+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+M+"*((?:-\\d)?\\d*)"+M+"*\\)|)(?=[^-]|$)","i")},Y=/HTML$/i,Q=/^(?:input|select|textarea|button)$/i,J=/^h\d$/i,K=/^[^{]+\{\s*\[native \w/,Z=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,ee=/[+~]/,te=new RegExp("\\\\[\\da-fA-F]{1,6}"+M+"?|\\\\([^\\r\\n\\f])","g"),ne=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},re=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,ie=function(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e},oe=function(){T()},ae=be(function(e){return!0===e.disabled&&"fieldset"===e.nodeName.toLowerCase()},{dir:"parentNode",next:"legend"});try{H.apply(t=O.call(p.childNodes),p.childNodes),t[p.childNodes.length].nodeType}catch(e){H={apply:t.length?function(e,t){L.apply(e,O.call(t))}:function(e,t){var n=e.length,r=0;while(e[n++]=t[r++]);e.length=n-1}}}function se(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&(T(e),e=e||C,E)){if(11!==p&&(u=Z.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return n.push(a),n}else if(f&&(a=f.getElementById(i))&&y(e,a)&&a.id===i)return n.push(a),n}else{if(u[2])return H.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&d.getElementsByClassName&&e.getElementsByClassName)return H.apply(n,e.getElementsByClassName(i)),n}if(d.qsa&&!N[t+" "]&&(!v||!v.test(t))&&(1!==p||"object"!==e.nodeName.toLowerCase())){if(c=t,f=e,1===p&&(U.test(t)||z.test(t))){(f=ee.test(t)&&ye(e.parentNode)||e)===e&&d.scope||((s=e.getAttribute("id"))?s=s.replace(re,ie):e.setAttribute("id",s=S)),o=(l=h(t)).length;while(o--)l[o]=(s?"#"+s:":scope")+" "+xe(l[o]);c=l.join(",")}try{return H.apply(n,f.querySelectorAll(c)),n}catch(e){N(t,!0)}finally{s===S&&e.removeAttribute("id")}}}return g(t.replace($,"$1"),e,n,r)}function ue(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function le(e){return e[S]=!0,e}function ce(e){var t=C.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function fe(e,t){var n=e.split("|"),r=n.length;while(r--)b.attrHandle[n[r]]=t}function pe(e,t){var n=t&&e,r=n&&1===e.nodeType&&1===t.nodeType&&e.sourceIndex-t.sourceIndex;if(r)return r;if(n)while(n=n.nextSibling)if(n===t)return-1;return e?1:-1}function de(t){return function(e){return"input"===e.nodeName.toLowerCase()&&e.type===t}}function he(n){return function(e){var t=e.nodeName.toLowerCase();return("input"===t||"button"===t)&&e.type===n}}function ge(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&ae(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function ve(a){return le(function(o){return o=+o,le(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function ye(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}for(e in d=se.support={},i=se.isXML=function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!Y.test(t||n&&n.nodeName||"HTML")},T=se.setDocument=function(e){var t,n,r=e?e.ownerDocument||e:p;return r!=C&&9===r.nodeType&&r.documentElement&&(a=(C=r).documentElement,E=!i(C),p!=C&&(n=C.defaultView)&&n.top!==n&&(n.addEventListener?n.addEventListener("unload",oe,!1):n.attachEvent&&n.attachEvent("onunload",oe)),d.scope=ce(function(e){return a.appendChild(e).appendChild(C.createElement("div")),"undefined"!=typeof e.querySelectorAll&&!e.querySelectorAll(":scope fieldset div").length}),d.attributes=ce(function(e){return e.className="i",!e.getAttribute("className")}),d.getElementsByTagName=ce(function(e){return e.appendChild(C.createComment("")),!e.getElementsByTagName("*").length}),d.getElementsByClassName=K.test(C.getElementsByClassName),d.getById=ce(function(e){return a.appendChild(e).id=S,!C.getElementsByName||!C.getElementsByName(S).length}),d.getById?(b.filter.ID=function(e){var t=e.replace(te,ne);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&E){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(te,ne);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&E){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=d.getElementsByTagName?function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):d.qsa?t.querySelectorAll(e):void 0}:function(e,t){var n,r=[],i=0,o=t.getElementsByTagName(e);if("*"===e){while(n=o[i++])1===n.nodeType&&r.push(n);return r}return o},b.find.CLASS=d.getElementsByClassName&&function(e,t){if("undefined"!=typeof t.getElementsByClassName&&E)return t.getElementsByClassName(e)},s=[],v=[],(d.qsa=K.test(C.querySelectorAll))&&(ce(function(e){var t;a.appendChild(e).innerHTML="<a id='"+S+"'></a><select id='"+S+"-\r\\' msallowcapture=''><option selected=''></option></select>",e.querySelectorAll("[msallowcapture^='']").length&&v.push("[*^$]="+M+"*(?:''|\"\")"),e.querySelectorAll("[selected]").length||v.push("\\["+M+"*(?:value|"+R+")"),e.querySelectorAll("[id~="+S+"-]").length||v.push("~="),(t=C.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||v.push("\\["+M+"*name"+M+"*="+M+"*(?:''|\"\")"),e.querySelectorAll(":checked").length||v.push(":checked"),e.querySelectorAll("a#"+S+"+*").length||v.push(".#.+[+~]"),e.querySelectorAll("\\\f"),v.push("[\\r\\n\\f]")}),ce(function(e){e.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var t=C.createElement("input");t.setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),e.querySelectorAll("[name=d]").length&&v.push("name"+M+"*[*^$|!~]?="),2!==e.querySelectorAll(":enabled").length&&v.push(":enabled",":disabled"),a.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&v.push(":enabled",":disabled"),e.querySelectorAll("*,:x"),v.push(",.*:")})),(d.matchesSelector=K.test(c=a.matches||a.webkitMatchesSelector||a.mozMatchesSelector||a.oMatchesSelector||a.msMatchesSelector))&&ce(function(e){d.disconnectedMatch=c.call(e,"*"),c.call(e,"[s!='']:x"),s.push("!=",F)}),v=v.length&&new RegExp(v.join("|")),s=s.length&&new RegExp(s.join("|")),t=K.test(a.compareDocumentPosition),y=t||K.test(a.contains)?function(e,t){var n=9===e.nodeType?e.documentElement:e,r=t&&t.parentNode;return e===r||!(!r||1!==r.nodeType||!(n.contains?n.contains(r):e.compareDocumentPosition&&16&e.compareDocumentPosition(r)))}:function(e,t){if(t)while(t=t.parentNode)if(t===e)return!0;return!1},j=t?function(e,t){if(e===t)return l=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!d.sortDetached&&t.compareDocumentPosition(e)===n?e==C||e.ownerDocument==p&&y(p,e)?-1:t==C||t.ownerDocument==p&&y(p,t)?1:u?P(u,e)-P(u,t):0:4&n?-1:1)}:function(e,t){if(e===t)return l=!0,0;var n,r=0,i=e.parentNode,o=t.parentNode,a=[e],s=[t];if(!i||!o)return e==C?-1:t==C?1:i?-1:o?1:u?P(u,e)-P(u,t):0;if(i===o)return pe(e,t);n=e;while(n=n.parentNode)a.unshift(n);n=t;while(n=n.parentNode)s.unshift(n);while(a[r]===s[r])r++;return r?pe(a[r],s[r]):a[r]==p?-1:s[r]==p?1:0}),C},se.matches=function(e,t){return se(e,null,null,t)},se.matchesSelector=function(e,t){if(T(e),d.matchesSelector&&E&&!N[t+" "]&&(!s||!s.test(t))&&(!v||!v.test(t)))try{var n=c.call(e,t);if(n||d.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){N(t,!0)}return 0<se(t,C,null,[e]).length},se.contains=function(e,t){return(e.ownerDocument||e)!=C&&T(e),y(e,t)},se.attr=function(e,t){(e.ownerDocument||e)!=C&&T(e);var n=b.attrHandle[t.toLowerCase()],r=n&&D.call(b.attrHandle,t.toLowerCase())?n(e,t,!E):void 0;return void 0!==r?r:d.attributes||!E?e.getAttribute(t):(r=e.getAttributeNode(t))&&r.specified?r.value:null},se.escape=function(e){return(e+"").replace(re,ie)},se.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},se.uniqueSort=function(e){var t,n=[],r=0,i=0;if(l=!d.detectDuplicates,u=!d.sortStable&&e.slice(0),e.sort(j),l){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)e.splice(n[r],1)}return u=null,e},o=se.getText=function(e){var t,n="",r=0,i=e.nodeType;if(i){if(1===i||9===i||11===i){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=o(e)}else if(3===i||4===i)return e.nodeValue}else while(t=e[r++])n+=o(t);return n},(b=se.selectors={cacheLength:50,createPseudo:le,match:G,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(te,ne),e[3]=(e[3]||e[4]||e[5]||"").replace(te,ne),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||se.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&se.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return G.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&X.test(n)&&(t=h(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(te,ne).toLowerCase();return"*"===e?function(){return!0}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=m[e+" "];return t||(t=new RegExp("(^|"+M+")"+e+"("+M+"|$)"))&&m(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=se.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace(B," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(h,e,t,g,v){var y="nth"!==h.slice(0,3),m="last"!==h.slice(-4),x="of-type"===e;return 1===g&&0===v?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u,l=y!==m?"nextSibling":"previousSibling",c=e.parentNode,f=x&&e.nodeName.toLowerCase(),p=!n&&!x,d=!1;if(c){if(y){while(l){a=e;while(a=a[l])if(x?a.nodeName.toLowerCase()===f:1===a.nodeType)return!1;u=l="only"===h&&!u&&"nextSibling"}return!0}if(u=[m?c.firstChild:c.lastChild],m&&p){d=(s=(r=(i=(o=(a=c)[S]||(a[S]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]||[])[0]===k&&r[1])&&r[2],a=s&&c.childNodes[s];while(a=++s&&a&&a[l]||(d=s=0)||u.pop())if(1===a.nodeType&&++d&&a===e){i[h]=[k,s,d];break}}else if(p&&(d=s=(r=(i=(o=(a=e)[S]||(a[S]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]||[])[0]===k&&r[1]),!1===d)while(a=++s&&a&&a[l]||(d=s=0)||u.pop())if((x?a.nodeName.toLowerCase()===f:1===a.nodeType)&&++d&&(p&&((i=(o=a[S]||(a[S]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]=[k,d]),a===e))break;return(d-=v)===g||d%g==0&&0<=d/g}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||se.error("unsupported pseudo: "+e);return a[S]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?le(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=P(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:le(function(e){var r=[],i=[],s=f(e.replace($,"$1"));return s[S]?le(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:le(function(t){return function(e){return 0<se(t,e).length}}),contains:le(function(t){return t=t.replace(te,ne),function(e){return-1<(e.textContent||o(e)).indexOf(t)}}),lang:le(function(n){return V.test(n||"")||se.error("unsupported lang: "+n),n=n.replace(te,ne).toLowerCase(),function(e){var t;do{if(t=E?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=n.location&&n.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===a},focus:function(e){return e===C.activeElement&&(!C.hasFocus||C.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:ge(!1),disabled:ge(!0),checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return J.test(e.nodeName)},input:function(e){return Q.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},text:function(e){var t;return"input"===e.nodeName.toLowerCase()&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:ve(function(){return[0]}),last:ve(function(e,t){return[t-1]}),eq:ve(function(e,t,n){return[n<0?n+t:n]}),even:ve(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:ve(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:ve(function(e,t,n){for(var r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:ve(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=de(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=he(e);function me(){}function xe(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function be(s,e,t){var u=e.dir,l=e.next,c=l||u,f=t&&"parentNode"===c,p=r++;return e.first?function(e,t,n){while(e=e[u])if(1===e.nodeType||f)return s(e,t,n);return!1}:function(e,t,n){var r,i,o,a=[k,p];if(n){while(e=e[u])if((1===e.nodeType||f)&&s(e,t,n))return!0}else while(e=e[u])if(1===e.nodeType||f)if(i=(o=e[S]||(e[S]={}))[e.uniqueID]||(o[e.uniqueID]={}),l&&l===e.nodeName.toLowerCase())e=e[u]||e;else{if((r=i[c])&&r[0]===k&&r[1]===p)return a[2]=r[2];if((i[c]=a)[2]=s(e,t,n))return!0}return!1}}function we(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Te(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function Ce(d,h,g,v,y,e){return v&&!v[S]&&(v=Ce(v)),y&&!y[S]&&(y=Ce(y,e)),le(function(e,t,n,r){var i,o,a,s=[],u=[],l=t.length,c=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)se(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),f=!d||!e&&h?c:Te(c,s,d,n,r),p=g?y||(e?d:l||v)?[]:t:f;if(g&&g(f,p,n,r),v){i=Te(p,u),v(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(p[u[o]]=!(f[u[o]]=a))}if(e){if(y||d){if(y){i=[],o=p.length;while(o--)(a=p[o])&&i.push(f[o]=a);y(null,p=[],i,r)}o=p.length;while(o--)(a=p[o])&&-1<(i=y?P(e,a):s[o])&&(e[i]=!(t[i]=a))}}else p=Te(p===t?p.splice(l,p.length):p),y?y(null,t,p,r):H.apply(t,p)})}function Ee(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=be(function(e){return e===i},a,!0),l=be(function(e){return-1<P(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!==w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[be(we(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[S]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return Ce(1<s&&we(c),1<s&&xe(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace($,"$1"),t,s<n&&Ee(e.slice(s,n)),n<r&&Ee(e=e.slice(n)),n<r&&xe(e))}c.push(t)}return we(c)}return me.prototype=b.filters=b.pseudos,b.setFilters=new me,h=se.tokenize=function(e,t){var n,r,i,o,a,s,u,l=x[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=_.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=z.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace($," ")}),a=a.slice(n.length)),b.filter)!(r=G[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?se.error(e):x(e,s).slice(0)},f=se.compile=function(e,t){var n,v,y,m,x,r,i=[],o=[],a=A[e+" "];if(!a){t||(t=h(e)),n=t.length;while(n--)(a=Ee(t[n]))[S]?i.push(a):o.push(a);(a=A(e,(v=o,m=0<(y=i).length,x=0<v.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=k+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t==C||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument==C||(T(o),n=!E);while(s=v[a++])if(s(o,t||C,n)){r.push(o);break}i&&(k=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=y[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=q.call(r));f=Te(f)}H.apply(r,f),i&&!e&&0<f.length&&1<u+y.length&&se.uniqueSort(r)}return i&&(k=h,w=p),c},m?le(r):r))).selector=e}return a},g=se.select=function(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&h(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&E&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(te,ne),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=G.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(te,ne),ee.test(o[0].type)&&ye(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&xe(o)))return H.apply(n,r),n;break}}}return(l||f(e,c))(r,t,!E,n,!t||ee.test(e)&&ye(t.parentNode)||t),n},d.sortStable=S.split("").sort(j).join("")===S,d.detectDuplicates=!!l,T(),d.sortDetached=ce(function(e){return 1&e.compareDocumentPosition(C.createElement("fieldset"))}),ce(function(e){return e.innerHTML="<a href='#'></a>","#"===e.firstChild.getAttribute("href")})||fe("type|href|height|width",function(e,t,n){if(!n)return e.getAttribute(t,"type"===t.toLowerCase()?1:2)}),d.attributes&&ce(function(e){return e.innerHTML="<input/>",e.firstChild.setAttribute("value",""),""===e.firstChild.getAttribute("value")})||fe("value",function(e,t,n){if(!n&&"input"===e.nodeName.toLowerCase())return e.defaultValue}),ce(function(e){return null==e.getAttribute("disabled")})||fe(R,function(e,t,n){var r;if(!n)return!0===e[t]?t.toLowerCase():(r=e.getAttributeNode(t))&&r.specified?r.value:null}),se}(C);S.find=d,S.expr=d.selectors,S.expr[":"]=S.expr.pseudos,S.uniqueSort=S.unique=d.uniqueSort,S.text=d.getText,S.isXMLDoc=d.isXML,S.contains=d.contains,S.escapeSelector=d.escape;var h=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&S(e).is(n))break;r.push(e)}return r},T=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},k=S.expr.match.needsContext;function A(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}var N=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function j(e,n,r){return m(n)?S.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?S.grep(e,function(e){return e===n!==r}):"string"!=typeof n?S.grep(e,function(e){return-1<i.call(n,e)!==r}):S.filter(n,e,r)}S.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?S.find.matchesSelector(r,e)?[r]:[]:S.find.matches(e,S.grep(t,function(e){return 1===e.nodeType}))},S.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(S(e).filter(function(){for(t=0;t<r;t++)if(S.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)S.find(e,i[t],n);return 1<r?S.uniqueSort(n):n},filter:function(e){return this.pushStack(j(this,e||[],!1))},not:function(e){return this.pushStack(j(this,e||[],!0))},is:function(e){return!!j(this,"string"==typeof e&&k.test(e)?S(e):e||[],!1).length}});var D,q=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(S.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||D,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:q.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof S?t[0]:t,S.merge(this,S.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:E,!0)),N.test(r[1])&&S.isPlainObject(t))for(r in t)m(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=E.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):m(e)?void 0!==n.ready?n.ready(e):e(S):S.makeArray(e,this)}).prototype=S.fn,D=S(E);var L=/^(?:parents|prev(?:Until|All))/,H={children:!0,contents:!0,next:!0,prev:!0};function O(e,t){while((e=e[t])&&1!==e.nodeType);return e}S.fn.extend({has:function(e){var t=S(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(S.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&S(e);if(!k.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&S.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?S.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?i.call(S(e),this[0]):i.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(S.uniqueSort(S.merge(this.get(),S(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),S.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return h(e,"parentNode")},parentsUntil:function(e,t,n){return h(e,"parentNode",n)},next:function(e){return O(e,"nextSibling")},prev:function(e){return O(e,"previousSibling")},nextAll:function(e){return h(e,"nextSibling")},prevAll:function(e){return h(e,"previousSibling")},nextUntil:function(e,t,n){return h(e,"nextSibling",n)},prevUntil:function(e,t,n){return h(e,"previousSibling",n)},siblings:function(e){return T((e.parentNode||{}).firstChild,e)},children:function(e){return T(e.firstChild)},contents:function(e){return null!=e.contentDocument&&r(e.contentDocument)?e.contentDocument:(A(e,"template")&&(e=e.content||e),S.merge([],e.childNodes))}},function(r,i){S.fn[r]=function(e,t){var n=S.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=S.filter(t,n)),1<this.length&&(H[r]||S.uniqueSort(n),L.test(r)&&n.reverse()),this.pushStack(n)}});var P=/[^\x20\t\r\n\f]+/g;function R(e){return e}function M(e){throw e}function I(e,t,n,r){var i;try{e&&m(i=e.promise)?i.call(e).done(t).fail(n):e&&m(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}S.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},S.each(e.match(P)||[],function(e,t){n[t]=!0}),n):S.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){S.each(e,function(e,t){m(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==w(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return S.each(arguments,function(e,t){var n;while(-1<(n=S.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<S.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},S.extend({Deferred:function(e){var o=[["notify","progress",S.Callbacks("memory"),S.Callbacks("memory"),2],["resolve","done",S.Callbacks("once memory"),S.Callbacks("once memory"),0,"resolved"],["reject","fail",S.Callbacks("once memory"),S.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return S.Deferred(function(r){S.each(o,function(e,t){var n=m(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&m(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,m(t)?s?t.call(e,l(u,o,R,s),l(u,o,M,s)):(u++,t.call(e,l(u,o,R,s),l(u,o,M,s),l(u,o,R,o.notifyWith))):(a!==R&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){S.Deferred.exceptionHook&&S.Deferred.exceptionHook(e,t.stackTrace),u<=i+1&&(a!==M&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(S.Deferred.getStackHook&&(t.stackTrace=S.Deferred.getStackHook()),C.setTimeout(t))}}return S.Deferred(function(e){o[0][3].add(l(0,e,m(r)?r:R,e.notifyWith)),o[1][3].add(l(0,e,m(t)?t:R)),o[2][3].add(l(0,e,m(n)?n:M))}).promise()},promise:function(e){return null!=e?S.extend(e,a):a}},s={};return S.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=s.call(arguments),o=S.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?s.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(I(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||m(i[t]&&i[t].then)))return o.then();while(t--)I(i[t],a(t),o.reject);return o.promise()}});var W=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;S.Deferred.exceptionHook=function(e,t){C.console&&C.console.warn&&e&&W.test(e.name)&&C.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},S.readyException=function(e){C.setTimeout(function(){throw e})};var F=S.Deferred();function B(){E.removeEventListener("DOMContentLoaded",B),C.removeEventListener("load",B),S.ready()}S.fn.ready=function(e){return F.then(e)["catch"](function(e){S.readyException(e)}),this},S.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--S.readyWait:S.isReady)||(S.isReady=!0)!==e&&0<--S.readyWait||F.resolveWith(E,[S])}}),S.ready.then=F.then,"complete"===E.readyState||"loading"!==E.readyState&&!E.documentElement.doScroll?C.setTimeout(S.ready):(E.addEventListener("DOMContentLoaded",B),C.addEventListener("load",B));var $=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===w(n))for(s in i=!0,n)$(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,m(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(S(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},_=/^-ms-/,z=/-([a-z])/g;function U(e,t){return t.toUpperCase()}function X(e){return e.replace(_,"ms-").replace(z,U)}var V=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function G(){this.expando=S.expando+G.uid++}G.uid=1,G.prototype={cache:function(e){var t=e[this.expando];return t||(t={},V(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[X(t)]=n;else for(r in t)i[X(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][X(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(X):(t=X(t))in r?[t]:t.match(P)||[]).length;while(n--)delete r[t[n]]}(void 0===t||S.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!S.isEmptyObject(t)}};var Y=new G,Q=new G,J=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,K=/[A-Z]/g;function Z(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(K,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:J.test(i)?JSON.parse(i):i)}catch(e){}Q.set(e,t,n)}else n=void 0;return n}S.extend({hasData:function(e){return Q.hasData(e)||Y.hasData(e)},data:function(e,t,n){return Q.access(e,t,n)},removeData:function(e,t){Q.remove(e,t)},_data:function(e,t,n){return Y.access(e,t,n)},_removeData:function(e,t){Y.remove(e,t)}}),S.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=Q.get(o),1===o.nodeType&&!Y.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=X(r.slice(5)),Z(o,r,i[r]));Y.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){Q.set(this,n)}):$(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=Q.get(o,n))?t:void 0!==(t=Z(o,n))?t:void 0;this.each(function(){Q.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){Q.remove(this,e)})}}),S.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=Y.get(e,t),n&&(!r||Array.isArray(n)?r=Y.access(e,t,S.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=S.queue(e,t),r=n.length,i=n.shift(),o=S._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){S.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return Y.get(e,n)||Y.access(e,n,{empty:S.Callbacks("once memory").add(function(){Y.remove(e,[t+"queue",n])})})}}),S.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?S.queue(this[0],t):void 0===n?this:this.each(function(){var e=S.queue(this,t,n);S._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&S.dequeue(this,t)})},dequeue:function(e){return this.each(function(){S.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=S.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=Y.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var ee=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,te=new RegExp("^(?:([+-])=|)("+ee+")([a-z%]*)$","i"),ne=["Top","Right","Bottom","Left"],re=E.documentElement,ie=function(e){return S.contains(e.ownerDocument,e)},oe={composed:!0};re.getRootNode&&(ie=function(e){return S.contains(e.ownerDocument,e)||e.getRootNode(oe)===e.ownerDocument});var ae=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&ie(e)&&"none"===S.css(e,"display")};function se(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return S.css(e,t,"")},u=s(),l=n&&n[3]||(S.cssNumber[t]?"":"px"),c=e.nodeType&&(S.cssNumber[t]||"px"!==l&&+u)&&te.exec(S.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)S.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,S.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ue={};function le(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=Y.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&ae(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ue[s])||(o=a.body.appendChild(a.createElement(s)),u=S.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ue[s]=u)))):"none"!==n&&(l[c]="none",Y.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}S.fn.extend({show:function(){return le(this,!0)},hide:function(){return le(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ae(this)?S(this).show():S(this).hide()})}});var ce,fe,pe=/^(?:checkbox|radio)$/i,de=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,he=/^$|^module$|\/(?:java|ecma)script/i;ce=E.createDocumentFragment().appendChild(E.createElement("div")),(fe=E.createElement("input")).setAttribute("type","radio"),fe.setAttribute("checked","checked"),fe.setAttribute("name","t"),ce.appendChild(fe),y.checkClone=ce.cloneNode(!0).cloneNode(!0).lastChild.checked,ce.innerHTML="<textarea>x</textarea>",y.noCloneChecked=!!ce.cloneNode(!0).lastChild.defaultValue,ce.innerHTML="<option></option>",y.option=!!ce.lastChild;var ge={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function ve(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&A(e,t)?S.merge([e],n):n}function ye(e,t){for(var n=0,r=e.length;n<r;n++)Y.set(e[n],"globalEval",!t||Y.get(t[n],"globalEval"))}ge.tbody=ge.tfoot=ge.colgroup=ge.caption=ge.thead,ge.th=ge.td,y.option||(ge.optgroup=ge.option=[1,"<select multiple='multiple'>","</select>"]);var me=/<|&#?\w+;/;function xe(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===w(o))S.merge(p,o.nodeType?[o]:o);else if(me.test(o)){a=a||f.appendChild(t.createElement("div")),s=(de.exec(o)||["",""])[1].toLowerCase(),u=ge[s]||ge._default,a.innerHTML=u[1]+S.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;S.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<S.inArray(o,r))i&&i.push(o);else if(l=ie(o),a=ve(f.appendChild(o),"script"),l&&ye(a),n){c=0;while(o=a[c++])he.test(o.type||"")&&n.push(o)}return f}var be=/^([^.]*)(?:\.(.+)|)/;function we(){return!0}function Te(){return!1}function Ce(e,t){return e===function(){try{return E.activeElement}catch(e){}}()==("focus"===t)}function Ee(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Ee(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=Te;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return S().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=S.guid++)),e.each(function(){S.event.add(this,t,i,r,n)})}function Se(e,i,o){o?(Y.set(e,i,!1),S.event.add(e,i,{namespace:!1,handler:function(e){var t,n,r=Y.get(this,i);if(1&e.isTrigger&&this[i]){if(r.length)(S.event.special[i]||{}).delegateType&&e.stopPropagation();else if(r=s.call(arguments),Y.set(this,i,r),t=o(this,i),this[i](),r!==(n=Y.get(this,i))||t?Y.set(this,i,!1):n={},r!==n)return e.stopImmediatePropagation(),e.preventDefault(),n&&n.value}else r.length&&(Y.set(this,i,{value:S.event.trigger(S.extend(r[0],S.Event.prototype),r.slice(1),this)}),e.stopImmediatePropagation())}})):void 0===Y.get(e,i)&&S.event.add(e,i,we)}S.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=Y.get(t);if(V(t)){n.handler&&(n=(o=n).handler,i=o.selector),i&&S.find.matchesSelector(re,i),n.guid||(n.guid=S.guid++),(u=v.events)||(u=v.events=Object.create(null)),(a=v.handle)||(a=v.handle=function(e){return"undefined"!=typeof S&&S.event.triggered!==e.type?S.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(P)||[""]).length;while(l--)d=g=(s=be.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=S.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=S.event.special[d]||{},c=S.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&S.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),S.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=Y.hasData(e)&&Y.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(P)||[""]).length;while(l--)if(d=g=(s=be.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=S.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||S.removeEvent(e,d,v.handle),delete u[d])}else for(d in u)S.event.remove(e,d+t[l],n,r,!0);S.isEmptyObject(u)&&Y.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=new Array(arguments.length),u=S.event.fix(e),l=(Y.get(this,"events")||Object.create(null))[u.type]||[],c=S.event.special[u.type]||{};for(s[0]=u,t=1;t<arguments.length;t++)s[t]=arguments[t];if(u.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,u)){a=S.event.handlers.call(this,u,l),t=0;while((i=a[t++])&&!u.isPropagationStopped()){u.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!u.isImmediatePropagationStopped())u.rnamespace&&!1!==o.namespace&&!u.rnamespace.test(o.namespace)||(u.handleObj=o,u.data=o.data,void 0!==(r=((S.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,s))&&!1===(u.result=r)&&(u.preventDefault(),u.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,u),u.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<S(i,this).index(l):S.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(S.Event.prototype,t,{enumerable:!0,configurable:!0,get:m(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[S.expando]?e:new S.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return pe.test(t.type)&&t.click&&A(t,"input")&&Se(t,"click",we),!1},trigger:function(e){var t=this||e;return pe.test(t.type)&&t.click&&A(t,"input")&&Se(t,"click"),!0},_default:function(e){var t=e.target;return pe.test(t.type)&&t.click&&A(t,"input")&&Y.get(t,"click")||A(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},S.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},S.Event=function(e,t){if(!(this instanceof S.Event))return new S.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?we:Te,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&S.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[S.expando]=!0},S.Event.prototype={constructor:S.Event,isDefaultPrevented:Te,isPropagationStopped:Te,isImmediatePropagationStopped:Te,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=we,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=we,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=we,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},S.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},S.event.addProp),S.each({focus:"focusin",blur:"focusout"},function(e,t){S.event.special[e]={setup:function(){return Se(this,e,Ce),!1},trigger:function(){return Se(this,e),!0},_default:function(){return!0},delegateType:t}}),S.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){S.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||S.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),S.fn.extend({on:function(e,t,n,r){return Ee(this,e,t,n,r)},one:function(e,t,n,r){return Ee(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,S(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=Te),this.each(function(){S.event.remove(this,e,n,t)})}});var ke=/<script|<style|<link/i,Ae=/checked\s*(?:[^=]|=\s*.checked.)/i,Ne=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function je(e,t){return A(e,"table")&&A(11!==t.nodeType?t:t.firstChild,"tr")&&S(e).children("tbody")[0]||e}function De(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function qe(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Le(e,t){var n,r,i,o,a,s;if(1===t.nodeType){if(Y.hasData(e)&&(s=Y.get(e).events))for(i in Y.remove(t,"handle events"),s)for(n=0,r=s[i].length;n<r;n++)S.event.add(t,i,s[i][n]);Q.hasData(e)&&(o=Q.access(e),a=S.extend({},o),Q.set(t,a))}}function He(n,r,i,o){r=g(r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=m(d);if(h||1<f&&"string"==typeof d&&!y.checkClone&&Ae.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),He(t,r,i,o)});if(f&&(t=(e=xe(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=S.map(ve(e,"script"),De)).length;c<f;c++)u=e,c!==p&&(u=S.clone(u,!0,!0),s&&S.merge(a,ve(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,S.map(a,qe),c=0;c<s;c++)u=a[c],he.test(u.type||"")&&!Y.access(u,"globalEval")&&S.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?S._evalUrl&&!u.noModule&&S._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},l):b(u.textContent.replace(Ne,""),u,l))}return n}function Oe(e,t,n){for(var r,i=t?S.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||S.cleanData(ve(r)),r.parentNode&&(n&&ie(r)&&ye(ve(r,"script")),r.parentNode.removeChild(r));return e}S.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=ie(e);if(!(y.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||S.isXMLDoc(e)))for(a=ve(c),r=0,i=(o=ve(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&pe.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||ve(e),a=a||ve(c),r=0,i=o.length;r<i;r++)Le(o[r],a[r]);else Le(e,c);return 0<(a=ve(c,"script")).length&&ye(a,!f&&ve(e,"script")),c},cleanData:function(e){for(var t,n,r,i=S.event.special,o=0;void 0!==(n=e[o]);o++)if(V(n)){if(t=n[Y.expando]){if(t.events)for(r in t.events)i[r]?S.event.remove(n,r):S.removeEvent(n,r,t.handle);n[Y.expando]=void 0}n[Q.expando]&&(n[Q.expando]=void 0)}}}),S.fn.extend({detach:function(e){return Oe(this,e,!0)},remove:function(e){return Oe(this,e)},text:function(e){return $(this,function(e){return void 0===e?S.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return He(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||je(this,e).appendChild(e)})},prepend:function(){return He(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=je(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return He(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return He(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(S.cleanData(ve(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return S.clone(this,e,t)})},html:function(e){return $(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!ke.test(e)&&!ge[(de.exec(e)||["",""])[1].toLowerCase()]){e=S.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(S.cleanData(ve(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return He(this,arguments,function(e){var t=this.parentNode;S.inArray(this,n)<0&&(S.cleanData(ve(this)),t&&t.replaceChild(e,this))},n)}}),S.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){S.fn[e]=function(e){for(var t,n=[],r=S(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),S(r[o])[a](t),u.apply(n,t.get());return this.pushStack(n)}});var Pe=new RegExp("^("+ee+")(?!px)[a-z%]+$","i"),Re=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=C),t.getComputedStyle(e)},Me=function(e,t,n){var r,i,o={};for(i in t)o[i]=e.style[i],e.style[i]=t[i];for(i in r=n.call(e),t)e.style[i]=o[i];return r},Ie=new RegExp(ne.join("|"),"i");function We(e,t,n){var r,i,o,a,s=e.style;return(n=n||Re(e))&&(""!==(a=n.getPropertyValue(t)||n[t])||ie(e)||(a=S.style(e,t)),!y.pixelBoxStyles()&&Pe.test(a)&&Ie.test(t)&&(r=s.width,i=s.minWidth,o=s.maxWidth,s.minWidth=s.maxWidth=s.width=a,a=n.width,s.width=r,s.minWidth=i,s.maxWidth=o)),void 0!==a?a+"":a}function Fe(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){u.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",re.appendChild(u).appendChild(l);var e=C.getComputedStyle(l);n="1%"!==e.top,s=12===t(e.marginLeft),l.style.right="60%",o=36===t(e.right),r=36===t(e.width),l.style.position="absolute",i=12===t(l.offsetWidth/3),re.removeChild(u),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s,u=E.createElement("div"),l=E.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",y.clearCloneStyle="content-box"===l.style.backgroundClip,S.extend(y,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),s},scrollboxSize:function(){return e(),i},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=E.createElement("table"),t=E.createElement("tr"),n=E.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",re.appendChild(e).appendChild(t).appendChild(n),r=C.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,re.removeChild(e)),a}}))}();var Be=["Webkit","Moz","ms"],$e=E.createElement("div").style,_e={};function ze(e){var t=S.cssProps[e]||_e[e];return t||(e in $e?e:_e[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=Be.length;while(n--)if((e=Be[n]+t)in $e)return e}(e)||e)}var Ue=/^(none|table(?!-c[ea]).+)/,Xe=/^--/,Ve={position:"absolute",visibility:"hidden",display:"block"},Ge={letterSpacing:"0",fontWeight:"400"};function Ye(e,t,n){var r=te.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function Qe(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(u+=S.css(e,n+ne[a],!0,i)),r?("content"===n&&(u-=S.css(e,"padding"+ne[a],!0,i)),"margin"!==n&&(u-=S.css(e,"border"+ne[a]+"Width",!0,i))):(u+=S.css(e,"padding"+ne[a],!0,i),"padding"!==n?u+=S.css(e,"border"+ne[a]+"Width",!0,i):s+=S.css(e,"border"+ne[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u}function Je(e,t,n){var r=Re(e),i=(!y.boxSizingReliable()||n)&&"border-box"===S.css(e,"boxSizing",!1,r),o=i,a=We(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(Pe.test(a)){if(!n)return a;a="auto"}return(!y.boxSizingReliable()&&i||!y.reliableTrDimensions()&&A(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===S.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===S.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+Qe(e,t,n||(i?"border":"content"),o,r,a)+"px"}function Ke(e,t,n,r,i){return new Ke.prototype.init(e,t,n,r,i)}S.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=We(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=X(t),u=Xe.test(t),l=e.style;if(u||(t=ze(s)),a=S.cssHooks[t]||S.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=te.exec(n))&&i[1]&&(n=se(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(S.cssNumber[s]?"":"px")),y.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=X(t);return Xe.test(t)||(t=ze(s)),(a=S.cssHooks[t]||S.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=We(e,t,r)),"normal"===i&&t in Ge&&(i=Ge[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),S.each(["height","width"],function(e,u){S.cssHooks[u]={get:function(e,t,n){if(t)return!Ue.test(S.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?Je(e,u,n):Me(e,Ve,function(){return Je(e,u,n)})},set:function(e,t,n){var r,i=Re(e),o=!y.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===S.css(e,"boxSizing",!1,i),s=n?Qe(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-Qe(e,u,"border",!1,i)-.5)),s&&(r=te.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=S.css(e,u)),Ye(0,t,s)}}}),S.cssHooks.marginLeft=Fe(y.reliableMarginLeft,function(e,t){if(t)return(parseFloat(We(e,"marginLeft"))||e.getBoundingClientRect().left-Me(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),S.each({margin:"",padding:"",border:"Width"},function(i,o){S.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+ne[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(S.cssHooks[i+o].set=Ye)}),S.fn.extend({css:function(e,t){return $(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Re(e),i=t.length;a<i;a++)o[t[a]]=S.css(e,t[a],!1,r);return o}return void 0!==n?S.style(e,t,n):S.css(e,t)},e,t,1<arguments.length)}}),((S.Tween=Ke).prototype={constructor:Ke,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||S.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(S.cssNumber[n]?"":"px")},cur:function(){var e=Ke.propHooks[this.prop];return e&&e.get?e.get(this):Ke.propHooks._default.get(this)},run:function(e){var t,n=Ke.propHooks[this.prop];return this.options.duration?this.pos=t=S.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):Ke.propHooks._default.set(this),this}}).init.prototype=Ke.prototype,(Ke.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=S.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){S.fx.step[e.prop]?S.fx.step[e.prop](e):1!==e.elem.nodeType||!S.cssHooks[e.prop]&&null==e.elem.style[ze(e.prop)]?e.elem[e.prop]=e.now:S.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=Ke.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},S.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},S.fx=Ke.prototype.init,S.fx.step={};var Ze,et,tt,nt,rt=/^(?:toggle|show|hide)$/,it=/queueHooks$/;function ot(){et&&(!1===E.hidden&&C.requestAnimationFrame?C.requestAnimationFrame(ot):C.setTimeout(ot,S.fx.interval),S.fx.tick())}function at(){return C.setTimeout(function(){Ze=void 0}),Ze=Date.now()}function st(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=ne[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function ut(e,t,n){for(var r,i=(lt.tweeners[t]||[]).concat(lt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function lt(o,e,t){var n,a,r=0,i=lt.prefilters.length,s=S.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=Ze||at(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:S.extend({},e),opts:S.extend(!0,{specialEasing:{},easing:S.easing._default},t),originalProperties:e,originalOptions:t,startTime:Ze||at(),duration:t.duration,tweens:[],createTween:function(e,t){var n=S.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=X(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=S.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=lt.prefilters[r].call(l,o,c,l.opts))return m(n.stop)&&(S._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return S.map(c,ut,l),m(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),S.fx.timer(S.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}S.Animation=S.extend(lt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return se(n.elem,e,te.exec(t),n),n}]},tweener:function(e,t){m(e)?(t=e,e=["*"]):e=e.match(P);for(var n,r=0,i=e.length;r<i;r++)n=e[r],lt.tweeners[n]=lt.tweeners[n]||[],lt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ae(e),v=Y.get(e,"fxshow");for(r in n.queue||(null==(a=S._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,S.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],rt.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!v||void 0===v[r])continue;g=!0}d[r]=v&&v[r]||S.style(e,r)}if((u=!S.isEmptyObject(t))||!S.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=Y.get(e,"display")),"none"===(c=S.css(e,"display"))&&(l?c=l:(le([e],!0),l=e.style.display||l,c=S.css(e,"display"),le([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===S.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=Y.access(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&le([e],!0),p.done(function(){for(r in g||le([e]),Y.remove(e,"fxshow"),d)S.style(e,r,d[r])})),u=ut(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?lt.prefilters.unshift(e):lt.prefilters.push(e)}}),S.speed=function(e,t,n){var r=e&&"object"==typeof e?S.extend({},e):{complete:n||!n&&t||m(e)&&e,duration:e,easing:n&&t||t&&!m(t)&&t};return S.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in S.fx.speeds?r.duration=S.fx.speeds[r.duration]:r.duration=S.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){m(r.old)&&r.old.call(this),r.queue&&S.dequeue(this,r.queue)},r},S.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ae).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=S.isEmptyObject(t),o=S.speed(e,n,r),a=function(){var e=lt(this,S.extend({},t),o);(i||Y.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=S.timers,r=Y.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&it.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||S.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=Y.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=S.timers,o=n?n.length:0;for(t.finish=!0,S.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),S.each(["toggle","show","hide"],function(e,r){var i=S.fn[r];S.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(st(r,!0),e,t,n)}}),S.each({slideDown:st("show"),slideUp:st("hide"),slideToggle:st("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){S.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),S.timers=[],S.fx.tick=function(){var e,t=0,n=S.timers;for(Ze=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||S.fx.stop(),Ze=void 0},S.fx.timer=function(e){S.timers.push(e),S.fx.start()},S.fx.interval=13,S.fx.start=function(){et||(et=!0,ot())},S.fx.stop=function(){et=null},S.fx.speeds={slow:600,fast:200,_default:400},S.fn.delay=function(r,e){return r=S.fx&&S.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=C.setTimeout(e,r);t.stop=function(){C.clearTimeout(n)}})},tt=E.createElement("input"),nt=E.createElement("select").appendChild(E.createElement("option")),tt.type="checkbox",y.checkOn=""!==tt.value,y.optSelected=nt.selected,(tt=E.createElement("input")).value="t",tt.type="radio",y.radioValue="t"===tt.value;var ct,ft=S.expr.attrHandle;S.fn.extend({attr:function(e,t){return $(this,S.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){S.removeAttr(this,e)})}}),S.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?S.prop(e,t,n):(1===o&&S.isXMLDoc(e)||(i=S.attrHooks[t.toLowerCase()]||(S.expr.match.bool.test(t)?ct:void 0)),void 0!==n?null===n?void S.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=S.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!y.radioValue&&"radio"===t&&A(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(P);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),ct={set:function(e,t,n){return!1===t?S.removeAttr(e,n):e.setAttribute(n,n),n}},S.each(S.expr.match.bool.source.match(/\w+/g),function(e,t){var a=ft[t]||S.find.attr;ft[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=ft[o],ft[o]=r,r=null!=a(e,t,n)?o:null,ft[o]=i),r}});var pt=/^(?:input|select|textarea|button)$/i,dt=/^(?:a|area)$/i;function ht(e){return(e.match(P)||[]).join(" ")}function gt(e){return e.getAttribute&&e.getAttribute("class")||""}function vt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(P)||[]}S.fn.extend({prop:function(e,t){return $(this,S.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[S.propFix[e]||e]})}}),S.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&S.isXMLDoc(e)||(t=S.propFix[t]||t,i=S.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=S.find.attr(e,"tabindex");return t?parseInt(t,10):pt.test(e.nodeName)||dt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),y.optSelected||(S.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),S.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){S.propFix[this.toLowerCase()]=this}),S.fn.extend({addClass:function(t){var e,n,r,i,o,a,s,u=0;if(m(t))return this.each(function(e){S(this).addClass(t.call(this,e,gt(this)))});if((e=vt(t)).length)while(n=this[u++])if(i=gt(n),r=1===n.nodeType&&" "+ht(i)+" "){a=0;while(o=e[a++])r.indexOf(" "+o+" ")<0&&(r+=o+" ");i!==(s=ht(r))&&n.setAttribute("class",s)}return this},removeClass:function(t){var e,n,r,i,o,a,s,u=0;if(m(t))return this.each(function(e){S(this).removeClass(t.call(this,e,gt(this)))});if(!arguments.length)return this.attr("class","");if((e=vt(t)).length)while(n=this[u++])if(i=gt(n),r=1===n.nodeType&&" "+ht(i)+" "){a=0;while(o=e[a++])while(-1<r.indexOf(" "+o+" "))r=r.replace(" "+o+" "," ");i!==(s=ht(r))&&n.setAttribute("class",s)}return this},toggleClass:function(i,t){var o=typeof i,a="string"===o||Array.isArray(i);return"boolean"==typeof t&&a?t?this.addClass(i):this.removeClass(i):m(i)?this.each(function(e){S(this).toggleClass(i.call(this,e,gt(this),t),t)}):this.each(function(){var e,t,n,r;if(a){t=0,n=S(this),r=vt(i);while(e=r[t++])n.hasClass(e)?n.removeClass(e):n.addClass(e)}else void 0!==i&&"boolean"!==o||((e=gt(this))&&Y.set(this,"__className__",e),this.setAttribute&&this.setAttribute("class",e||!1===i?"":Y.get(this,"__className__")||""))})},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+ht(gt(n))+" ").indexOf(t))return!0;return!1}});var yt=/\r/g;S.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=m(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,S(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=S.map(t,function(e){return null==e?"":e+""})),(r=S.valHooks[this.type]||S.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=S.valHooks[t.type]||S.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(yt,""):null==e?"":e:void 0}}),S.extend({valHooks:{option:{get:function(e){var t=S.find.attr(e,"value");return null!=t?t:ht(S.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!A(n.parentNode,"optgroup"))){if(t=S(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=S.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<S.inArray(S.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),S.each(["radio","checkbox"],function(){S.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<S.inArray(S(e).val(),t)}},y.checkOn||(S.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})}),y.focusin="onfocusin"in C;var mt=/^(?:focusinfocus|focusoutblur)$/,xt=function(e){e.stopPropagation()};S.extend(S.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||E],d=v.call(e,"type")?e.type:e,h=v.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||E,3!==n.nodeType&&8!==n.nodeType&&!mt.test(d+S.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[S.expando]?e:new S.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:S.makeArray(t,[e]),c=S.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!x(n)){for(s=c.delegateType||d,mt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||E)&&p.push(a.defaultView||a.parentWindow||C)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(Y.get(o,"events")||Object.create(null))[e.type]&&Y.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&V(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!V(n)||u&&m(n[d])&&!x(n)&&((a=n[u])&&(n[u]=null),S.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,xt),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,xt),S.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=S.extend(new S.Event,n,{type:e,isSimulated:!0});S.event.trigger(r,null,t)}}),S.fn.extend({trigger:function(e,t){return this.each(function(){S.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return S.event.trigger(e,t,n,!0)}}),y.focusin||S.each({focus:"focusin",blur:"focusout"},function(n,r){var i=function(e){S.event.simulate(r,e.target,S.event.fix(e))};S.event.special[r]={setup:function(){var e=this.ownerDocument||this.document||this,t=Y.access(e,r);t||e.addEventListener(n,i,!0),Y.access(e,r,(t||0)+1)},teardown:function(){var e=this.ownerDocument||this.document||this,t=Y.access(e,r)-1;t?Y.access(e,r,t):(e.removeEventListener(n,i,!0),Y.remove(e,r))}}});var bt=C.location,wt={guid:Date.now()},Tt=/\?/;S.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new C.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||S.error("Invalid XML: "+(n?S.map(n.childNodes,function(e){return e.textContent}).join("\n"):e)),t};var Ct=/\[\]$/,Et=/\r?\n/g,St=/^(?:submit|button|image|reset|file)$/i,kt=/^(?:input|select|textarea|keygen)/i;function At(n,e,r,i){var t;if(Array.isArray(e))S.each(e,function(e,t){r||Ct.test(n)?i(n,t):At(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==w(e))i(n,e);else for(t in e)At(n+"["+t+"]",e[t],r,i)}S.param=function(e,t){var n,r=[],i=function(e,t){var n=m(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!S.isPlainObject(e))S.each(e,function(){i(this.name,this.value)});else for(n in e)At(n,e[n],t,i);return r.join("&")},S.fn.extend({serialize:function(){return S.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=S.prop(this,"elements");return e?S.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!S(this).is(":disabled")&&kt.test(this.nodeName)&&!St.test(e)&&(this.checked||!pe.test(e))}).map(function(e,t){var n=S(this).val();return null==n?null:Array.isArray(n)?S.map(n,function(e){return{name:t.name,value:e.replace(Et,"\r\n")}}):{name:t.name,value:n.replace(Et,"\r\n")}}).get()}});var Nt=/%20/g,jt=/#.*$/,Dt=/([?&])_=[^&]*/,qt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Lt=/^(?:GET|HEAD)$/,Ht=/^\/\//,Ot={},Pt={},Rt="*/".concat("*"),Mt=E.createElement("a");function It(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(P)||[];if(m(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function Wt(t,i,o,a){var s={},u=t===Pt;function l(e){var r;return s[e]=!0,S.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function Ft(e,t){var n,r,i=S.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&S.extend(!0,e,r),e}Mt.href=bt.href,S.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:bt.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(bt.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Rt,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":S.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Ft(Ft(e,S.ajaxSettings),t):Ft(S.ajaxSettings,e)},ajaxPrefilter:It(Ot),ajaxTransport:It(Pt),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,v=S.ajaxSetup({},t),y=v.context||v,m=v.context&&(y.nodeType||y.jquery)?S(y):S.event,x=S.Deferred(),b=S.Callbacks("once memory"),w=v.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=qt.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(v.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),v.url=((e||v.url||bt.href)+"").replace(Ht,bt.protocol+"//"),v.type=t.method||t.type||v.method||v.type,v.dataTypes=(v.dataType||"*").toLowerCase().match(P)||[""],null==v.crossDomain){r=E.createElement("a");try{r.href=v.url,r.href=r.href,v.crossDomain=Mt.protocol+"//"+Mt.host!=r.protocol+"//"+r.host}catch(e){v.crossDomain=!0}}if(v.data&&v.processData&&"string"!=typeof v.data&&(v.data=S.param(v.data,v.traditional)),Wt(Ot,v,t,T),h)return T;for(i in(g=S.event&&v.global)&&0==S.active++&&S.event.trigger("ajaxStart"),v.type=v.type.toUpperCase(),v.hasContent=!Lt.test(v.type),f=v.url.replace(jt,""),v.hasContent?v.data&&v.processData&&0===(v.contentType||"").indexOf("application/x-www-form-urlencoded")&&(v.data=v.data.replace(Nt,"+")):(o=v.url.slice(f.length),v.data&&(v.processData||"string"==typeof v.data)&&(f+=(Tt.test(f)?"&":"?")+v.data,delete v.data),!1===v.cache&&(f=f.replace(Dt,"$1"),o=(Tt.test(f)?"&":"?")+"_="+wt.guid+++o),v.url=f+o),v.ifModified&&(S.lastModified[f]&&T.setRequestHeader("If-Modified-Since",S.lastModified[f]),S.etag[f]&&T.setRequestHeader("If-None-Match",S.etag[f])),(v.data&&v.hasContent&&!1!==v.contentType||t.contentType)&&T.setRequestHeader("Content-Type",v.contentType),T.setRequestHeader("Accept",v.dataTypes[0]&&v.accepts[v.dataTypes[0]]?v.accepts[v.dataTypes[0]]+("*"!==v.dataTypes[0]?", "+Rt+"; q=0.01":""):v.accepts["*"]),v.headers)T.setRequestHeader(i,v.headers[i]);if(v.beforeSend&&(!1===v.beforeSend.call(y,T,v)||h))return T.abort();if(u="abort",b.add(v.complete),T.done(v.success),T.fail(v.error),c=Wt(Pt,v,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,v]),h)return T;v.async&&0<v.timeout&&(d=C.setTimeout(function(){T.abort("timeout")},v.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&C.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(v,T,n)),!i&&-1<S.inArray("script",v.dataTypes)&&S.inArray("json",v.dataTypes)<0&&(v.converters["text script"]=function(){}),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(v,s,T,i),i?(v.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(S.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(S.etag[f]=u)),204===e||"HEAD"===v.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(y,[o,l,T]):x.rejectWith(y,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,v,i?o:a]),b.fireWith(y,[T,l]),g&&(m.trigger("ajaxComplete",[T,v]),--S.active||S.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return S.get(e,t,n,"json")},getScript:function(e,t){return S.get(e,void 0,t,"script")}}),S.each(["get","post"],function(e,i){S[i]=function(e,t,n,r){return m(t)&&(r=r||n,n=t,t=void 0),S.ajax(S.extend({url:e,type:i,dataType:r,data:t,success:n},S.isPlainObject(e)&&e))}}),S.ajaxPrefilter(function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),S._evalUrl=function(e,t,n){return S.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){S.globalEval(e,t,n)}})},S.fn.extend({wrapAll:function(e){var t;return this[0]&&(m(e)&&(e=e.call(this[0])),t=S(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return m(n)?this.each(function(e){S(this).wrapInner(n.call(this,e))}):this.each(function(){var e=S(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=m(t);return this.each(function(e){S(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){S(this).replaceWith(this.childNodes)}),this}}),S.expr.pseudos.hidden=function(e){return!S.expr.pseudos.visible(e)},S.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},S.ajaxSettings.xhr=function(){try{return new C.XMLHttpRequest}catch(e){}};var Bt={0:200,1223:204},$t=S.ajaxSettings.xhr();y.cors=!!$t&&"withCredentials"in $t,y.ajax=$t=!!$t,S.ajaxTransport(function(i){var o,a;if(y.cors||$t&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Bt[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&C.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),S.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),S.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return S.globalEval(e),e}}}),S.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),S.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=S("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),E.head.appendChild(r[0])},abort:function(){i&&i()}}});var _t,zt=[],Ut=/(=)\?(?=&|$)|\?\?/;S.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=zt.pop()||S.expando+"_"+wt.guid++;return this[e]=!0,e}}),S.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Ut.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Ut.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=m(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Ut,"$1"+r):!1!==e.jsonp&&(e.url+=(Tt.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||S.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=C[r],C[r]=function(){o=arguments},n.always(function(){void 0===i?S(C).removeProp(r):C[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,zt.push(r)),o&&m(i)&&i(o[0]),o=i=void 0}),"script"}),y.createHTMLDocument=((_t=E.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===_t.childNodes.length),S.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(y.createHTMLDocument?((r=(t=E.implementation.createHTMLDocument("")).createElement("base")).href=E.location.href,t.head.appendChild(r)):t=E),o=!n&&[],(i=N.exec(e))?[t.createElement(i[1])]:(i=xe([e],t,o),o&&o.length&&S(o).remove(),S.merge([],i.childNodes)));var r,i,o},S.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=ht(e.slice(s)),e=e.slice(0,s)),m(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&S.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?S("<div>").append(S.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},S.expr.pseudos.animated=function(t){return S.grep(S.timers,function(e){return t===e.elem}).length},S.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=S.css(e,"position"),c=S(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=S.css(e,"top"),u=S.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),m(t)&&(t=t.call(e,n,S.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},S.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){S.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===S.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===S.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=S(e).offset()).top+=S.css(e,"borderTopWidth",!0),i.left+=S.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-S.css(r,"marginTop",!0),left:t.left-i.left-S.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===S.css(e,"position"))e=e.offsetParent;return e||re})}}),S.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;S.fn[t]=function(e){return $(this,function(e,t,n){var r;if(x(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),S.each(["top","left"],function(e,n){S.cssHooks[n]=Fe(y.pixelPosition,function(e,t){if(t)return t=We(e,n),Pe.test(t)?S(e).position()[n]+"px":t})}),S.each({Height:"height",Width:"width"},function(a,s){S.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){S.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return $(this,function(e,t,n){var r;return x(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?S.css(e,t,i):S.style(e,t,n,i)},s,n?e:void 0,n)}})}),S.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){S.fn[t]=function(e){return this.on(t,e)}}),S.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)}}),S.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){S.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}});var Xt=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;S.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),m(e))return r=s.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(s.call(arguments)))}).guid=e.guid=e.guid||S.guid++,i},S.holdReady=function(e){e?S.readyWait++:S.ready(!0)},S.isArray=Array.isArray,S.parseJSON=JSON.parse,S.nodeName=A,S.isFunction=m,S.isWindow=x,S.camelCase=X,S.type=w,S.now=Date.now,S.isNumeric=function(e){var t=S.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},S.trim=function(e){return null==e?"":(e+"").replace(Xt,"")},"function"==typeof define&&define.amd&&define("jquery",[],function(){return S});var Vt=C.jQuery,Gt=C.$;return S.noConflict=function(e){return C.$===S&&(C.$=Gt),e&&C.jQuery===S&&(C.jQuery=Vt),S},"undefined"==typeof e&&(C.jQuery=C.$=S),S});
    
  
    !function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(d){"use strict";var s,l=window.Slick||{};s=0,(l=function(i,e){var t,o=this;o.defaults={adaptiveHeight:!1,appendArrows:d(i),appendDots:d(i),arrows:!0,arrowsPlacement:null,asNavFor:null,prevArrow:'<button class="slick-prev" type="button"><span class="slick-prev-icon" aria-hidden="true"></span><span class="slick-sr-only">Previous</span></button>',nextArrow:'<button class="slick-next" type="button"><span class="slick-next-icon" aria-hidden="true"></span><span class="slick-sr-only">Next</span></button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(i,e){return d('<button type="button"><span class="slick-dot-icon" aria-hidden="true"></span><span class="slick-sr-only">Go to slide '+(e+1)+"</span></button>")},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,infinite:!0,initialSlide:0,instructionsText:null,lazyLoad:"ondemand",mobileFirst:!1,playIcon:'<span class="slick-play-icon" aria-hidden="true"></span>',pauseIcon:'<span class="slick-pause-icon" aria-hidden="true"></span>',pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,regionLabel:"carousel",respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useAutoplayToggleButton:!0,useCSS:!0,useGroupRole:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},o.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,$instructionsText:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$pauseButton:null,$pauseIcon:null,$playIcon:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},d.extend(o,o.initials),o.activeBreakpoint=null,o.animType=null,o.animProp=null,o.breakpoints=[],o.breakpointSettings=[],o.cssTransitions=!1,o.focussed=!1,o.interrupted=!1,o.hidden="hidden",o.paused=!0,o.positionProp=null,o.respondTo=null,o.rowCount=1,o.shouldClick=!0,o.$slider=d(i),o.$slidesCache=null,o.transformType=null,o.transitionType=null,o.visibilityChange="visibilitychange",o.windowWidth=0,o.windowTimer=null,t=d(i).data("slick")||{},o.options=d.extend({},o.defaults,e,t),o.currentSlide=o.options.initialSlide,o.originalSettings=o.options,void 0!==document.mozHidden?(o.hidden="mozHidden",o.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(o.hidden="webkitHidden",o.visibilityChange="webkitvisibilitychange"),o.autoPlay=d.proxy(o.autoPlay,o),o.autoPlayClear=d.proxy(o.autoPlayClear,o),o.autoPlayIterator=d.proxy(o.autoPlayIterator,o),o.autoPlayToggleHandler=d.proxy(o.autoPlayToggleHandler,o),o.changeSlide=d.proxy(o.changeSlide,o),o.clickHandler=d.proxy(o.clickHandler,o),o.selectHandler=d.proxy(o.selectHandler,o),o.setPosition=d.proxy(o.setPosition,o),o.swipeHandler=d.proxy(o.swipeHandler,o),o.dragHandler=d.proxy(o.dragHandler,o),o.instanceUid=s++,o.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,o.registerBreakpoints(),o.init(!0)}).prototype.addSlide=l.prototype.slickAdd=function(i,e,t){var o=this;if("boolean"==typeof e)t=e,e=null;else if(e<0||e>=o.slideCount)return!1;o.unload(),"number"==typeof e?0===e&&0===o.$slides.length?d(i).appendTo(o.$slideTrack):t?d(i).insertBefore(o.$slides.eq(e)):d(i).insertAfter(o.$slides.eq(e)):!0===t?d(i).prependTo(o.$slideTrack):d(i).appendTo(o.$slideTrack),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slides.each(function(i,e){d(e).attr("data-slick-index",i),d(e).attr("role","group"),d(e).attr("aria-label","slide "+i)}),o.$slidesCache=o.$slides,o.reinit()},l.prototype.animateHeight=function(){var i,e=this;1===e.options.slidesToShow&&!0===e.options.adaptiveHeight&&!1===e.options.vertical&&(i=e.$slides.eq(e.currentSlide).outerHeight(!0),e.$list.animate({height:i},e.options.speed))},l.prototype.animateSlide=function(i,e){var t={},o=this;o.animateHeight(),!0===o.options.rtl&&!1===o.options.vertical&&(i=-i),!1===o.transformsEnabled?!1===o.options.vertical?o.$slideTrack.animate({left:i},o.options.speed,o.options.easing,e):o.$slideTrack.animate({top:i},o.options.speed,o.options.easing,e):!1===o.cssTransitions?(!0===o.options.rtl&&(o.currentLeft=-o.currentLeft),d({animStart:o.currentLeft}).animate({animStart:i},{duration:o.options.speed,easing:o.options.easing,step:function(i){i=Math.ceil(i),!1===o.options.vertical?t[o.animType]="translate("+i+"px, 0px)":t[o.animType]="translate(0px,"+i+"px)",o.$slideTrack.css(t)},complete:function(){e&&e.call()}})):(o.applyTransition(),i=Math.ceil(i),!1===o.options.vertical?t[o.animType]="translate3d("+i+"px, 0px, 0px)":t[o.animType]="translate3d(0px,"+i+"px, 0px)",o.$slideTrack.css(t),e&&setTimeout(function(){o.disableTransition(),e.call()},o.options.speed))},l.prototype.getNavTarget=function(){var i=this.options.asNavFor;return i&&null!==i&&(i=d(i).not(this.$slider)),i},l.prototype.asNavFor=function(e){var i=this.getNavTarget();null!==i&&"object"==typeof i&&i.each(function(){var i=d(this).slick("getSlick");i.unslicked||i.slideHandler(e,!0)})},l.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},l.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},l.prototype.autoPlayClear=function(){this.autoPlayTimer&&clearInterval(this.autoPlayTimer)},l.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},l.prototype.autoPlayToggleHandler=function(){var i=this;i.paused?(i.$playIcon.css("display","none"),i.$pauseIcon.css("display","inline"),i.$pauseButton.find(".slick-play-text").attr("style","display: none"),i.$pauseButton.find(".slick-pause-text").removeAttr("style"),i.slickPlay()):(i.$playIcon.css("display","inline"),i.$pauseIcon.css("display","none"),i.$pauseButton.find(".slick-play-text").removeAttr("style"),i.$pauseButton.find(".slick-pause-text").attr("style","display: none"),i.slickPause())},l.prototype.buildArrows=function(){var i=this;if(!0===i.options.arrows)if(i.$prevArrow=d(i.options.prevArrow).addClass("slick-arrow"),i.$nextArrow=d(i.options.nextArrow).addClass("slick-arrow"),i.slideCount>i.options.slidesToShow){if(i.htmlExpr.test(i.options.prevArrow))if(null!=i.options.arrowsPlacement)switch(i.options.arrowsPlacement){case"beforeSlides":case"split":console.log("test"),i.$prevArrow.prependTo(i.options.appendArrows);break;case"afterSlides":i.$prevArrow.appendTo(i.options.appendArrows)}else i.$prevArrow.prependTo(i.options.appendArrows);if(i.htmlExpr.test(i.options.nextArrow))if(null!=i.options.arrowsPlacement)switch(i.options.arrowsPlacement){case"beforeSlides":console.log("test2"),i.$prevArrow.after(i.$nextArrow);break;case"afterSlides":case"split":i.$nextArrow.appendTo(i.options.appendArrows)}else i.$nextArrow.appendTo(i.options.appendArrows);!0!==i.options.infinite&&i.$prevArrow.addClass("slick-disabled").prop("disabled",!0)}else i.$prevArrow.add(i.$nextArrow).addClass("slick-hidden").prop("disabled",!0)},l.prototype.buildDots=function(){var i,e,t=this;if(!0===t.options.dots&&t.slideCount>t.options.slidesToShow){for(t.$slider.addClass("slick-dotted"),e=d("<ul />").addClass(t.options.dotsClass),i=0;i<=t.getDotCount();i+=1)e.append(d("<li />").append(t.options.customPaging.call(this,t,i)));t.$dots=e.appendTo(t.options.appendDots),t.$dots.find("li").first().addClass("slick-active")}},l.prototype.buildOut=function(){var t=this;t.$slides=t.$slider.children(t.options.slide+":not(.slick-cloned)").addClass("slick-slide"),t.slideCount=t.$slides.length,t.$slides.each(function(i,e){d(e).attr("data-slick-index",i).data("originalStyling",d(e).attr("style")||""),t.options.useGroupRole&&d(e).attr("role","group").attr("aria-label","slide "+(i+1))}),t.$slider.addClass("slick-slider"),t.$slider.attr("role","region"),t.$slider.attr("aria-label",t.options.regionLabel),t.$slideTrack=0===t.slideCount?d('<div class="slick-track"/>').appendTo(t.$slider):t.$slides.wrapAll('<div class="slick-track"/>').parent(),t.$list=t.$slideTrack.wrap('<div class="slick-list"/>').parent(),t.$slideTrack.css("opacity",0),!0!==t.options.centerMode&&!0!==t.options.swipeToSlide||(t.options.slidesToScroll=1),d("img[data-lazy]",t.$slider).not("[src]").addClass("slick-loading"),t.setupInfinite(),t.buildArrows(),t.buildDots(),t.updateDots(),t.setSlideClasses("number"==typeof t.currentSlide?t.currentSlide:0),!0===t.options.draggable&&t.$list.addClass("draggable"),t.options.autoplay&&t.options.useAutoplayToggleButton&&(t.$pauseIcon=d(t.options.pauseIcon).attr("aria-hidden",!0),t.$playIcon=d(t.options.playIcon).attr("aria-hidden",!0),t.$pauseButton=d('<button type="button" aria-label="autoplay-toggle" class="slick-autoplay-toggle-button">'),t.$pauseButton.append(t.$pauseIcon),t.$pauseButton.append(t.$playIcon.css("display","none")),t.$pauseButton.append(d('<span class="slick-pause-text slick-sr-only">Pause</span>')),t.$pauseButton.append(d('<span class="slick-play-text slick-sr-only" style="display: none">Play</span>')),t.$pauseButton.prependTo(t.$slider)),null!=t.options.instructionsText&&""!=t.options.instructionsText&&(t.$instructionsText=d('<p class="slick-instructions slick-sr-only">'+t.options.instructionsText+"</p>"),t.$instructionsText.prependTo(t.$slider))},l.prototype.buildRows=function(){var i,e,t,o=this,s=document.createDocumentFragment(),n=o.$slider.children();if(0<o.options.rows){for(t=o.options.slidesPerRow*o.options.rows,e=Math.ceil(n.length/t),i=0;i<e;i++){for(var l=document.createElement("div"),r=0;r<o.options.rows;r++){for(var a=document.createElement("div"),d=0;d<o.options.slidesPerRow;d++){var p=i*t+(r*o.options.slidesPerRow+d);n.get(p)&&a.appendChild(n.get(p))}l.appendChild(a)}s.appendChild(l)}o.$slider.empty().append(s),o.$slider.children().children().children().css({width:100/o.options.slidesPerRow+"%",display:"inline-block"})}},l.prototype.checkResponsive=function(i,e){var t,o,s,n=this,l=!1,r=n.$slider.width(),a=window.innerWidth||d(window).width();if("window"===n.respondTo?s=a:"slider"===n.respondTo?s=r:"min"===n.respondTo&&(s=Math.min(a,r)),n.options.responsive&&n.options.responsive.length&&null!==n.options.responsive){for(t in o=null,n.breakpoints)n.breakpoints.hasOwnProperty(t)&&(!1===n.originalSettings.mobileFirst?s<n.breakpoints[t]&&(o=n.breakpoints[t]):s>n.breakpoints[t]&&(o=n.breakpoints[t]));null!==o?null!==n.activeBreakpoint&&o===n.activeBreakpoint&&!e||(n.activeBreakpoint=o,"unslick"===n.breakpointSettings[o]?n.unslick(o):(n.options=d.extend({},n.originalSettings,n.breakpointSettings[o]),!0===i&&(n.currentSlide=n.options.initialSlide),n.refresh(i)),l=o):null!==n.activeBreakpoint&&(n.activeBreakpoint=null,n.options=n.originalSettings,!0===i&&(n.currentSlide=n.options.initialSlide),n.refresh(i),l=o),i||!1===l||n.$slider.trigger("breakpoint",[n,l])}},l.prototype.changeSlide=function(i,e){var t,o,s=this,n=d(i.currentTarget);switch(n.is("a")&&i.preventDefault(),n.is("li")||(n=n.closest("li")),t=s.slideCount%s.options.slidesToScroll!=0?0:(s.slideCount-s.currentSlide)%s.options.slidesToScroll,i.data.message){case"previous":o=0==t?s.options.slidesToScroll:s.options.slidesToShow-t,s.slideCount>s.options.slidesToShow&&s.slideHandler(s.currentSlide-o,!1,e);break;case"next":o=0==t?s.options.slidesToScroll:t,s.slideCount>s.options.slidesToShow&&s.slideHandler(s.currentSlide+o,!1,e);break;case"index":var l=0===i.data.index?0:i.data.index||n.index()*s.options.slidesToScroll;s.slideHandler(s.checkNavigable(l),!1,e),n.children().trigger("focus");break;default:return}},l.prototype.checkNavigable=function(i){var e=this.getNavigableIndexes(),t=0;if(i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},l.prototype.cleanUpEvents=function(){var i=this;i.options.autoplay&&i.options.useAutoplayToggleButton&&i.$pauseButton.off("click.slick",i.autoPlayToggleHandler),i.options.dots&&null!==i.$dots&&d("li",i.$dots).off("click.slick",i.changeSlide).off("mouseenter.slick",d.proxy(i.interrupt,i,!0)).off("mouseleave.slick",d.proxy(i.interrupt,i,!1)),i.$slider.off("focus.slick blur.slick"),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow&&i.$prevArrow.off("click.slick",i.changeSlide),i.$nextArrow&&i.$nextArrow.off("click.slick",i.changeSlide)),i.$list.off("touchstart.slick mousedown.slick",i.swipeHandler),i.$list.off("touchmove.slick mousemove.slick",i.swipeHandler),i.$list.off("touchend.slick mouseup.slick",i.swipeHandler),i.$list.off("touchcancel.slick mouseleave.slick",i.swipeHandler),i.$list.off("click.slick",i.clickHandler),d(document).off(i.visibilityChange,i.visibility),i.cleanUpSlideEvents(),d(window).off("orientationchange.slick.slick-"+i.instanceUid,i.orientationChange),d(window).off("resize.slick.slick-"+i.instanceUid,i.resize),d("[draggable!=true]",i.$slideTrack).off("dragstart",i.preventDefault),d(window).off("load.slick.slick-"+i.instanceUid,i.setPosition)},l.prototype.cleanUpSlideEvents=function(){var i=this;i.$list.off("mouseenter.slick",d.proxy(i.interrupt,i,!0)),i.$list.off("mouseleave.slick",d.proxy(i.interrupt,i,!1))},l.prototype.cleanUpRows=function(){var i;0<this.options.rows&&((i=this.$slides.children().children()).removeAttr("style"),this.$slider.empty().append(i))},l.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},l.prototype.destroy=function(i){var e=this;e.autoPlayClear(),e.touchObject={},e.cleanUpEvents(),d(".slick-cloned",e.$slider).detach(),e.options.autoplay&&e.options.useAutoplayToggleButton&&e.$pauseButton.remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.$prevArrow.length&&(e.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").prop("disabled",!1).css("display",""),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove()),e.$nextArrow&&e.$nextArrow.length&&(e.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").prop("disabled",!1).css("display",""),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove()),e.$slides&&(e.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){d(this).attr("style",d(this).data("originalStyling"))}),e.$slideTrack.children(this.options.slide).detach(),e.$slideTrack.detach(),e.$list.detach(),e.$slider.append(e.$slides)),e.cleanUpRows(),e.$slider.removeClass("slick-slider"),e.$slider.removeClass("slick-initialized"),e.$slider.removeClass("slick-dotted"),e.unslicked=!0,i||e.$slider.trigger("destroy",[e])},l.prototype.disableTransition=function(i){var e={};e[this.transitionType]="",!1===this.options.fade?this.$slideTrack.css(e):this.$slides.eq(i).css(e)},l.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},l.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},l.prototype.filterSlides=l.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},l.prototype.focusHandler=function(){var t=this;t.$slider.off("focus.slick blur.slick").on("focus.slick","*",function(i){var e=d(this);setTimeout(function(){t.options.pauseOnFocus&&e.is(":focus")&&(t.focussed=!0,t.autoPlay())},0)}).on("blur.slick","*",function(i){d(this);t.options.pauseOnFocus&&(t.focussed=!1,t.autoPlay())})},l.prototype.getCurrent=l.prototype.slickCurrentSlide=function(){return this.currentSlide},l.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},l.prototype.getLeft=function(i){var e,t,o,s,n=this,l=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),l=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(l=i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,l=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(l=n.slideOffset=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+l,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},l.prototype.getOption=l.prototype.slickGetOption=function(i){return this.options[i]},l.prototype.getNavigableIndexes=function(){for(var i=this,e=0,t=0,o=[],s=!1===i.options.infinite?i.slideCount:(e=-1*i.options.slidesToScroll,t=-1*i.options.slidesToScroll,2*i.slideCount);e<s;)o.push(e),e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;return o},l.prototype.getSlick=function(){return this},l.prototype.getSlideCount=function(){var s,n=this,i=!0===n.options.centerMode?Math.floor(n.$list.width()/2):0,l=-1*n.swipeLeft+i;return!0===n.options.swipeToSlide?(n.$slideTrack.find(".slick-slide").each(function(i,e){var t=d(e).outerWidth(),o=e.offsetLeft;if(!0!==n.options.centerMode&&(o+=t/2),l<o+t)return s=e,!1}),Math.abs(d(s).attr("data-slick-index")-n.currentSlide)||1):n.options.slidesToScroll},l.prototype.goTo=l.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},l.prototype.init=function(i){var e=this;d(e.$slider).hasClass("slick-initialized")||(d(e.$slider).addClass("slick-initialized"),e.buildRows(),e.buildOut(),e.setProps(),e.startLoad(),e.loadSlider(),e.initializeEvents(),e.updateArrows(),e.updateDots(),e.checkResponsive(!0),e.focusHandler()),i&&e.$slider.trigger("init",[e]),e.options.autoplay&&(e.paused=!1,e.autoPlay()),e.updateSlideVisibility(),null!=e.options.accessibility&&console.warn("accessibility setting is no longer supported."),null!=e.options.focusOnChange&&console.warn("focusOnChange is no longer supported."),null!=e.options.focusOnSelect&&console.warn("focusOnSelect is no longer supported.")},l.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide))},l.prototype.initDotEvents=function(){var i=this;!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&d("li",i.$dots).on("click.slick",{message:"index"},i.changeSlide),!0===i.options.dots&&!0===i.options.pauseOnDotsHover&&i.slideCount>i.options.slidesToShow&&d("li",i.$dots).on("mouseenter.slick",d.proxy(i.interrupt,i,!0)).on("mouseleave.slick",d.proxy(i.interrupt,i,!1))},l.prototype.initSlideEvents=function(){var i=this;i.options.pauseOnHover&&(i.$list.on("mouseenter.slick",d.proxy(i.interrupt,i,!0)),i.$list.on("mouseleave.slick",d.proxy(i.interrupt,i,!1)))},l.prototype.initializeEvents=function(){var i=this;i.initArrowEvents(),i.initDotEvents(),i.initSlideEvents(),i.options.autoplay&&i.options.useAutoplayToggleButton&&i.$pauseButton.on("click.slick",i.autoPlayToggleHandler),i.$list.on("touchstart.slick mousedown.slick",{action:"start"},i.swipeHandler),i.$list.on("touchmove.slick mousemove.slick",{action:"move"},i.swipeHandler),i.$list.on("touchend.slick mouseup.slick",{action:"end"},i.swipeHandler),i.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},i.swipeHandler),i.$list.on("click.slick",i.clickHandler),d(document).on(i.visibilityChange,d.proxy(i.visibility,i)),d(window).on("orientationchange.slick.slick-"+i.instanceUid,d.proxy(i.orientationChange,i)),d(window).on("resize.slick.slick-"+i.instanceUid,d.proxy(i.resize,i)),d("[draggable!=true]",i.$slideTrack).on("dragstart",i.preventDefault),d(window).on("load.slick.slick-"+i.instanceUid,i.setPosition),d(i.setPosition)},l.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},l.prototype.lazyLoad=function(){var i,e,t,n=this;function o(i){d("img[data-lazy]",i).each(function(){var i=d(this),e=d(this).attr("data-lazy"),t=d(this).attr("data-srcset"),o=d(this).attr("data-sizes")||n.$slider.attr("data-sizes"),s=document.createElement("img");s.onload=function(){i.animate({opacity:0},100,function(){t&&(i.attr("srcset",t),o&&i.attr("sizes",o)),i.attr("src",e).animate({opacity:1},200,function(){i.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,i,e])})},s.onerror=function(){i.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,i,e])},s.src=e})}if(!0===n.options.centerMode?t=!0===n.options.infinite?(e=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(e=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),n.options.slidesToShow/2+1+2+n.currentSlide):(e=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,t=Math.ceil(e+n.options.slidesToShow),!0===n.options.fade&&(0<e&&e--,t<=n.slideCount&&t++)),i=n.$slider.find(".slick-slide").slice(e,t),"anticipated"===n.options.lazyLoad)for(var s=e-1,l=t,r=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)s<0&&(s=n.slideCount-1),i=(i=i.add(r.eq(s))).add(r.eq(l)),s--,l++;o(i),n.slideCount<=n.options.slidesToShow?o(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?o(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&o(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},l.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},l.prototype.next=l.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},l.prototype.orientationChange=function(){this.checkResponsive(),this.setPosition()},l.prototype.pause=l.prototype.slickPause=function(){this.autoPlayClear(),this.paused=!0},l.prototype.play=l.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},l.prototype.postSlide=function(i){var e=this;e.unslicked||(e.$slider.trigger("afterChange",[e,i]),e.animating=!1,e.slideCount>e.options.slidesToShow&&e.setPosition(),e.swipeLeft=null,e.options.autoplay&&e.autoPlay(),e.updateSlideVisibility())},l.prototype.prev=l.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},l.prototype.preventDefault=function(i){i.preventDefault()},l.prototype.progressiveLazyLoad=function(i){i=i||1;var e,t,o,s,n,l=this,r=d("img[data-lazy]",l.$slider);r.length?(e=r.first(),t=e.attr("data-lazy"),o=e.attr("data-srcset"),s=e.attr("data-sizes")||l.$slider.attr("data-sizes"),(n=document.createElement("img")).onload=function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,e,t]),l.progressiveLazyLoad()},n.onerror=function(){i<3?setTimeout(function(){l.progressiveLazyLoad(i+1)},500):(e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,e,t]),l.progressiveLazyLoad())},n.src=t):l.$slider.trigger("allImagesLoaded",[l])},l.prototype.refresh=function(i){var e,t=this,o=t.slideCount-t.options.slidesToShow;!t.options.infinite&&t.currentSlide>o&&(t.currentSlide=o),t.slideCount<=t.options.slidesToShow&&(t.currentSlide=0),e=t.currentSlide,t.destroy(!0),d.extend(t,t.initials,{currentSlide:e}),t.init(),i||t.changeSlide({data:{message:"index",index:e}},!1)},l.prototype.registerBreakpoints=function(){var i,e,t,o=this,s=o.options.responsive||null;if("array"===d.type(s)&&s.length){for(i in o.respondTo=o.options.respondTo||"window",s)if(t=o.breakpoints.length-1,s.hasOwnProperty(i)){for(e=s[i].breakpoint;0<=t;)o.breakpoints[t]&&o.breakpoints[t]===e&&o.breakpoints.splice(t,1),t--;o.breakpoints.push(e),o.breakpointSettings[e]=s[i].settings}o.breakpoints.sort(function(i,e){return o.options.mobileFirst?i-e:e-i})}},l.prototype.reinit=function(){var i=this;i.$slides=i.$slideTrack.children(i.options.slide).addClass("slick-slide"),i.slideCount=i.$slides.length,i.currentSlide>=i.slideCount&&0!==i.currentSlide&&(i.currentSlide=i.currentSlide-i.options.slidesToScroll),i.slideCount<=i.options.slidesToShow&&(i.currentSlide=0),i.registerBreakpoints(),i.setProps(),i.setupInfinite(),i.buildArrows(),i.updateArrows(),i.initArrowEvents(),i.buildDots(),i.updateDots(),i.initDotEvents(),i.cleanUpSlideEvents(),i.initSlideEvents(),i.checkResponsive(!1,!0),i.setSlideClasses("number"==typeof i.currentSlide?i.currentSlide:0),i.setPosition(),i.focusHandler(),i.paused=!i.options.autoplay,i.autoPlay(),i.$slider.trigger("reInit",[i])},l.prototype.resize=function(){var i=this;d(window).width()!==i.windowWidth&&(clearTimeout(i.windowDelay),i.windowDelay=window.setTimeout(function(){i.windowWidth=d(window).width(),i.checkResponsive(),i.unslicked||i.setPosition()},50))},l.prototype.removeSlide=l.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},l.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled||(!(s={})===o.cssTransitions?s[o.animType]="translate("+e+", "+t+")":s[o.animType]="translate3d("+e+", "+t+", 0px)"),o.$slideTrack.css(s)},l.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},l.prototype.setFade=function(){var t,o=this;o.$slides.each(function(i,e){t=o.slideWidth*i*-1,!0===o.options.rtl?d(e).css({position:"relative",right:t,top:0,zIndex:o.options.zIndex-2,opacity:0}):d(e).css({position:"relative",left:t,top:0,zIndex:o.options.zIndex-2,opacity:0})}),o.$slides.eq(o.currentSlide).css({zIndex:o.options.zIndex-1,opacity:1})},l.prototype.setHeight=function(){var i,e=this;1===e.options.slidesToShow&&!0===e.options.adaptiveHeight&&!1===e.options.vertical&&(i=e.$slides.eq(e.currentSlide).outerHeight(!0),e.$list.css("height",i))},l.prototype.setOption=l.prototype.slickSetOption=function(){var i,e,t,o,s,n=this,l=!1;if("object"===d.type(arguments[0])?(t=arguments[0],l=arguments[1],s="multiple"):"string"===d.type(arguments[0])&&(o=arguments[1],l=arguments[2],"responsive"===(t=arguments[0])&&"array"===d.type(arguments[1])?s="responsive":void 0!==arguments[1]&&(s="single")),"single"===s)n.options[t]=o;else if("multiple"===s)d.each(t,function(i,e){n.options[i]=e});else if("responsive"===s)for(e in o)if("array"!==d.type(n.options.responsive))n.options.responsive=[o[e]];else{for(i=n.options.responsive.length-1;0<=i;)n.options.responsive[i].breakpoint===o[e].breakpoint&&n.options.responsive.splice(i,1),i--;n.options.responsive.push(o[e])}l&&(n.unload(),n.reinit())},l.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},l.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},l.prototype.setSlideClasses=function(i){var e,t,o,s,n=this,l=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true").attr("aria-label",function(){return d(this).attr("aria-label").replace(" (centered)","")});n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode?(o=n.options.slidesToShow%2==0?1:0,s=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(s<=i&&i<=n.slideCount-1-s?n.$slides.slice(i-s+o,i+s+1).addClass("slick-active").removeAttr("aria-hidden"):(e=n.options.slidesToShow+i,l.slice(e-s+1+o,e+s+2).addClass("slick-active").removeAttr("aria-hidden")),0===i?l.eq(n.options.slidesToShow+n.slideCount+1).addClass("slick-center").attr("aria-label",function(){return d(this).attr("aria-label")+" (centered)"}):i===n.slideCount-1&&l.eq(n.options.slidesToShow).addClass("slick-center").attr("aria-label",function(){return d(this).attr("aria-label")+" (centered)"})),n.$slides.eq(i).addClass("slick-center").attr("aria-label",function(){return d(this).attr("aria-label")+" (centered)"})):0<=i&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").removeAttr("aria-hidden"):l.length<=n.options.slidesToShow?l.addClass("slick-active").removeAttr("aria-hidden"):(t=n.slideCount%n.options.slidesToShow,e=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?l.slice(e-(n.options.slidesToShow-t),e+t).addClass("slick-active").removeAttr("aria-hidden"):l.slice(e,e+n.options.slidesToShow).addClass("slick-active").removeAttr("aria-hidden")),"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},l.prototype.setupInfinite=function(){var i,e,t,o=this;if(!0===o.options.fade&&(o.options.centerMode=!1),!0===o.options.infinite&&!1===o.options.fade&&(e=null,o.slideCount>o.options.slidesToShow)){for(t=!0===o.options.centerMode?o.options.slidesToShow+1:o.options.slidesToShow,i=o.slideCount;i>o.slideCount-t;--i)e=i-1,d(o.$slides[e]).clone(!0).attr("id","").attr("data-slick-index",e-o.slideCount).prependTo(o.$slideTrack).addClass("slick-cloned");for(i=0;i<t+o.slideCount;i+=1)e=i,d(o.$slides[e]).clone(!0).attr("id","").attr("data-slick-index",e+o.slideCount).appendTo(o.$slideTrack).addClass("slick-cloned");o.$slideTrack.find(".slick-cloned").find("[id]").each(function(){d(this).attr("id","")})}},l.prototype.interrupt=function(i){i||this.autoPlay(),this.interrupted=i},l.prototype.selectHandler=function(i){var e=d(i.target).is(".slick-slide")?d(i.target):d(i.target).parents(".slick-slide"),t=(t=parseInt(e.attr("data-slick-index")))||0;this.slideCount<=this.options.slidesToShow?this.slideHandler(t,!1,!0):this.slideHandler(t)},l.prototype.slideHandler=function(i,e,t){var o,s,n,l,r,a,d=this;if(e=e||!1,!(!0===d.animating&&!0===d.options.waitForAnimate||!0===d.options.fade&&d.currentSlide===i))if(!1===e&&d.asNavFor(i),o=i,r=d.getLeft(o),l=d.getLeft(d.currentSlide),d.currentLeft=null===d.swipeLeft?l:d.swipeLeft,!1===d.options.infinite&&!1===d.options.centerMode&&(i<0||i>d.getDotCount()*d.options.slidesToScroll))!1===d.options.fade&&(o=d.currentSlide,!0!==t&&d.slideCount>d.options.slidesToShow?d.animateSlide(l,function(){d.postSlide(o)}):d.postSlide(o));else if(!1===d.options.infinite&&!0===d.options.centerMode&&(i<0||i>d.slideCount-d.options.slidesToScroll))!1===d.options.fade&&(o=d.currentSlide,!0!==t&&d.slideCount>d.options.slidesToShow?d.animateSlide(l,function(){d.postSlide(o)}):d.postSlide(o));else{if(d.options.autoplay&&clearInterval(d.autoPlayTimer),s=o<0?d.slideCount%d.options.slidesToScroll!=0?d.slideCount-d.slideCount%d.options.slidesToScroll:d.slideCount+o:o>=d.slideCount?d.slideCount%d.options.slidesToScroll!=0?0:o-d.slideCount:o,d.animating=!0,d.$slider.trigger("beforeChange",[d,d.currentSlide,s]),n=d.currentSlide,d.currentSlide=s,d.setSlideClasses(d.currentSlide),d.options.asNavFor&&(a=(a=d.getNavTarget()).slick("getSlick")).slideCount<=a.options.slidesToShow&&a.setSlideClasses(d.currentSlide),d.updateDots(),d.updateArrows(),!0===d.options.fade)return!0!==t?(d.fadeSlideOut(n),d.fadeSlide(s,function(){d.postSlide(s)})):d.postSlide(s),void d.animateHeight();!0!==t&&d.slideCount>d.options.slidesToShow?d.animateSlide(r,function(){d.postSlide(s)}):d.postSlide(s)}},l.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},l.prototype.swipeDirection=function(){var i=this,e=i.touchObject.startX-i.touchObject.curX,t=i.touchObject.startY-i.touchObject.curY,o=Math.atan2(t,e),s=Math.round(180*o/Math.PI);return s<0&&(s=360-Math.abs(s)),s<=45&&0<=s||s<=360&&315<=s?!1===i.options.rtl?"left":"right":135<=s&&s<=225?!1===i.options.rtl?"right":"left":!0===i.options.verticalSwiping?35<=s&&s<=135?"down":"up":"vertical"},l.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1;if(o.interrupted=!1,o.shouldClick=!(10<o.touchObject.swipeLength),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},l.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},l.prototype.swipeMove=function(i){var e,t,o,s,n,l=this,r=void 0!==i.originalEvent?i.originalEvent.touches:null;return!(!l.dragging||l.scrolling||r&&1!==r.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==r?r[0].pageX:i.clientX,l.touchObject.curY=void 0!==r?r[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),n=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&4<n?!(l.scrolling=!0):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=n),t=l.swipeDirection(),void 0!==i.originalEvent&&4<l.touchObject.swipeLength&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,(l.touchObject.edgeHit=!1)===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},l.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return!(t.touchObject={});void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},l.prototype.unfilterSlides=l.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},l.prototype.unload=function(){var i=this;d(".slick-cloned",i.$slider).remove(),i.$dots&&i.$dots.remove(),i.$prevArrow&&i.htmlExpr.test(i.options.prevArrow)&&i.$prevArrow.remove(),i.$nextArrow&&i.htmlExpr.test(i.options.nextArrow)&&i.$nextArrow.remove(),i.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},l.prototype.unslick=function(i){this.$slider.trigger("unslick",[this,i]),this.destroy()},l.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2);!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").prop("disabled",!1),i.$nextArrow.removeClass("slick-disabled").prop("disabled",!1),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").prop("disabled",!0),i.$nextArrow.removeClass("slick-disabled").prop("disabled",!1)):(i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode||i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode)&&(i.$nextArrow.addClass("slick-disabled").prop("disabled",!0),i.$prevArrow.removeClass("slick-disabled").prop("disabled",!1)))},l.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").find("button").removeAttr("aria-current").end().end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active").find("button").attr("aria-current",!0).end().end())},l.prototype.updateSlideVisibility=function(){this.$slideTrack.find(".slick-slide").attr("aria-hidden","true").find("a, input, button, select").attr("tabindex","-1"),this.$slideTrack.find(".slick-active").removeAttr("aria-hidden").find("a, input, button, select").removeAttr("tabindex")},l.prototype.visibility=function(){this.options.autoplay&&(document[this.hidden]?this.interrupted=!0:this.interrupted=!1)},d.fn.slick=function(){for(var i,e=this,t=arguments[0],o=Array.prototype.slice.call(arguments,1),s=e.length,n=0;n<s;n++)if("object"==typeof t||void 0===t?e[n].slick=new l(e[n],t):i=e[n].slick[t].apply(e[n].slick,o),void 0!==i)return i;return e}});



    $(".multiple-items-left").on("beforeChange", function (){
      console.log('test');

  })

  

  $('.multiple-items-left').on('init', function() {
    var dataId = $('.slick-current').attr("data-slick-index");    
    var color = $('.slick-current').find('.gallery-item').attr("data-color");  
    var background = $('.slick-current').find('.gallery-item').attr("data-background");  
  
    $('.header').addClass(color +'-color');
    $('.header').addClass('bg-' + background +'-color');
    $('.multiple-items').addClass(color +'-color');
    $('.header__icons').addClass(color +'-color');

    $('.multiple-items').addClass('bg-' + background +'-color');

  });

  $('.multiple-items-left').on('beforeChange', function (event, slick, currentSlide, nextSlide) {

    //var dataId = $('.slick-current').attr("data-slick-index");   

  
    
    $('.header, .multiple-items, .header__icons, .announcement-bar').removeClass('green-color');
    $('.header, .multiple-items, .header__icons, .announcement-bar').removeClass('blue-color');
    $('.header, .multiple-items, .header__icons, .announcement-bar').removeClass('black-color');
    $('.header, .multiple-items, .header__icons, .announcement-bar').removeClass('lightblue-color');
    $('.header, .multiple-items, .header__icons, .announcement-bar').removeClass('white-color');
    $('.header, .multiple-items, .header__icons, .announcement-bar').removeClass('bg-green-color');
    $('.header, .multiple-items, .header__icons, .announcement-bar').removeClass('bg-green-color-a');
    $('.header, .multiple-items, .header__icons, .announcement-bar').removeClass('bg-undefined-color');
    $('.header, .multiple-items, .header__icons, .announcement-bar').removeClass('bg-blue-color');
    $('.header, .multiple-items, .header__icons, .announcement-bar').removeClass('bg-black-color');
    $('.header, .multiple-items, .header__icons, .announcement-bar').removeClass('bg-lightblue-color');
    $('.header, .multiple-items, .header__icons, .announcement-bar').removeClass('bg-white-color');
    if (currentSlide === 0 && nextSlide === slick.$slides.length - 1) {
      // its going from the first slide to the last slide (backwards)
    //  direction = 'prev';

      var color = $('.multiple-items .slick-slide:last-child').find('.gallery-item').attr("data-color");  
      var background = $('.multiple-items .slick-slide:last-child').find('.gallery-item').attr("data-background");  


  } else if (nextSlide > currentSlide || (currentSlide === (slick.$slides.length - 1) && nextSlide === 0 )) {

    var color = $('.slick-current').next().find('.gallery-item').attr("data-color");  
    var background = $('.slick-current').next().find('.gallery-item').attr("data-background");  
     // direction = 'next';
  
  }
  
  else {
    var color = $('.slick-current').prev().find('.gallery-item').attr("data-color");  
    var background = $('.slick-current').prev().find('.gallery-item').attr("data-background");  
  }

  



  //  $('.header').addClass(color +'-color');
 //   $('.header').addClass('bg-' + background +'-color');
 //  $('.announcement-bar').addClass('bg-' + background +'-color-a');
    $('.multiple-items').addClass(color +'-color');
  //  $('.header__icons').addClass(color +'-color');

    $('.multiple-items').addClass('bg-' + background +'-color');
});
 
}








function initAcc(elem, option){
  document.addEventListener('click', function (e) {

      if (!e.target.matches(elem+' .a-btn')) return;
      else{
          if(!e.target.parentElement.classList.contains('active')){

              if(option==true){
                  var elementList = document.querySelectorAll(elem+' .a-container');
                  Array.prototype.forEach.call(elementList, function (e) {
                      e.classList.remove('active');
                  });
              }            
 
              e.target.parentElement.classList.add('active');
          }else{

              e.target.parentElement.classList.remove('active');
          }
      }
  });
}

initAcc('.accordion.v1', true);
initAcc('.accordion.v2', false);



document.querySelector('.mobile-menu-navigation .body-spray-trigger').addEventListener('click', function() {
  document.querySelector('.mobile-menu-navigation .body-spray-menu').classList.toggle('active');
  document.querySelector('.mobile-menu-navigation .body-spray-trigger').classList.toggle('active');
  });

  document.querySelector('.mobile-menu-navigation .soap-trigger').addEventListener('click', function() {
    document.querySelector('.mobile-menu-navigation .soap-menu').classList.toggle('active');
    document.querySelector('.mobile-menu-navigation .soap-trigger').classList.toggle('active');
    });

    document.querySelector('.mobile-menu-navigation .sets-trigger').addEventListener('click', function() {
      document.querySelector('.mobile-menu-navigation .sets-menu').classList.toggle('active');
      document.querySelector('.mobile-menu-navigation .sets-trigger').classList.toggle('active');
      });

      document.querySelector('.mobile-menu-navigation .other-trigger').addEventListener('click', function() {
        document.querySelector('.mobile-menu-navigation .other-menu').classList.toggle('active');
        document.querySelector('.mobile-menu-navigation .other-trigger').classList.toggle('active');
        });

  document.querySelector('.mobile-menu-navigation .body-wash-trigger').addEventListener('click', function() {
    document.querySelector('.mobile-menu-navigation .body-wash-menu').classList.toggle('active');
    document.querySelector('.mobile-menu-navigation .body-wash-trigger').classList.toggle('active');
    });


    document.querySelector('.mobile-menu-navigation .fragrance-trigger').addEventListener('click', function() {
      document.querySelector('.mobile-menu-navigation .fragrance-menu').classList.toggle('active');
      document.querySelector('.mobile-menu-navigation .fragrance-trigger').classList.toggle('active');
      });

if (window.innerWidth > 780 && document.querySelector('.multiple-items') != null || document.querySelector('.pre-order-marquee') != null ) {
!function(t,e){"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?module.exports=e():t.Marquee3k=e()}(this,function(){"use strict";let t=0;class e{constructor(t,e){this.element=t,this.selector=e.selector,this.speed=t.dataset.speed||.25,this.pausable=t.dataset.pausable,this.reverse=t.dataset.reverse,this.paused=!1,this.parent=t.parentElement,this.parentProps=this.parent.getBoundingClientRect(),this.content=t.children[0],this.innerContent=this.content.innerHTML,this.wrapStyles="",this.offset=0,this._setupWrapper(),this._setupContent(),this._setupEvents(),this.wrapper.appendChild(this.content),this.element.appendChild(this.wrapper)}_setupWrapper(){this.wrapper=document.createElement("div"),this.wrapper.classList.add("marquee3k__wrapper"),this.wrapper.style.whiteSpace="nowrap"}_setupContent(){this.content.classList.add(`${this.selector}__copy`),this.content.style.display="inline-block",this.contentWidth=this.content.offsetWidth,this.requiredReps=this.contentWidth>this.parentProps.width?2:Math.ceil((this.parentProps.width-this.contentWidth)/this.contentWidth)+1;for(let t=0;t<this.requiredReps;t++)this._createClone();this.reverse&&(this.offset=-1*this.contentWidth),this.element.classList.add("is-init")}_setupEvents(){this.element.addEventListener("mouseenter",()=>{this.pausable&&(this.paused=!0)}),this.element.addEventListener("mouseleave",()=>{this.pausable&&(this.paused=!1)})}_createClone(){const t=this.content.cloneNode(!0);t.style.display="inline-block",t.classList.add(`${this.selector}__copy`),this.wrapper.appendChild(t)}animate(){if(!this.paused){const t=this.reverse?this.offset<0:this.offset>-1*this.contentWidth,e=this.reverse?-1:1,s=this.reverse?-1*this.contentWidth:0;t?this.offset-=this.speed*e:this.offset=s,this.wrapper.style.whiteSpace="nowrap",this.wrapper.style.transform=`translate(${this.offset}px, 0) translateZ(0)`}}_refresh(){this.contentWidth=this.content.offsetWidth}repopulate(t,e){if(this.contentWidth=this.content.offsetWidth,e){const e=Math.ceil(t/this.contentWidth)+1;for(let t=0;t<e;t++)this._createClone()}}static refresh(t){MARQUEES[t]._refresh()}static pause(t){MARQUEES[t].paused=!0}static play(t){MARQUEES[t].paused=!1}static toggle(t){MARQUEES[t].paused=!MARQUEES[t].paused}static refreshAll(){for(let t=0;t<MARQUEES.length;t++)MARQUEES[t]._refresh()}static pauseAll(){for(let t=0;t<MARQUEES.length;t++)MARQUEES[t].paused=!0}static playAll(){for(let t=0;t<MARQUEES.length;t++)MARQUEES[t].paused=!1}static toggleAll(){for(let t=0;t<MARQUEES.length;t++)MARQUEES[t].paused=!MARQUEES[t].paused}static init(s={selector:"marquee3k"}){t&&window.cancelAnimationFrame(t),window.MARQUEES=[];const i=Array.from(document.querySelectorAll(`.${s.selector}`));let n,r=window.innerWidth;for(let t=0;t<i.length;t++){const n=i[t],r=new e(n,s);MARQUEES.push(r)}!function e(){for(let t=0;t<MARQUEES.length;t++)MARQUEES[t].animate();t=window.requestAnimationFrame(e)}(),window.addEventListener("resize",()=>{clearTimeout(n),n=setTimeout(()=>{const t=r<window.innerWidth,e=window.innerWidth-r;for(let s=0;s<MARQUEES.length;s++)MARQUEES[s].repopulate(e,t);r=this.innerWidth},250)})}}return e});
}


window.addEventListener('resize', function(event){
    if (window.innerWidth < 780 && window.innerHeight > 900 ) {
   location.reload();
    }
});


 function handleEnter(e){
    var keycode = (e.keyCode ? e.keyCode : e.which);
    if (keycode == '13' || keycode == '32') {
      document.activeElement.click();
    }
  }
  

  if (document.querySelector('.jdgm-random-link' != null)) {
    document.querySelector('.jdgm-random-link').remove();
  }
  

  console.log("test");
  if (document.querySelector('.rc-template' != null)) {
  var radios = document.querySelectorAll('.rc-template input');


function changeHandler(event) {
  document.getElementById('Option-product-0').value = this.value;
}
Array.prototype.forEach.call(radios, function(radio) {
   radio.addEventListener('change', changeHandler);
});
}

///Cookie Banner
// Creare's 'Implied Consent' EU Cookie Law Banner v:2.4
// Conceived by Robert Kent, James Bavington & Tom Foyster
 
var dropCookie = true;                      // false disables the Cookie, allowing you to style the banner
var cookieDuration = 14;                    // Number of days before the cookie expires, and the banner reappears
var cookieName = 'complianceCookie';        // Name of our cookie
var cookieValue = 'on';                     // Value of cookie
 

function createDiv(){
    var bodytag = document.getElementsByTagName('body')[0];
    var div = document.createElement('div');
    div.setAttribute('id','cookie-law');
    div.innerHTML = '<div id="shopify-privacy-banner-body-div"><div class="shopify-privacy-banner-body-div-text"><h3>We care about your privacy</h3> <p>We use cookies and similar technologies to provide the best experience on our website. <a id="shopify-privacy-banner-privacy-policy" href="https://offcourt.com/policies/privacy-policy" target="_blank">Privacy Policy</a></p></div><div class="shopify-privacy-banner-button-div"><button class="accept" onclick="removeMe();" id="shopify-privacy-banner-accept-button" class="accept">Ok</button> <button class="decline" class="close-cookie-banner" onclick="removeMe();">No Thanks</button></div></div>';    
 // Be advised the Close Banner 'X' link requires jQuery
     
    // bodytag.appendChild(div); // Adds the Cookie Law Banner just before the closing </body> tag
    // or
    bodytag.insertBefore(div,bodytag.firstChild); // Adds the Cookie Law Banner just after the opening <body> tag
     
    document.getElementsByTagName('body')[0].className+=' cookiebanner'; //Adds a class tothe <body> tag when the banner is visible
     
}
 
 
function createCookie(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000)); 
        var expires = "; expires="+date.toGMTString(); 
    }
    else var expires = "";
    if(window.dropCookie) { 
        document.cookie = name+"="+value+expires+"; path=/"; 
    }
}
 
function checkCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
 
function eraseCookie(name) {
    createCookie(name,"",-1);
}
 
window.onload = function(){
    if(checkCookie(window.cookieName) != window.cookieValue){
        createDiv(); 
    }
}

function removeMe(){
      createCookie(window.cookieName,window.cookieValue, window.cookieDuration); // Create the cookie
	var element = document.getElementById('cookie-law');
	element.parentNode.removeChild(element);
}



////


function _toConsumableArray(e) {
  return _arrayWithoutHoles(e) || _iterableToArray(e) || _unsupportedIterableToArray(e) || _nonIterableSpread()
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
}

function _iterableToArray(e) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e)
}

function _arrayWithoutHoles(e) {
  if (Array.isArray(e)) return _arrayLikeToArray(e)
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && _setPrototypeOf(e, t)
}

function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf || function(e, t) {
    return e.__proto__ = t, e
  })(e, t)
}

function _createSuper(e) {
  var t = _isNativeReflectConstruct();
  return function() {
    var n, i = _getPrototypeOf(e);
    if (t) {
      var r = _getPrototypeOf(this).constructor;
      n = Reflect.construct(i, arguments, r)
    } else n = i.apply(this, arguments);
    return _possibleConstructorReturn(this, n)
  }
}

function _possibleConstructorReturn(e, t) {
  return !t || "object" !== _typeof(t) && "function" != typeof t ? _assertThisInitialized(e) : t
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0
  } catch (e) {
    return !1
  }
}

function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e)
  })(e)
}

function _slicedToArray(e, t) {
  return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _unsupportedIterableToArray(e, t) || _nonIterableRest()
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
}

function _unsupportedIterableToArray(e, t) {
  if (e) {
    if ("string" == typeof e) return _arrayLikeToArray(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray(e, t) : void 0
  }
}

function _arrayLikeToArray(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
  return i
}

function _iterableToArrayLimit(e, t) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
    var n = [],
      i = !0,
      r = !1,
      s = void 0;
    try {
      for (var o, a = e[Symbol.iterator](); !(i = (o = a.next()).done) && (n.push(o.value), !t || n.length !== t); i = !0);
    } catch (e) {
      r = !0, s = e
    } finally {
      try {
        i || null == a.return || a.return()
      } finally {
        if (r) throw s
      }
    }
    return n
  }
}

function _arrayWithHoles(e) {
  if (Array.isArray(e)) return e
}

function _instanceof(e, t) {
  return null != t && "undefined" != typeof Symbol && t[Symbol.hasInstance] ? !!t[Symbol.hasInstance](e) : e instanceof t
}

function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
    return typeof e
  } : function(e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
  })(e)
}

function _classCallCheck(e, t) {
  if (!_instanceof(e, t)) throw new TypeError("Cannot call a class as a function")
}

function _defineProperties(e, t) {
  for (var n = 0; n < t.length; n++) {
    var i = t[n];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
  }
}

function _createClass(e, t, n) {
  return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e
}
window.Element && !Element.prototype.closest && (Element.prototype.closest = function(e) {
    var t, n = (this.document || this.ownerDocument).querySelectorAll(e),
      i = this;
    do {
      for (t = n.length; --t >= 0 && n.item(t) !== i;);
    } while (t < 0 && (i = i.parentElement));
    return i
  }),
  function(sections, _shopify_themeA11y) {
    sections = "default" in sections ? sections.default : sections;
    var keyCodes = {
      TAB: "tab",
      ENTER: "enter",
      ESC: "escape",
      SPACE: " ",
      END: "end",
      HOME: "home",
      LEFT: "arrowleft",
      UP: "arrowup",
      RIGHT: "arrowright",
      DOWN: "arrowdown"
    };

    function debounce(e, t) {
      let n;
      return (...i) => {
        clearTimeout(n), n = setTimeout(() => e.apply(this, i), t)
      }
    }

    function promiseStylesheet(e) {
      var t = e || theme.stylesheet;
      return void 0 === this.stylesheetPromise && (this.stylesheetPromise = new Promise(function(e) {
        var n = document.querySelector('link[href="'.concat(t, '"]'));
        n.loaded && e(), window.onloadCSS(n, function() {
          e()
        })
      })), this.stylesheetPromise
    }

    function promiseTransitionEnd(e) {
      var t = ["webkitTransitionEnd", "otransitionend", "oTransitionEnd", "msTransitionEnd", "transitionend"],
        n = 0,
        i = Promise.resolve();
      return ["WebkitTransition", "MozTransition", "OTransition", "msTransition", "transition"].forEach(function() {
        n || (n = parseFloat(window.getComputedStyle(e).transitionDuration))
      }), n > 0 && (i = new Promise(function(n) {
        var i = t.map(function(t) {
          return e.addEventListener(t, r), {
            event: t,
            handler: r
          }
        });

        function r(t) {
          t.target === e && (i.forEach(function(t) {
            var n = t.event,
              i = t.handler;
            e.removeEventListener(n, i)
          }), n())
        }
      })), i
    }

    function cookiesEnabled() {
      var e = window.navigator.cookieEnabled;
      return e || (document.cookie = "testcookie", e = -1 !== document.cookie.indexOf("testcookie")), e
    }



    function resizeSelectInput(e) {
      var t = document.createElement("span");
      void 0 !== e.selectedOptions && (t.innerHTML = e.selectedOptions[0].label), document.querySelector(".footer").appendChild(t);
      var n = t.offsetWidth;
      t.parentNode.removeChild(t), e.style.width = "".concat(n + 50, "px")
    }

    function isIntersectionObserverAvailable() {
      return "IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype
    }

    function getMediaQueryString(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "min";
      return "(".concat(t, "-width: ").concat({
        medium: "740px",
        large: "1200px",
        widescreen: "1400px"
      } [e], ")")
    }
    var selectors = {
        stage: "data-popup-stage",
        popup: "data-popup",
        open: "data-popup-open",
        close: "data-popup-close",
        focus: "data-popup-focus"
      },
      classes = {
        open: "is-open",
        transitionReady: "transition-ready",
        preventScrolling: "prevent-scrolling"
      },
      Popup = function() {
        "use strict";

        function e(t) {
          _classCallCheck(this, e), this.name = t
        }
        return _createClass(e, [{
          key: "init",
          value: function() {
            this.elements = this._getElements(), this._bindEvents(), this.scrollPosition = window.pageYOffset
          }
        }, {
          key: "openPopup",
          value: function(e) {
            if (e.preventDefault && e.preventDefault(), this._prepareAnimation(), this.elements.stage.classList.add(classes.open), this._sleepAnimation(), this.elements.focus ? _shopify_themeA11y.trapFocus(this.elements.popup, {
                elementToFocus: this.elements.focus
              }) : _shopify_themeA11y.trapFocus(this.elements.popup), void 0 !== e.currentTarget && (this.elements.triggerNode = e.currentTarget, this.elements.triggerNode.setAttribute("aria-expanded", !0)), this._enableScrollLock(), "cart" === this.elements.popup.getAttribute("data-popup")) {
              let e = Array.from(document.querySelectorAll(".marquee3k")).findIndex(e => "cart-drawer_marquee marquee3k is-init" === e.className);
              Marquee3k.play(e)
            }
            document.addEventListener("keyup", this.keyUpHandler)
          }
        }, {
          key: "closePopup",
          value: function() {
            var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
            if (this._prepareAnimation(), this.elements.stage.classList.remove(classes.open), this._sleepAnimation(), e && (_shopify_themeA11y.removeTrapFocus(), void 0 !== this.elements.triggerNode && this.elements.triggerNode.focus(), document.removeEventListener("keyup", this.keyUpHandler)), void 0 !== this.elements.triggerNode && this.elements.triggerNode.setAttribute("aria-expanded", !1), this._disableScrollLock(), "cart" === this.elements.popup.getAttribute("data-popup")) {
              let e = Array.from(document.querySelectorAll(".marquee3k")).findIndex(e => "cart-drawer_marquee marquee3k is-init" === e.className);
              Marquee3k.pause(e)
            }
            void 0 !== this.elements.triggerNode && this.elements.triggerNode.dispatchEvent(new window.CustomEvent("popup_closed"))
          }
        }, {
          key: "getElements",
          value: function() {
            return this.elements
          }
        }, {
          key: "resetContainerFocus",
          value: function() {
            _shopify_themeA11y.removeTrapFocus(), this.elements.focus ? _shopify_themeA11y.trapFocus(this.elements.popup, {
              elementToFocus: this.elements.focus
            }) : _shopify_themeA11y.trapFocus(this.elements.popup)
          }
        }, {
          key: "_prepareAnimation",
          value: function() {
            this.elements.stage.classList.add(classes.transitionReady)
          }
        }, {
          key: "_sleepAnimation",
          value: function() {
            var e = this;
            return promiseTransitionEnd(this.elements.popup).then(function() {
              e.elements.stage.classList.remove(classes.transitionReady)
            })
          }
        }, {
          key: "_getElements",
          value: function() {
            return {
              stage: document.querySelector(`[${selectors.stage}=${this.name}]`),
              popup: document.querySelector(`[${selectors.popup}=${this.name}]`),
              open: document.querySelectorAll(`[${selectors.open}=${this.name}]`),
              close: document.querySelectorAll(`[${selectors.close}=${this.name}]`),
              focus: document.querySelector(`[${selectors.focus}=${this.name}]`)
            }
          }
        }, {
          key: "_bindEvents",
          value: function() {
            var e = this;
            this.elements.open.forEach(function(t) {
              t.addEventListener("click", function(t) {
                return e.openPopup(t)
              })
            }), this.elements.close.forEach(function(t) {
              t.addEventListener("click", function() {
                return e.closePopup()
              })
            })
          }
        }, {
          key: "_enableScrollLock",
          value: function() {
            this.scrollPosition = window.pageYOffset, document.body.style.top = "-".concat(this.scrollPosition, "px"), document.body.classList.add(classes.preventScrolling)
          }
        }, {
          key: "_disableScrollLock",
          value: function() {
            document.body.classList.remove(classes.preventScrolling), document.body.style.removeProperty("top"), window.scrollTo(0, this.scrollPosition)
          }
        }, {
          key: "_onKeyUp",
          value: function(e) {
            e.key.toLowerCase() === keyCodes.ESC && this.closePopup()
          }
        }]), e
      }();

    function getDefaultRequestConfig() {
      return JSON.parse(JSON.stringify({
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json;"
        }
      }))
    }

    function fetchJSON(e, t) {
      return fetch(e, t).then(function(e) {
        if (!e.ok) throw e;
        return e.json()
      })
    }

    function cart() {
      return fetchJSON("/cart.js", getDefaultRequestConfig())
    }

    function cartAddFromForm(e) {
      var t = getDefaultRequestConfig();
      return delete t.headers["Content-Type"], t.method = "POST", t.body = e, fetchJSON("/cart/add.js", t)
    }

    function cartChange(e, t) {
      var n = getDefaultRequestConfig();
      return t = t || {}, n.method = "POST", n.body = JSON.stringify({
        line: e,
        quantity: t.quantity,
        properties: t.properties
      }), fetchJSON("/cart/change.js", n)
    }

    function cartUpdate(e) {
      var t = getDefaultRequestConfig();
      return t.method = "POST", t.body = JSON.stringify(e), fetchJSON("/cart/update.js", t)
    }

    function key(e) {
      if ("string" != typeof e || 2 !== e.split(":").length) throw new TypeError("Theme Cart: Provided key value is not a string with the format xxx:xxx")
    }

    function quantity(e) {
      if ("number" != typeof e || isNaN(e)) throw new TypeError("Theme Cart: An object which specifies a quantity or properties value is required")
    }

    function id(e) {
      if ("number" != typeof e || isNaN(e)) throw new TypeError("Theme Cart: Variant ID must be a number")
    }

    function properties(e) {
      if ("object" !== _typeof(e)) throw new TypeError("Theme Cart: Properties must be an object")
    }

    function form(e) {
      if (!_instanceof(e, HTMLFormElement)) throw new TypeError("Theme Cart: Form must be an instance of HTMLFormElement")
    }

    function options(e) {
      if ("object" !== _typeof(e)) throw new TypeError("Theme Cart: Options must be an object");
      if (void 0 === e.quantity && void 0 === e.properties) throw new Error("Theme Cart: You muse define a value for quantity or properties");
      void 0 !== e.quantity && quantity(e.quantity), void 0 !== e.properties && properties(e.properties)
    }

    function getState() {
      return cart()
    }

    function getItemIndex(e) {
      return key(e), cart().then(function(t) {
        var n = -1;
        return t.items.forEach(function(t, i) {
          n = t.key === e ? i + 1 : n
        }), -1 === n ? Promise.reject(new Error("Theme Cart: Unable to match line item with provided key")) : n
      })
    }

    function addItemFromForm(e) {
      form(e);
      var t = new FormData(e);
      return id(parseInt(t.get("id"), 10)), cartAddFromForm(t)
    }

    function updateItem(e, t) {
      return key(e), options(t), getItemIndex(e).then(function(e) {
        return cartChange(e, t)
      })
    }

    function updateNote(e) {
      return cartUpdate({
        note: e
      })
    }

    function clearNote() {
      return cartUpdate({
        note: ""
      })
    }

    function createCommonjsModule(e, t) {
      return e(t = {
        exports: {}
      }, t.exports), t.exports
    }
    var currency_cjs = createCommonjsModule(function(e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.formatMoney = function(e, t) {
          "string" == typeof e && (e = e.replace(".", ""));
          var i = "",
            r = /\{\{\s*(\w+)\s*\}\}/,
            s = t || n;

          function o(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ",",
              i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ".";
            if (isNaN(e) || null == e) return 0;
            var r = (e = (e / 100).toFixed(t)).split("."),
              s = r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n),
              o = r[1] ? i + r[1] : "";
            return s + o
          }
          switch (s.match(r)[1]) {
            case "amount":
              i = o(e, 2);
              break;
            case "amount_no_decimals":
              i = o(e, 0);
              break;
            case "amount_with_comma_separator":
              i = o(e, 2, ".", ",");
              break;
            case "amount_no_decimals_with_comma_separator":
              i = o(e, 0, ".", ",")
          }
          return s.replace(r, i)
        };
        var n = "$"
      }),
      formatMoney = currency_cjs.formatMoney,
      selectors$1 = {
        cartItemsWrapper: "[data-cart-items]",
        cartItem: "data-cart-item",
        quantityInput: "[data-cart-item-quantity]",
        remove: "[data-remove]",
        cartCountBubble: "[data-cart-count-bubble]",
        cartCount: "[data-cart-count]",
        cartItemTxt: "[data-cart-item-txt]",
        cartNote: "[data-cart-note]",
        cartPrice: "[data-cart-price]",
        priceLiveRegion: "[data-price-live-region]",
        checkoutButton: "[data-checkout-button]",
        cartItemError: "[data-cart-item-error]",
        closeButton: "[data-cart-close]",
        emptyText: "[data-cart-empty-text]",
        discounts: "[data-discounts]",
        cartMarquee: "[data-cart_marquee]",
        freeShipping: "[data-free-shipping]"
      },
      classes$1 = {
        hidden: "hidden",
        isEmpty: "is-empty",
        hideNote: "hide-note",
        cookiesDisabled: "cookies-disabled",
        hasError: "has-error"
      },
      disableRebuyCart = true,
      Cart = function() {
        "use strict";

        function e(t) {
          _classCallCheck(this, e), this.elements = {
            cart: t
          }
        }
        return _createClass(e, [{
          key: "init",
          value: function() {
            var e = this;

            document.addEventListener('rebuy:cart.change', function(r) {
             
              if (disableRebuyCart) {
                disableRebuyCart = false
              } else {
                e.renderCartItems(), getState().then(function(n) {
                  e.renderCart(n, r)
                })
              }
            });

            if (cookiesEnabled())
              if (e.elements.cartNoteDropdown = Array.prototype.slice.call(e.elements.cart.querySelectorAll(".drawer__note_lable_wrapper"), 0), Object.assign(e.elements, e.getCartElements(), e.getItemElements()), e.bindContextOfThis(), e.debouncedOnCartItemInput = debounce((t, n) => {
                  e.onCartItemInput(t, n)
                }, 300), e.addCartEvents(), e.addItemEvents(), "false" === e.elements.cart.querySelector(selectors$1.cartMarquee).dataset.alwaysshow) {
                var t = [];
                e.elements.cartItems.forEach(function(e) {
                  e.classList.contains("free-sample") ? t.push("show") : t.push("hide")
                }), t.includes("hide") || 0 === t.length || e.elements.cart.querySelector(selectors$1.cartMarquee).classList.contains("hide") ? e.showHideCartMarquee(!1) : e.showHideCartMarquee(!0)
              } else "true" === e.elements.cart.querySelector(selectors$1.cartMarquee).dataset.alwaysshow && e.elements.cart.querySelector(selectors$1.cartMarquee).classList.contains("hide") && e.showHideCartMarquee(!0);
            else this.elements.cart.classList.add(classes$1.cookiesDisabled)
          }
        }, {
          key: "bindContextOfThis",
          value: function() {
            this.onCartItemInput = this.onCartItemInput.bind(this), this.onCartItemClick = this.onCartItemClick.bind(this), this.updateCartNote = this.updateCartNote.bind(this), this.cartNoteToggle = this.cartNoteToggle.bind(this)
          }
        }, {
          key: "getItemElements",
          value: function() {
            return {
              cartItems: Array.prototype.slice.call(this.elements.cart.querySelectorAll("[".concat(selectors$1.cartItem, "]")), 0)
            }
          }
        }, {
          key: "getCartElements",
          value: function() {
            return {
              cartNote: this.elements.cart.querySelector(selectors$1.cartNote)
            }
          }
        }, {
          key: "showHideCartMarquee",
          value: function(e) {
            e ? this.elements.cart.querySelector(selectors$1.cartMarquee).classList.remove("hide") : this.elements.cart.querySelector(selectors$1.cartMarquee).classList.add("hide")
          }
        }, {
          key: "addItemEvents",
          value: function() {
            var e = this;
            this.elements.cartItems.forEach(function(t) {
              t.addEventListener("change", function(t) {
                disableRebuyCart = true
                e.debouncedOnCartItemInput(t, t.currentTarget)
              }), t.addEventListener("click", e.onCartItemClick)
            }), console.log(e.elements.cartNoteDropdown, this.elements.cartItems), e.elements.cartNoteDropdown[0].addEventListener("click", e.cartNoteToggle)
          }
        }, {
          key: "addCartEvents",
          value: function() {
            this.elements.cartNote && this.elements.cartNote.addEventListener("input", this.updateCartNote)
          }
        }, {
          key: "onCartItemInput",
          value: function(e, t) {
            e.preventDefault();
            var n = t.querySelector(selectors$1.quantityInput);
            return e.target === n && this.updateQuantity(e, t)
          }
        }, {
          key: "onCartItemClick",
          value: function(e) {
            disableRebuyCart = true
            var t = e.currentTarget.querySelector(selectors$1.remove);
            e.target === t && (e.preventDefault(), e.target.disabled = !0, this.removeItem(e))
          }
        }, {
          key: "cartNoteToggle",
          value: function(e) {
            this.elements.cartNoteDropdown[0].parentElement.classList.toggle("active")
          }
        }, {
          key: "updateQuantity",
          value: function(e, t) {
            var n = this,
              i = t.dataset.cartItem,
              r = t.dataset.cartItemProductId,
              s = _slicedToArray(i.split(":"), 1)[0],
              o = e.target.value || 1,
              a = parseInt(o, 10);
            return this.removeLineItemError(t), updateItem(i, {
              quantity: a
            }).then(function(e) {
              return n.renderCart(e, r), theme.cartQuantity.updateQuantityInputElements(i, a), e.item_count ? n.renderCartItems(e) : (n.renderEmptyCart(), !1)
            }).then(function(e) {
              if (e) {
                var t = e.items.find(function(e) {
                    return e.key === i
                  }),
                  r = e.items.reduce(function(e, t) {
                    return t.id === Number(s) ? e + t.quantity : e
                  }, 0),
                  o = n.elements.cart.querySelector("[".concat(selectors$1.cartItem, '="').concat(i, '"]'));
                if (o && o.querySelector(selectors$1.quantityInput).focus(), !(a <= r)) {
                  var l = o.querySelector(selectors$1.cartItemError);
                  n.updateLineItemError(l, t)
                }
              }
            })
          }
        }, {
          key: "updateCartNote",
          value: function() {
            var e = this.elements.cartNote.value;
            e ? updateNote(e) : clearNote()
          }
        }, {
          key: "removeItem",
          value: function(e) {
            var t = this,
              n = e.currentTarget,
              i = n.dataset.cartItem,
              r = n.dataset.cartItemProductId;
            return updateItem(i, {
              quantity: 0
            }).then(function(e) {
              t.renderCart(e, r), theme.cartQuantity.updateQuantityInputElements(i, 0), e.item_count ? t.renderCartItems(e) : t.renderEmptyCart()
            })
          }
        }, {
          key: "updateLineItemError",
          value: function(e, t) {
            var n = theme.strings.quantityError;
            n = n.replace("[quantity]", t.quantity).replace("[title]", t.title), e.innerHTML = n, e.classList.add(classes$1.hasError)
          }
        }, {
          key: "removeLineItemError",
          value: function(e) {
            var t = e.querySelector(selectors$1.cartItemError);
            t.classList.remove(classes$1.hasError), t.textContent = ""
          }
        }, {
          key: "changeCheckoutButtonState",
          value: function(e) {
            this.elements.checkoutButton = this.elements.checkoutButton || this.elements.cart.querySelector(selectors$1.checkoutButton), this.elements.checkoutButton.disabled = e
          }
        }, {
          key: "onCartUpdated",
          value: function(e) {
            var t = this;
            console.log('onCartUpdated')
            console.log(disableRebuyCart)
            disableRebuyCart = true
            return this.renderCartItems(), getState().then(function(n) {
              t.renderCart(n, e)
            })
          }
        }, {
          key: "renderCartItems",
          value: function(e) {
            var t = this;
            return fetch("".concat(theme.rootUrl, "?section_id=cart-items")).then(function(e) {
              return e.text()
            }).then(function(n) {
              t.elements.cartItemsWrapper = t.elements.cartItemsWrapper || t.elements.cart.querySelector(selectors$1.cartItemsWrapper), t.elements.cartItemsWrapper.innerHTML = n, Object.assign(t.elements, t.getItemElements()), t.addItemEvents();
              var i = [],
                r = t.elements.cart.querySelector(selectors$1.freeShipping);
              return t.elements.cartItems.forEach(function(e) {
                e.classList.contains("free-sample") ? i.push("show") : i.push("hide")
              }), "false" === t.elements.cart.querySelector(selectors$1.cartMarquee).dataset.alwaysshow ? void 0 === e ? getState().then(function(e) {
                i.includes("hide") || parseFloat(r.getAttribute("data-shipping_threshold")) < e.total_price ? t.showHideCartMarquee(!1) : t.showHideCartMarquee(!0)
              }) : i.includes("hide") || parseFloat(r.getAttribute("data-shipping_threshold")) < e.total_price ? t.showHideCartMarquee(!1) : t.showHideCartMarquee(!0) : "true" === t.elements.cart.querySelector(selectors$1.cartMarquee).dataset.alwaysshow && t.showHideCartMarquee(!0), e
            })
          }
        }, {
          key: "renderCart",
          value: function(e, t) {
            let n = !0;
            e.items.forEach(function(e) {
              !0 === e.gift_card && (n = !1), console.log("showCartNote:", n)
            }), this.renderCartNote(n), this.renderSubtotalPrice(e.total_price), this.renderCartCountBubble(e.item_count), this.renderPriceLiveRegion(e), this.renderCartLevelDiscounts(), theme.cartQuantity.updateLocalCartState(e, t), e.item_count && (this.elements.cart.classList.remove(classes$1.isEmpty), this.changeCheckoutButtonState(!1))
          }
        }, {
          key: "renderEmptyCart",
          value: function() {
            this.elements.cart.classList.add(classes$1.isEmpty), this.changeCheckoutButtonState(!0), this.elements.cartEmptyText = this.elements.cartEmptyText || this.elements.cart.querySelector(selectors$1.emptyText), this.elements.cartEmptyText.setAttribute("tabindex", "-1"), this.elements.cartEmptyText.focus(), this.showHideCartMarquee(!1)
          }
        }, {
          key: "renderCartLevelDiscounts",
          value: function() {
            var e = this;
            return fetch("".concat(theme.rootUrl, "?section_id=cart-discounts")).then(function(e) {
              return e.text()
            }).then(function(t) {
              e.elements.discounts = e.elements.discounts || e.elements.cart.querySelector(selectors$1.discounts), e.elements.discounts.innerHTML = t
            })
          }
        }, {
          key: "renderSubtotalPrice",
          value: function(e) {
            var t = formatMoney(e, theme.moneyFormat);
            this.elements.cartPrice = this.elements.cartPrice || document.body.querySelectorAll(selectors$1.cartPrice), this.elements.cartPrice.forEach(function(e) {
              e.innerHTML = t
            });
            var n = this.elements.cart.querySelector(selectors$1.freeShipping);
            parseFloat(n.getAttribute("data-shipping_threshold")) < e ? n.classList.remove("hide") : n.classList.add("hide")
          }
        }, {
          key: "renderCartCountBubble",
          value: function(e) {
            document.querySelectorAll(selectors$1.cartCountBubble);
            var t = document.querySelectorAll(selectors$1.cartCount);
            document.querySelectorAll(selectors$1.cartItemTxt)[0].innerHTML = 1 == e ? "item" : "items", t.forEach(function(t) {
              return t.innerText = e > 99 ? "99+" : e
            })
          }
        }, {
          key: "renderPriceLiveRegion",
          value: function(e) {
            var t = this,
              n = e.total_price;
            this.elements.priceLiveRegion = this.elements.priceLiveRegion || this.elements.cart.querySelector(selectors$1.priceLiveRegion);
            var i = this.formatPriceLiveRegionText(n);
            this.elements.priceLiveRegion.textContent = i, this.elements.priceLiveRegion.setAttribute("aria-hidden", !1), window.setTimeout(function() {
              t.elements.priceLiveRegion.setAttribute("aria-hidden", !0)
            }, 1e3)
          }
        }, {
          key: "formatPriceLiveRegionText",
          value: function(e) {
            var t = formatMoney(e, theme.moneyFormat);
            return "".concat(theme.strings.subtotal, ": ").concat(t)
          }
        }, {
          key: "getItemFromState",
          value: function(e, t) {
            return t.items.find(function(t) {
              return t.key === e
            })
          }
        }, {
          key: "renderCartNote",
          value: function(e) {
            console.log("renderCartNote:", e), !1 === e ? this.elements.cart.classList.add(classes$1.hideNote) : this.elements.cart.classList.remove(classes$1.hideNote)
          }
        }]), e
      }(),
      selectors$2 = {
        quantityIndicatorId: function(e) {
          return '[data-quantity-indicator="'.concat(e, '"]')
        },
        quantityInputKey: function(e) {
          return '[data-quantity-input-key="'.concat(e, '"]')
        },
        quantityNumber: "[data-quantity-number]",
        quantityLabel: "[data-quantity-label]"
      },
      classes$2 = {
        inCart: "in-cart",
        isVisible: "is-visible",
        updated: "updated"
      },
      CartQuantity = function() {
        "use strict";

        function e() {
          _classCallCheck(this, e), this.cartState = {}
        }
        return _createClass(e, [{
          key: "updateLocalCartState",
          value: function(e, t) {
            var n = this;
            e ? (this.cartState = this._convertToLocalCartState(e), this.updateQuantityIndicatorElements([t])) : getState().then(function(e) {
              n.cartState = n._convertToLocalCartState(e), n.updateQuantityIndicatorElements()
            })
          }
        }, {
          key: "updateQuantityInputElements",
          value: function(e, t) {
            document.querySelectorAll(selectors$2.quantityInputKey(e)).forEach(function(e) {
              e.dataset.quantityInCart = t, e.value = t, t || e.dispatchEvent(new window.CustomEvent("removedFromCart"))
            })
          }
        }, {
          key: "updateQuantityIndicatorElements",
          value: function(e) {
            var t = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document,
              i = arguments.length > 2 ? arguments[2] : void 0;
            (e || Object.keys(this.cartState)).forEach(function(e) {
              var r = t.cartState[e];
              !r && i || n.querySelectorAll(selectors$2.quantityIndicatorId(e)).forEach(function(e) {
                t._setQuantityIndicator(e, r)
              })
            })
          }
        }, {
          key: "_convertToLocalCartState",
          value: function(e) {
            var t = {};
            return e.items.forEach(function(e) {
              t[e.product_id] || (t[e.product_id] = 0), t[e.product_id] += e.quantity
            }), t
          }
        }, {
          key: "_setQuantityIndicator",
          value: function(e, t) {
            var n = e.querySelector(selectors$2.quantityNumber),
              i = t || 0;
            if (parseInt(n.dataset.quantity, 10) !== i) {
              e.classList.contains(classes$2.isVisible) && t ? this._animateUpdate(e) : this._animateShowOrHide(e, i), n.dataset.quantity = i;
              var r = i < 100 ? i : "99+";
              n.textContent = r;
              var s = 1 === t ? e.dataset.labelSingle : e.dataset.labelMulti.replace("[quantity]", i);
              e.querySelector(selectors$2.quantityLabel).textContent = s
            }
          }
        }, {
          key: "_animateShowOrHide",
          value: function(e, t) {
            e.classList.toggle(classes$2.inCart, t), t ? e.classList.add(classes$2.isVisible) : promiseTransitionEnd(e).then(function() {
              e.classList.remove(classes$2.isVisible)
            })
          }
        }, {
          key: "_animateUpdate",
          value: function(e) {
            e.classList.add(classes$2.updated), promiseTransitionEnd(e).then(function() {
              e.classList.remove(classes$2.updated)
            })
          }
        }]), e
      }(),
      selectors$3 = {
        form: "[data-form]",
        formInputWrapper: "[data-form-input-wrapper]",
        formStatus: "[data-form-status]"
      },
      classes$3 = {
        floatingLabel: "form__input-wrapper--floating-label"
      },
      Form = function() {
        "use strict";

        function e() {
          var t = this;
          _classCallCheck(this, e), Array.prototype.slice.call(document.querySelectorAll(selectors$3.form), 0).forEach(function(e) {
            t._focusFormStatus(e), t._handleFormInputLabels(e)
          })
        }
        return _createClass(e, [{
          key: "_focusFormStatus",
          value: function(e) {
            var t = e.querySelector(selectors$3.formStatus);
            t && (t.focus(), t.addEventListener("blur", function() {
              t.removeAttribute("tabindex")
            }))
          }
        }, {
          key: "_handleFormInputLabels",
          value: function(e) {
            var t = Array.prototype.slice.call(e.querySelectorAll(selectors$3.formInputWrapper), 0);
            t && t.forEach(function(e) {
              e.addEventListener("focusin", function() {
                e.classList.add(classes$3.floatingLabel)
              }), e.addEventListener("focusout", function(t) {
                "" === t.target.value && e.classList.remove(classes$3.floatingLabel)
              })
            })
          }
        }]), e
      }(),
      classes$4 = {
        cookiesDisabled: "cookies-disabled"
      },
      CartTemplate = function() {
        "use strict";

        function e(t) {
          _classCallCheck(this, e), this.elements = {
            cart: t
          }
        }
        return _createClass(e, [{
          key: "init",
          value: function() {
            cookiesEnabled() || this.elements.cart.classList.add(classes$4.cookiesDisabled)
          }
        }]), e
      }(),
      selectors$4 = {
        arrow: "[data-scroller-arrow]",
        menu: "[data-scroller-content]",
        wrapper: "[data-scroller-wrapper]"
      },
      classes$5 = {
        noTransition: "scroller-content--no-transition",
        wrapper: "scroller-wrapper"
      },
      config = {
        offset: 150
      },
      Scroller = function() {
        "use strict";

        function e(t) {
          _classCallCheck(this, e), this.container = t
        }
        return _createClass(e, [{
          key: "init",
          value: function() {
            var e = this;
            this.wrapper = this.container.querySelector(selectors$4.wrapper), this.wrapper && (this.initialized = !0, this.menu = this.wrapper.querySelector(selectors$4.menu), this.arrows = this.container.querySelectorAll(selectors$4.arrow), this.isTransitioning = !1, this._setupEventHandlers(), promiseStylesheet().then(function() {
              e._recalculateOverflow()
            }))
          }
        }, {
          key: "makeElementVisible",
          value: function(e) {
            if ("none" !== this.overflowValue && this.initialized) {
              var t = !0,
                n = config.offset / 2,
                i = e.getBoundingClientRect(),
                r = Math.floor(i.left) - n,
                s = Math.floor(i.right) + n;
              if (this.wrapperRect || this._recalculateOverflow(), s > this.wrapperRect.right ? (this.direction = "next", t = !1) : r < this.wrapperRect.left && (this.direction = "previous", t = !1), !t && !this.isTransitioning) {
                this.isTransitioning = !0;
                var o = this._getDistanceToElement(s, e.offsetLeft, n);
                this._setMenuTranslateX(o)
              }
            }
          }
        }, {
          key: "destroy",
          value: function() {
            var e = this;
            this.initialized && (this.wrapper.removeEventListener("scroll", this.eventHandlers.recalculateOverflow, {
              passive: !0
            }), window.removeEventListener("resize", this.eventHandlers.debounceScroller), this.arrows.forEach(function(t) {
              t.removeEventListener("click", e.eventHandlers.onArrowClick)
            }))
          }
        }, {
          key: "_recalculateOverflow",
          value: function() {
            var e = this._getOverflowValue();
            this._setOverflowClass(e)
          }
        }, {
          key: "_setupEventHandlers",
          value: function() {
            var e = this;
            this.eventHandlers = this._getEventHandlers(), this.wrapper.addEventListener("scroll", this.eventHandlers.recalculateOverflow, {
              passive: !0
            }), window.addEventListener("resize", this.eventHandlers.debounceScroller), this.arrows.forEach(function(t) {
              t.addEventListener("click", e.eventHandlers.onArrowClick)
            })
          }
        }, {
          key: "_getEventHandlers",
          value: function() {
            var e = this;
            return {
              recalculateOverflow: this._recalculateOverflow.bind(this),
              onArrowClick: this._onArrowClick.bind(this),
              debounceScroller: debounce(function() {
                e._recalculateOverflow()
              }, 250)
            }
          }
        }, {
          key: "_getOverflowValue",
          value: function() {
            this._getSelectorsDomRect();
            var e = Math.floor(this.wrapperRect.left),
              t = Math.floor(this.wrapperRect.right),
              n = Math.floor(this.menuRect.left) < e,
              i = Math.floor(this.menuRect.right) > t,
              r = "none";
            return n && i ? r = "both" : n ? r = "left" : i && (r = "right"), r
          }
        }, {
          key: "_getSelectorsDomRect",
          value: function() {
            this.wrapperRect = this.wrapper.getBoundingClientRect(), this.menuRect = this.menu.getBoundingClientRect()
          }
        }, {
          key: "_setOverflowClass",
          value: function(e) {
            var t = this;
            this.overflowValue !== e && (this.wrapper.classList.remove("".concat(classes$5.wrapper, "--").concat(this.overflowValue)), window.requestAnimationFrame(function() {
              t.wrapper.classList.add("".concat(classes$5.wrapper, "--").concat(e)), t.overflowValue = e
            }))
          }
        }, {
          key: "_onArrowClick",
          value: function(e) {
            if (!this.isTransitioning) {
              this.isTransitioning = !0, this.direction = e.currentTarget.dataset.scrollerArrowDirection;
              var t = config.offset,
                n = this._getDistanceToNextPosition();
              n = n < 2 * t ? n : t, this._setMenuTranslateX(n)
            }
          }
        }, {
          key: "_getDistanceToNextPosition",
          value: function() {
            return "next" === this.direction ? Math.round(this.menuRect.right - this.wrapperRect.right) : this.wrapper.scrollLeft
          }
        }, {
          key: "_getDistanceToElement",
          value: function(e, t, n) {
            if ("next" === this.direction) {
              var i = Math.ceil(this.menuRect.width - this.wrapperRect.width - this.wrapper.scrollLeft),
                r = Math.round(e - this.wrapperRect.right) + n;
              return r = r < i ? r : i
            }
            var s = this.wrapper.scrollLeft - t + n;
            return s = s < this.wrapper.scrollLeft ? s : this.wrapper.scrollLeft
          }
        }, {
          key: "_setMenuTranslateX",
          value: function(e) {
            var t = this,
              n = "next" === this.direction ? -e : e;
            this.menu.style.transform = "translateX(".concat(n, "px)"), this.translatedValue = n, this.menu.classList.remove(classes$5.noTransition), promiseTransitionEnd(this.menu).then(function() {
              t._setWrapperScrollLeft(), t.isTransitioning = !1
            })
          }
        }, {
          key: "_setWrapperScrollLeft",
          value: function() {
            var e = Math.abs(this.translatedValue);
            this.menu.style.transform = "none", this.menu.classList.add(classes$5.noTransition), "previous" === this.direction ? this.wrapper.scrollLeft -= e : this.wrapper.scrollLeft += e
          }
        }]), e
      }(),
      selectors$6 = {
        disclosure: "[data-disclosure]",
        disclosureList: "[data-disclosure-list]",
        disclosureToggle: "[data-disclosure-toggle]",
        disclosureInput: "[data-disclosure-input]",
        disclosureOptions: "[data-disclosure-option]"
      },
      classes$6 = {
        listVisible: "disclosure-list--visible"
      },
      Disclosure = function() {
        "use strict";

        function e(t) {
          _classCallCheck(this, e), this.disclosureForm = t, this.disclosure = t.querySelector(selectors$6.disclosure), this.disclosureList = t.querySelector(selectors$6.disclosureList), this.disclosureToggle = t.querySelector(selectors$6.disclosureToggle), this.disclosureInput = t.querySelector(selectors$6.disclosureInput), this.disclosureOptions = t.querySelectorAll(selectors$6.disclosureOptions), this._setupListeners()
        }
        return _createClass(e, [{
          key: "destroy",
          value: function() {
            var e = this;
            this.disclosureToggle.removeEventListener("click", this.eventHandlers.toggleList), this.disclosureOptions.forEach(function(t) {
              return t.removeEventListener("click", e.eventHandlers.connectOptions)
            }), this.disclosure.removeEventListener("keyup", this.eventHandlers.onDisclosureKeyUp), this.disclosureList.removeEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut), this.disclosureToggle.removeEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut), document.body.removeEventListener("click", this.eventHandlers.onBodyClick)
          }
        }, {
          key: "_setupListeners",
          value: function() {
            var e = this;
            this.eventHandlers = this._setupEventHandlers(), this.disclosureToggle.addEventListener("click", this.eventHandlers.toggleList), this.disclosureOptions.forEach(function(t) {
              t.addEventListener("click", e.eventHandlers.connectOptions)
            }), this.disclosure.addEventListener("keyup", this.eventHandlers.onDisclosureKeyUp), this.disclosureList.addEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut), this.disclosureToggle.addEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut), document.body.addEventListener("click", this.eventHandlers.onBodyClick)
          }
        }, {
          key: "_setupEventHandlers",
          value: function() {
            return {
              connectOptions: this._connectOptions.bind(this),
              toggleList: this._toggleList.bind(this),
              onBodyClick: this._onBodyClick.bind(this),
              onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
              onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
              onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
            }
          }
        }, {
          key: "_connectOptions",
          value: function(e) {
            e.preventDefault(), this._submitForm(e.currentTarget.dataset.value)
          }
        }, {
          key: "_onDisclosureToggleFocusOut",
          value: function(e) {
            !1 === this.disclosure.contains(e.relatedTarget) && this._toggleList()
          }
        }, {
          key: "_onDisclosureListFocusOut",
          value: function(e) {
            var t = e.currentTarget.contains(e.relatedTarget);
            this.disclosureList.classList.contains(classes$6.listVisible) && !t && this._toggleList()
          }
        }, {
          key: "_onDisclosureKeyUp",
          value: function(e) {
            e.key.toLowerCase() === keyCodes.ESC && (this._toggleList(), this.disclosureToggle.focus())
          }
        }, {
          key: "_onBodyClick",
          value: function(e) {
            var t = this.disclosure.contains(e.target);
            this.disclosureList.classList.contains(classes$6.listVisible) && !t && this._toggleList()
          }
        }, {
          key: "_submitForm",
          value: function(e) {
            this.disclosureInput.value = e, this.disclosureForm.submit()
          }
        }, {
          key: "_toggleList",
          value: function() {
            var e = "true" === this.disclosureToggle.getAttribute("aria-expanded");
            this.disclosureList.classList.toggle(classes$6.listVisible), this.disclosureToggle.setAttribute("aria-expanded", !e)
          }
        }]), e
      }();
    sections.register("press", {
      onLoad: function() {
        this.pressLogos = Array.prototype.slice.call(this.container.querySelectorAll(".press-logo"), 0), this.pressQuotes = Array.prototype.slice.call(this.container.querySelectorAll(".press-quote"), 0), this._setupEventHandlers()
      },
      _setupEventHandlers: function() {
        var e = this;
        this.eventHandlers = this._getEventHandlers(), this.pressLogos.forEach(function(t) {
          return t.addEventListener("click", e.eventHandlers.onPressItemClick)
        })
      },
      _getEventHandlers: function() {
        return {
          onPressItemClick: this.onPressItemClick.bind(this)
        }
      },
      onPressItemClick: function(e) {
        this.pressQuotes.forEach(function(e) {
          return e.style.display = "none"
        }), this.pressQuotes[e.target.dataset.item].style.display = "block", this.pressLogos.forEach(function(e) {
          return e.classList.remove("active")
        }), this.pressLogos[e.target.dataset.item].classList.add("active")
      },
      onUnload: function() {
        var e = this;
        this.pressLogos.forEach(function(t) {
          return t.removeEventListener("click", e.eventHandlers.onPressItemClick)
        })
      }
    }), sections.register("full-video", {
      onLoad: function() {
        this.fullVideos = Array.prototype.slice.call(this.container.querySelectorAll(".hero-video"), 0), this._setupEventHandlers()
      },
      _setupEventHandlers: function() {
        let e, t = this;
        this.eventHandlers = this._getEventHandlers(), this.playVisibleVideos(), window.addEventListener("scroll", function() {
          clearTimeout(e), e = window.setTimeout(function() {
            t.eventHandlers.playVisibleVideos()
          }, 100)
        }), window.addEventListener("resize", this.eventHandlers.playVisibleVideos, {
          passive: !0
        })
      },
      _getEventHandlers: function() {
        return {
          playVisibleVideos: this.playVisibleVideos.bind(this)
        }
      },
      playVisibleVideos: function() {
        this.fullVideos.forEach(e => this.elementIsVisible(e) ? e.play() : e.pause())
      },
      elementIsVisible: function(e) {
        let t = e.getBoundingClientRect();
        return t.bottom >= 0 && t.top <= (window.innerHeight || document.documentElement.clientHeight)
      }
    }), sections.register("hero-cards", {
      onLoad: function() {},
      onUnload: function() {}
    })
    var selectors$5 = {
      disclosureForm: "[data-disclosure-form]"
    };
    sections.register("footer", {
      onLoad: function() {
        var e = Array.from(this.container.querySelectorAll(selectors$5.disclosureForm));
        this.disclosures = e.map(function(e) {
          return new Disclosure(e)
        })
      },
      onUnload: function() {
        this.disclosures.forEach(function(e) {
          return e.destroy()
        })
      }
    });
    var selectors$7 = {
        dropdownMenu: "[data-dropdown-menu]",
        dropdownParent: "[data-dropdown-parent]",
        dropdownParentIcons: "[data-menu-icon]",
        dropdownParentType: function(e) {
          return '[data-dropdown-parent-type="'.concat(e, '"]')
        },
        headerIcon: "[data-header-icon]",
        menuNavigation: "[data-menu-navigation]",
        menuNavigationItem: "[data-menu-navigation-item]",
        menuNavigationLastItem: "[data-menu-navigation-last-item]",
        menuNavigationType: function(e) {
          return '[data-menu-navigation-type="'.concat(e, '"]')
        },
        mobileNavigationToggle: "[data-mobile-navigation-toggle]",
        mobileNavigationContainer: "[data-mobile-navigation-container]",
        mobileNavigationDrawer: "[data-mobile-navigation-drawer]",
        header: "[data-header]",
        animatedLogo: "[data-animatedLogo]",
        stickySentinelHeader: "[data-sticky-sentinel-header]",
        stickyCollectionHeader: "[data-sticky-element]",
        logoImage: "[data-logo-image]",
        announcementBar: "[data-announcement-bar]",
        mainContent: "[data-main-content]"
      },
      classes$7 = {
        menuNavigationItemIsExpanded: "menu-navigation__item--is-expanded",
        menuDropdownItemIsExpanded: "menu-dropdown__item--is-expanded",
        menuNavigationHidden: "menu-navigation-wrapper--hidden",
        headerWrapperFixed: "header-wrapper--fixed",
        headerWrapperHidden: "header-wrapper--hidden",
        bodyWithStickyHeader: "body-with-sticky-header"
      },
      attributes = {
        headerLogo: "data-header-logo",
        headerIcon: "data-header-icon",
        popupOpen: "data-popup-open",
        menuNavigationToggle: "data-mobile-navigation-toggle",
        searchToggle: "data-search-toggle"
      },
      popups = {
        cart: "cart",
        menuNavigation: "menu-navigation",
        search: "search"
      };
    sections.register("header", {
      onLoad: function() {
        this.elements = this._getElements(), this.menuOpen = !1, isIntersectionObserverAvailable() && this._prepareStickyHeader(), null !== this.elements.animatedLogo && this._initAnimatedLogo(), this._reloadHeaderPopups(), this.mqlLarge = window.matchMedia(getMediaQueryString("medium")), this.mqlSmall = window.matchMedia(getMediaQueryString("medium", "max")), this.drawerMenuIsActive = !this.mqlLarge.matches, this.elements.menuNavigation && this._handleMenuNavigationWidth(), this._setupEventHandlers()
      },
      _isTouchDevice: function() {
        return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
      },
      _reloadHeaderPopups: function() {
        window.popups && (!window.popups.find(function(e) {
          return e.name === popups.menuNavigation
        }) && this.elements.menuNavigation && window.popups.push(new Popup(popups.menuNavigation)), Object.values(popups).forEach(function(e) {
          var t = window.popups.find(function(t) {
            return t.name === e
          });
          t && t.init()
        }))
      },
      _getElements: function() {
        return {
          announcementBar: this.container.querySelector(selectors$7.announcementBar),
          cartPriceBubbleContainers: this.container.querySelectorAll(selectors$7.cartPriceBubbleContainer),
          desktopNavigation: this.container.querySelector(selectors$7.menuNavigationType("desktop")),
          dropdownParents: Array.prototype.slice.call(this.container.querySelectorAll(selectors$7.dropdownParent), 0),
          dropdownParentIcons: Array.prototype.slice.call(this.container.querySelectorAll(selectors$7.dropdownParentIcons), 0),
          header: this.container.querySelector(selectors$7.header),
          headerIcons: Array.from(this.container.querySelectorAll(selectors$7.headerIcon)),
          headerLogo: this.container.querySelector(selectors$7.logoImage),
          headerSentinel: document.querySelector(selectors$7.stickySentinelHeader),
          headerWrapper: this.container,
          menuNavigation: this.container.querySelector(selectors$7.menuNavigation),
          menuNavigationItems: this.container.querySelectorAll(selectors$7.menuNavigationItem),
          mobileNavigationToggle: this.container.querySelector(selectors$7.mobileNavigationToggle),
          animatedLogo: this.container.querySelector(selectors$7.animatedLogo),
          mainContent: document.body.querySelector(selectors$7.mainContent)
        }
      },
      _setupEventHandlers: function() {
        var e = this;
        this.eventHandlers = this._getEventHandlers(), isIntersectionObserverAvailable() && (window.addEventListener("scroll", this.eventHandlers.toggleHeaderStyle, {
          passive: !0
        }), window.addEventListener("scroll", this.eventHandlers.toggleHeaderSticky, {
          passive: !0
        }), window.addEventListener("scroll", this.eventHandlers.animateLogo, {
          passive: !0
        }), window.addEventListener("resize", this.eventHandlers.resetAnimatedLogo, {
          passive: !0
        }), document.addEventListener("productAddedToCart", this.eventHandlers.productAddedToCart), document.addEventListener("featuredCollectionTabClicked", this.eventHandlers.preventHeaderSlideIn), document.addEventListener("elementSticky", this.eventHandlers.featuredCollectionSticky)), this.elements.menuNavigation && (this._isTouchDevice() ? this.elements.dropdownParentIcons.forEach(function(t) {
          return t.addEventListener("click", e.eventHandlers.onDropdownParentClick)
        }) : (this.elements.dropdownParents.forEach(function(t) {
          return t.addEventListener("mouseover", e.eventHandlers.onDropdownParentHover)
        }), this.elements.dropdownParents.forEach(function(t) {
          return t.addEventListener("mouseleave", e.eventHandlers.onBodyClick)
        })), window.addEventListener("resize", this.eventHandlers.onWindowResize), this.elements.mobileNavigationToggle.addEventListener("click", this.eventHandlers.handleMobileNavigation))
      },
      _getEventHandlers: function() {
        var e = this;
        return {
          handleMultiplePopups: this._handleMultiplePopups.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDrawerNavigationKeyup: this._onDrawerNavigationKeyup.bind(this),
          onDropdownFocusOut: this._onDropdownFocusOut.bind(this),
          onDropdownKeyup: this._onDropdownKeyup.bind(this),
          onDropdownParentClick: this._onDropdownParentClick.bind(this),
          onDropdownParentHover: this._onDropdownParentHover.bind(this),
          onWindowResize: debounce(function() {
            return e._onWindowResize()
          }, 250),
          handleMobileNavigation: this._handleMobileNavigation.bind(this),
          toggleHeaderSticky: debounce(function() {
            return e._toggleHeaderPosition()
          }, 100),
          toggleHeaderStyle: this._toogleHeaderColor.bind(this),
          featuredCollectionSticky: this._featuredCollectionSticky.bind(this),
          productAddedToCart: this._productAddedToCart.bind(this),
          preventHeaderSlideIn: this._preventHeaderSlideIn.bind(this),
          animateLogo: this._animateLogo.bind(this),
          resetAnimatedLogo: this._resizeAnimatedLogo.bind(this)
        }
      },
      _onWindowResize: function() {
        var e = this._getDesktopActiveParentDropdown(),
          t = "true" === this.elements.mobileNavigationToggle.getAttribute("aria-expanded");
        this.scrolledPastHeader || (this._handleMenuNavigationWidth(), this.drawerMenuIsActive && e ? this._closeActiveDropdown() : !this.drawerMenuIsActive && e ? this.elements.menuNavigation.style.overflow = "initial" : t && !this.drawerMenuIsActive ? this._closeMobileNavigation() : t && this.drawerMenuIsActive && this._toggleHeaderIcons(!0))
      },
      _initAnimatedLogo: function() {
        this.maxScrollDistance = Math.round(.3 * window.innerHeight), this.initialStartYPos = this.elements.animatedLogo.offsetTop, this.logoWidth = this.elements.animatedLogo.offsetWidth, this.widthAtMax = 65, this.topAtMax = this.elements.header.offsetTop + 10, this.widthDiff = this.logoWidth - this.widthAtMax, this.topDiff = this.initialStartYPos - this.topAtMax, this.pixelsPerScroll = this.widthDiff / this.maxScrollDistance, this.topPerScroll = this.topDiff / this.maxScrollDistance, this._animateLogo()
      },
      _animateLogo: function() {
        null !== this.elements.animatedLogo && (this.scrollTopPos = Math.min(window.pageYOffset, this.maxScrollDistance), this.scrollChangePx = Math.floor(this.scrollTopPos * this.pixelsPerScroll), this.scaleWidth = this.logoWidth - this.scrollChangePx, this.topScrollChangePx = Math.floor(this.scrollTopPos * this.topPerScroll), this.scaleTop = this.initialStartYPos - this.topScrollChangePx, this.elements.animatedLogo.style.top = this.scaleTop + "px", this.elements.animatedLogo.style.left = .5 * window.innerWidth - .5 * this.scaleWidth + "px", this.elements.animatedLogo.style.width = this.scaleWidth + "px")
      },
      _resizeAnimatedLogo: function() {
        null != this.elements.animatedLogo && (this.elements.animatedLogo.style.left = .5 * window.innerWidth - .5 * this.scaleWidth + "px")
      },
      _map: function(e, t, n, i, r) {
        var s = arguments.length > 5 && void 0 !== arguments[5] && arguments[5],
          o = !(arguments.length > 6 && void 0 !== arguments[6]) || arguments[6],
          a = !(arguments.length > 7 && void 0 !== arguments[7]) || arguments[7];
        if (o && e < t) return i;
        if (a && e > n) return r;
        var l = (e - t) / (n - t) * (r - i) + i;
        return s ? Math.round(l) : l
      },
      _handleMenuNavigationWidth: function() {
        if (this.mqlLarge.matches) {
          this.elements.menuNavigation.style.overflow = "hidden";
          var e = this.elements.menuNavigation.getBoundingClientRect().right,
            t = this.elements.menuNavigation.querySelector(selectors$7.menuNavigationLastItem).getBoundingClientRect().right;
          this.drawerMenuIsActive = !(e >= t)
        } else this.drawerMenuIsActive = !0
      },
      _onDropdownFocusOut: function(e) {
        if (e.preventDefault(), !e.currentTarget.contains(e.relatedTarget)) {
          var t = e.currentTarget.previousElementSibling;
          this._toggleMenuDropdown(t)
        }
      },
      _closeActiveDropdown: function() {
        var e = this._getDesktopActiveParentDropdown();
        e && this._animateDropdownClosed(e.nextElementSibling, e, !1)
      },
      _getDesktopActiveParentDropdown: function() {
        return this.elements.desktopNavigation.querySelector("".concat(selectors$7.dropdownParent).concat(selectors$7.dropdownParentType("main"), '[aria-expanded="true"]'))
      },
      _onDropdownParentHover: function(e) {
        var t = e.currentTarget;
        "main" === t.dataset.dropdownParentType && t.closest(selectors$7.menuNavigationType("desktop")) && (e.stopImmediatePropagation(), this._onBodyClick());
        var n = Array.from(t.parentElement.querySelectorAll(selectors$9.mediaImages));
        this._setupDropdowns(n), this._toggleMenuDropdown(t)
      },
      _onDropdownParentClick: function(e) {
        var t = e.currentTarget;
        "main" === t.parentElement.dataset.dropdownParentType && t.parentElement.closest(selectors$7.menuNavigationType("desktop")) && (e.stopImmediatePropagation(), this._onBodyClick());
        var n = Array.from(t.parentElement.querySelectorAll(selectors$9.mediaImages));
        this._setupDropdowns(n), this._toggleMenuDropdown(t.parentElement)
      },
      _setupDropdowns: function(e) {
        var t = this;
        e.forEach(function(e, n) {
          e.dataset.maxHeight || (0 === n && e.closest(selectors$7.menuNavigationType("desktop")) ? t._setupMainLevelDropdown(e) : t._setupChildAndMobileDropdown(e))
        })
      },
      _setupMainLevelDropdown: function(e) {
        e.style.whiteSpace = "nowrap";
        var t = e.getBoundingClientRect(),
          n = t.width,
          i = t.height;
        e.style.removeProperty("white-space"), e.dataset.maxHeight = "".concat(n < 260 ? i : e.getBoundingClientRect().height, "px")
      },
      _setupChildAndMobileDropdown: function(e) {
        e.dataset.maxHeight = `${e.getBoundingClientRect().height+40}px`, e.style.maxHeight = "0px"
      },
      _toggleMenuDropdown: function(e) {
        var t = "true" === e.getAttribute("aria-expanded"),
          n = e.getElementsByTagName("ul")[0];
        t ? this._animateDropdownClosed(n, e) : this._animateDropdownOpen(n, e)
      },
      _animateDropdownClosed: function(e, t) {
        var n = e.closest(selectors$7.menuNavigationType("desktop")),
          i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
          r = "main" === t.dataset.dropdownParentType;
        r ? (t.classList.remove(classes$7.menuNavigationItemIsExpanded), n && this.elements.mainContent.classList.remove("blur"), this.isFixed || this.scrolledPastHeader || n && this.elements.headerWrapper.classList.remove("fill"), e.closest(selectors$7.menuNavigationType("desktop")) && e.removeEventListener("focusout", this.eventHandlers.onDropdownFocusOut)) : t.classList.remove(classes$7.menuDropdownItemIsExpanded), n || (e.style.maxHeight = "0px"), e.style.opacity = 0, i ? (promiseTransitionEnd(e).then(function() {}), this._closeDropdown(t, e, r)) : this._closeDropdown(t, e, r)
      },
      _closeDropdown: function(e, t, n) {
        e.setAttribute("aria-expanded", "false"), n && t.closest(selectors$7.menuNavigationType("desktop")) && (this._getDesktopActiveParentDropdown() || (this.elements.menuNavigation.style.overflow = "hidden", this.elements.menuNavigation.classList.remove("sub-menu-open"), this.menuOpen = !1, this._toogleHeaderColor(), e.parentElement.classList.remove(classes$7.menuNavigationItemIsExpanded), this.elements.mainContent.classList.remove("blur")), document.body.removeEventListener("click", this.eventHandlers.onBodyClick), t.removeEventListener("click", this._preventDropdownClick), e.parentNode.removeEventListener("keyup", this.eventHandlers.onDropdownKeyup))
      },
      _animateDropdownOpen: function(e, t) {
        var n = this,
          i = "main" === t.dataset.dropdownParentType,
          r = t.closest(selectors$7.menuNavigationType("desktop"));
        i ? (r && (this.elements.menuNavigation.style.overflow = "initial"), this.elements.menuNavigation.classList.add("sub-menu-open"), this.menuOpen = !0, this._toogleHeaderColor(), t.parentElement.classList.add(classes$7.menuNavigationItemIsExpanded), t.classList.add(classes$7.menuNavigationItemIsExpanded), r && n.elements.headerWrapper.classList.add("fill"), r && this.elements.mainContent.classList.add("blur"), r && e.addEventListener("focusout", this.eventHandlers.onDropdownFocusOut)) : t.classList.add(classes$7.menuDropdownItemIsExpanded), t.setAttribute("aria-expanded", "true"), r || (e.style.maxHeight = `${e.dataset.maxHeight}`), e.style.opacity = 1, r && i && promiseTransitionEnd(e).then(function() {
          document.body.addEventListener("click", n.eventHandlers.onBodyClick), e.addEventListener("click", n._preventDropdownClick), t.parentNode.addEventListener("keyup", n.eventHandlers.onDropdownKeyup)
        })
      },
      _onDropdownKeyup: function(e) {
        if (e.key.toLowerCase() === keyCodes.ESC) {
          var t = e.currentTarget.querySelector(selectors$7.dropdownParentType("main")),
            n = t.nextElementSibling;
          this._animateDropdownClosed(n, t), t.focus()
        }
      },
      _preventDropdownClick: function(e) {
        e.stopImmediatePropagation()
      },
      _onBodyClick: function() {
        var e = this._getDesktopActiveParentDropdown();
        if (e) {
          var t = e.getElementsByTagName("ul")[0];
          this._animateDropdownClosed(t, e)
        }
      },
      _handleMobileNavigation: function(e) {
        var t = e.currentTarget;
        "true" === t.getAttribute("aria-expanded") ? (this._closeMobileNavigation(), this.scrolledPastHeader || this.elements.headerWrapper.classList.remove("fill")) : (this._openMobileNavigation(t), this.scrolledPastHeader || this.elements.headerWrapper.classList.contains("fill") || this.elements.headerWrapper.classList.add("fill"), this.stickyHeaderTimeout && clearTimeout(this.stickyHeaderTimeout), this.lastScrollDirection = "none")
      },
      _closeMobileNavigation: function() {
        var e = this;
        this._toggleHeaderIcons(), this.elements.headerButtons.length && this.elements.headerButtons.forEach(function(t) {
          return t.removeEventListener("click", e.eventHandlers.handleMultiplePopups)
        }), document.removeEventListener("keyup", this.eventHandlers.onDrawerNavigationKeyup), document.removeEventListener("focusin", this._onBodyFocusIn), this.elements.drawerNavigationPopup.closePopup(!1)
      },
      _openMobileNavigation: function(e) {
        var t = this;
        this.elements.drawerNavigationPopup = this.elements.drawerNavigationPopup || window.popups.find(function(e) {
          return e.name === popups.menuNavigation
        }), this.elements.headerButtons = this.elements.headerButtons || this.elements.headerIcons.filter(function(e) {
          return e.hasAttribute(attributes.popupOpen)
        }), this._setupMobileNavigationDropdowns(), this._setMobileDrawerHeight(), this._toggleHeaderIcons(!0), this.elements.headerButtons.length && this.elements.headerButtons.forEach(function(e) {
          return e.addEventListener("click", t.eventHandlers.handleMultiplePopups)
        }), document.addEventListener("keyup", this.eventHandlers.onDrawerNavigationKeyup), document.addEventListener("focusin", this._onBodyFocusIn), this.elements.drawerNavigationPopup.openPopup({
          currentTarget: e
        })
      },
      _onBodyFocusIn: function(e) {
        var t = e.target;
        (t.hasAttribute(attributes.headerIcon) || t.hasAttribute(attributes.menuNavigationToggle) || t.hasAttribute(attributes.headerLogo)) && e.stopImmediatePropagation()
      },
      _setupMobileNavigationDropdowns: function() {
        var e = this;
        this.elements.mobileNavigation || (this.elements.mobileNavigation = this.elements.headerWrapper.querySelector(selectors$7.menuNavigationType("mobile")), this.elements.mobileMenuParents = this.elements.mobileNavigation.querySelectorAll(selectors$7.dropdownParent), this.elements.mobileMenuParents.forEach(function(t) {
          return e._setupDropdowns(t.parentElement.querySelectorAll(selectors$7.dropdownMenu))
        }))
      },
      _setMobileDrawerHeight: function() {
        this.elements.mobileNavigationContainer = this.elements.mobileNavigationContainer || this.elements.headerWrapper.querySelector(selectors$7.mobileNavigationContainer), this.elements.mobileNavigationDrawer = this.elements.mobileNavigationDrawer || this.elements.headerWrapper.querySelector(selectors$7.mobileNavigationDrawer);
        var e = this.elements.headerWrapper.getBoundingClientRect().height,
          t = e - window.pageYOffset;
        this.elements.mobileNavigationDrawer.style.top = "".concat(e, "px"), this.elements.mobileNavigationContainer.style.height = "calc(100vh - ".concat(t, "px)")
      },
      _toggleHeaderIcons: function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        this.mqlSmall.matches
      },
      _handleMultiplePopups: function(e) {
        var t = this;
        this.elements.popups = this.elements.popups || {};
        var n = e.currentTarget.hasAttribute(attributes.searchToggle) ? popups.search : popups.cart;
        this.elements.popups[n] = this.elements.popups[n] || window.popups.find(function(e) {
          return e.name === n
        });
        var i = this.elements.popups[n].getElements();
        n === popups.search ? this._closeMobileNavigation() : promiseTransitionEnd(i.popup).then(function() {
          t._closeMobileNavigation()
        })
      },
      _onDrawerNavigationKeyup: function(e) {
        this._toggleHeaderIcons(), document.removeEventListener("keyup", this.eventHandlers.onDrawerNavigationKeyup)
      },
      _prepareStickyHeader: function() {
        this.featuredCollections = {}, this.previousScrollPosition = window.pageYOffset, this.headerWrapperHeight = this.elements.headerWrapper.offsetHeight, this.originalHeaderHeight = this.elements.header.offsetHeight, this._setupHeaderObserver(), this.headerObserver.observe(this.elements.headerSentinel)
      },
      _setupHeaderObserver: function() {
        var e = this;
        this.headerObserver = new IntersectionObserver(function(t) {
          t[0].isIntersecting ? (e._resetSentinel(), e.scrolledPastHeader = !1, e._toggleInlineMenuOpacity(), requestAnimationFrame(function() {
            e._resetHeader()
          }), e.menuOpen || e.elements.headerWrapper.classList.remove("fill")) : (e.scrolledPastHeader = !0, promiseTransitionEnd(e.elements.headerWrapper).then(function() {
            e._toggleInlineMenuOpacity(), e.drawerMenuIsActive = !0
          }), e.elements.headerWrapper.classList.contains("fill") || e.elements.headerWrapper.classList.add("fill"), e._moveSentinel())
        })
      },
      _toogleHeaderColor: function() {
        window.pageYOffset
      },
      _toggleHeaderPosition: function() {
        var e = this;
        if (!this.isHeaderAnimating && !this.doNotSlideHeaderIn) {
          var t = window.pageYOffset,
            n = t < this.previousScrollPosition ? "up" : "down";
          if (this.previousScrollPosition = t, this.scrolledPastHeader && this.lastScrollDirection !== n)
            if (this.lastScrollDirection = n, "down" === n) this.elements.menuNavigation && this._closeActiveDropdown(), e.isFixed ? requestAnimationFrame(function() {
              e._headerSlideOut()
            }) : this.elements.headerLogo && this.elements.headerLogo.style.removeProperty("transition");
            else {
              if (e.isFixed) return;
              requestAnimationFrame(function() {
                e._headerSlideIn()
              })
            }
        }
      },
      _productAddedToCart: function(e) {
        var t = this;
        this.isFixed || this._headerSlideIn(), this.cartPopup = this.cartPopup || window.popups.find(function(e) {
          return "cart" === e.name
        }), this.cartPopup.openPopup({}), clearTimeout(this.stickyHeaderTimeout), this.stickyHeaderTimeout = setTimeout(function() {
          t._headerSlideOut()
        }, 5e3)
      },
      _preventHeaderSlideIn: function() {
        var e = this;
        this.doNotSlideHeaderIn = !0, this.isFixed && this._headerSlideOut(), this.lastScrollDirection = null, this.preventHeaderSlideInTimeout = setTimeout(function() {
          e.doNotSlideHeaderIn = !1, e.previousScrollPosition = window.pageYOffset
        })
      },
      _featuredCollectionSticky: function(e) {
        var t = e.detail,
          n = t.stickyElement,
          i = t.isSticky,
          r = t.container.dataset.sectionId;
        this.featuredCollections[r] = this.featuredCollections[r] || {
          stickyElement: n,
          isSticky: i
        }, this.featuredCollections[r].isSticky = i, this._toggleFeaturedCollectionStyle(this.featuredCollections[r])
      },
      _resetHeader: function() {
        var e = this;
        this.elements.headerSentinel && (this.isFixed = !1, this.isHeaderAnimating = !0, this.pastHeaderSentinel = !0, this.elements.menuNavigation && (this.elements.headerLogo ? promiseTransitionEnd(this.elements.headerLogo).then(function() {
          e._handleMenuNavigationWidth()
        }) : this._handleMenuNavigationWidth()), this._toggleBodyClass(), this.featuredCollections && (Object.keys(this.featuredCollections).forEach(function(t) {
          var n = e.featuredCollections[t];
          n.stickyElement.style.transform = "translateY(0)", n.stickyElement.style.removeProperty("transition")
        }), this.isHeaderAnimating = !1))
      },
      _headerSlideIn: function() {
        var e = this;
        this.isFixed = !0, this.isHeaderAnimating = !0, this.drawerMenuIsActive = !0, this._toggleBodyClass(), requestAnimationFrame(function() {
          e._checkForFeaturedCollection()
        }), promiseTransitionEnd(this.elements.headerWrapper).then(function() {
          e.elements.headerLogo && (e.elements.headerLogo.style.transition = "max-width 0.25s ease-out"), e.isHeaderAnimating = !1
        })
      },
      _headerSlideOut: function() {
        this.isFixed = !0, this.isHeaderAnimating = !0, this._toggleBodyClass(), this.elements.headerLogo && this.elements.headerLogo.style.removeProperty("transition"), promiseTransitionEnd(this.elements.headerWrapper).then(function() {}), this._checkForFeaturedCollection()
      },
      _moveSentinel: function() {},
      _resetSentinel: function() {
        this.elements.headerSentinel.style.removeProperty("transform")
      },
      _toggleBodyClass: function() {
        document.body.classList.toggle(classes$7.bodyWithStickyHeader, this.isFixed)
      },
      _toggleInlineMenuOpacity: function() {
        this.elements.menuNavigation && this.drawerMenuIsActive
      },
      _checkForFeaturedCollection: function() {
        var e = this;
        this.featuredCollections && Object.keys(this.featuredCollections).forEach(function(t) {
          var n = e.featuredCollections[t];
          e._toggleFeaturedCollectionStyle(n)
        })
      },
      _toggleFeaturedCollectionStyle: function(e) {
        this.isFixed && e.isSticky ? (e.stickyElement.style.transition = "transform .25s ease-out", e.stickyElement.style.transform = "translateY(".concat(this.elements.header.offsetHeight, "px)")) : (e.stickyElement.style.transform = "translateY(0)", promiseTransitionEnd(e.stickyElement).then(function() {
          e.stickyElement.style.removeProperty("transition")
        }))
      },
      onUnload: function() {
        var e = this;
        window.removeEventListener("scroll", this.eventHandlers.toggleHeaderStyle, this.eventHandlers.toggleHeaderSticky, {
          passive: !0
        }), document.removeEventListener("productAddedToCart", this.eventHandlers.productAddedToCart), document.removeEventListener("featuredCollectionTabClicked", this.eventHandlers.preventHeaderSlideIn), document.removeEventListener("elementSticky", this.eventHandlers.featuredCollectionSticky), this.headerObserver && this.headerObserver.disconnect(), this.elements.menuNavigation && (this.elements.dropdownParents.forEach(function(t) {
          return t.removeEventListener("click", e.eventHandlers.onDropdownParentClick)
        }), window.removeEventListener("resize", this.eventHandlers.onWindowResize), this.elements.mobileNavigationToggle.removeEventListener("click", this.eventHandlers.handleMobileNavigation))
      }
    });
    var selectors$9 = {
        mediaArrowPrev: "[data-media-arrow-previous]",
        mediaArrowNext: "[data-media-arrow-next]",
        mediaCurrent: "[data-media-current]",
        mediaImages: "[data-media-image]",
        mediaLiveRegion: "[data-media-liveregion]",
        strip: "[data-media-strip]",
        mediaIndicatorLabel: "[data-media-indicator-label]",
        mediaWrapper: "[data-media-wrapper]",
        mediaStripWrapper: "[data-media-strip-wrapper]"
      },
      classes$8 = {
        isActive: "is-active",
        transitionReady: "transition-ready"
      },
      Gallery = function() {
        "use strict";

        function e(t) {
          _classCallCheck(this, e), this.elements = {
            container: t
          }, this.navigationOnClick = Boolean(this.elements.container.dataset.mediaClickNav)
        }
        return _createClass(e, [{
          key: "init",
          value: function() {
            var e = this;
            Object.assign(this.elements, this.getElements()), this.eventHandlers = this.setupEventHandlers(), this.bindEvents(), this.state = this.setInitialState(), this.setIndicatorLabel(), this.hideMedia(), this.applyTransformation(), window.setTimeout(function() {
              return e.enableTransition()
            }), this.preloadAdjacentImages()
          }
        }, {
          key: "getElements",
          value: function() {
            return {
              arrowNext: this.elements.container.querySelector(selectors$9.mediaArrowNext),
              arrowPrev: this.elements.container.querySelector(selectors$9.mediaArrowPrev),
              currentIndex: this.elements.container.querySelector(selectors$9.mediaCurrent),
              images: Array.from(this.elements.container.querySelectorAll(selectors$9.mediaImages)),
              liveRegionContent: this.elements.container.querySelector(selectors$9.mediaLiveRegion),
              galleryIndicator: this.elements.container.querySelector(selectors$9.mediaIndicatorLabel),
              mediaWrapper: this.elements.container.querySelectorAll(selectors$9.mediaWrapper),
              mediaStripWrapper: this.elements.container.querySelector(selectors$9.mediaStripWrapper)
            }
          }
        }, {
          key: "setupEventHandlers",
          value: function() {
            return {
              onArrowClick: this.onArrowClick.bind(this),
              onKeyUp: this.onKeyUp.bind(this),
              onImageClick: this.onImageClick.bind(this)
            }
          }
        }, {
          key: "bindEvents",
          value: function() {
            var e = this;
            [this.elements.arrowNext, this.elements.arrowPrev].forEach(function(t) {
              t.addEventListener("click", e.eventHandlers.onArrowClick)
            }), this.elements.container.addEventListener("keyup", this.eventHandlers.onKeyUp), this.navigationOnClick && this.elements.images.forEach(function(t) {
              t.addEventListener("click", e.eventHandlers.onImageClick)
            })
          }
        }, {
          key: "destroy",
          value: function() {
            var e = this;
            [this.elements.arrowNext, this.elements.arrowPrev].forEach(function(t) {
              t.removeEventListener("click", e.eventHandlers.onArrowClick)
            }), this.elements.container.removeEventListener("keyup", this.eventHandlers.onKeyUp), this.elements.images.forEach(function(t) {
              t.removeEventListener("click", e.eventHandlers.onImageClick)
            })
          }
        }, {
          key: "setInitialState",
          value: function() {
            var e = this.elements.images.find(function(e) {
              return e.classList.contains(classes$8.isActive)
            });
            return {
              activeMediaImage: e,
              mediaId: Number(e.dataset.mediaId),
              mediaIndex: Number(e.dataset.mediaIndex),
              activeMediaTotalImages: this.elements.images.length,
              useAriaHidden: !0
            }
          }
        }, {
          key: "onArrowClick",
          value: function(e) {
            e.preventDefault(), this.state.isNext = "mediaArrowNext" in e.currentTarget.dataset, this.goToAdjacentMedia()
          }
        }, {
          key: "onKeyUp",
          value: function(e) {
            e.key.toLowerCase() !== keyCodes.LEFT && e.key.toLowerCase() !== keyCodes.RIGHT || (e.preventDefault(), this.state.isNext = e.key.toLowerCase() === keyCodes.RIGHT, this.goToAdjacentMedia())
          }
        }, {
          key: "onImageClick",
          value: function(e) {
            var t = e.currentTarget.dataset.mediaIndex,
              n = this.elements.images.find(function(e) {
                return e.classList.contains(classes$8.isActive)
              }).dataset.mediaIndex;
            this.state.isNext = t > n, t !== n && this.goToAdjacentMedia()
          }
        }, {
          key: "goToAdjacentMedia",
          value: function() {
            this.setMediaIndex(), this.setActiveMedia("mediaIndex"), this.state.mediaId = Number(this.state.activeMediaImage.dataset.mediaId), this.renderGallery()
          }
        }, {
          key: "variantMediaSwitch",
          value: function(e) {
            e !== this.state.mediaId && (this.state.mediaId = e, this.setActiveMedia("mediaId"), this.state.mediaIndex = Number(this.state.activeMediaImage.dataset.mediaIndex), this.renderGallery())
          }
        }, {
          key: "cacheElement",
          value: function(e) {
            this.elements[e] = this.elements[e] || this.elements.container.querySelector(selectors$9[e])
          }
        }, {
          key: "setActiveMedia",
          value: function(e) {
            var t = this;
            this.state.activeMediaImage = this.elements.images.find(function(n) {
              return Number(n.dataset[e]) === t.state[e]
            })
          }
        }, {
          key: "setMediaIndex",
          value: function() {
            this.state.mediaIndex = this.state.isNext ? this.nextImage() : this.previousImage()
          }
        }, {
          key: "nextImage",
          value: function() {
            return this.state.mediaIndex === this.state.activeMediaTotalImages ? 1 : this.state.mediaIndex + 1
          }
        }, {
          key: "previousImage",
          value: function() {
            return 1 === this.state.mediaIndex ? this.state.activeMediaTotalImages : this.state.mediaIndex - 1
          }
        }, {
          key: "preloadAdjacentImages",
          value: function() {
            var e = this;
            this.elements.images.filter(function(t) {
              return [e.nextImage(), e.previousImage()].includes(Number(t.dataset.mediaIndex))
            }).forEach(function(t) {
              return e.loadImage(t)
            })
          }
        }, {
          key: "applyActiveClass",
          value: function() {
            this.state.activeMediaImage.classList.add(classes$8.isActive), this.loadImage(this.state.activeMediaImage)
          }
        }, {
          key: "hideMedia",
          value: function() {
            this.state.useAriaHidden && this.elements.images.forEach(function(e) {
              var t = e.closest(selectors$9.mediaWrapper),
                n = t.querySelectorAll("button, a");
              if (!e.classList.contains(classes$8.isActive)) return e.closest(selectors$9.mediaWrapper).setAttribute("aria-hidden", "true"), void n.forEach(function(e) {
                return e.setAttribute("tabindex", "-1")
              });
              t.removeAttribute("aria-hidden"), n.forEach(function(e) {
                return e.removeAttribute("tabindex")
              })
            })
          }
        }, {
          key: "getIndicatorText",
          value: function() {
            return this.elements.liveRegionContent.dataset.mediaLiveregionMessage.replace("[index]", this.state.mediaIndex).replace("[indexTotal]", this.state.activeMediaTotalImages)
          }
        }, {
          key: "setIndicatorLabel",
          value: function() {
            var e = this.getIndicatorText();
            this.elements.galleryIndicator.setAttribute("aria-label", e)
          }
        }, {
          key: "updateLiveRegion",
          value: function() {
            var e = this,
              t = this.getIndicatorText();
            this.elements.liveRegionContent.setAttribute("aria-hidden", !1), this.elements.liveRegionContent.textContent = t, setTimeout(function() {
              e.elements.liveRegionContent.setAttribute("aria-hidden", !0)
            }, 2e3)
          }
        }, {
          key: "loadImage",
          value: function(e) {
            e.getAttribute("src") || "IMG" !== e.tagName || e.setAttribute("src", e.dataset.src), e.getAttribute("srcset") || "IMG" !== e.tagName || e.setAttribute("srcset", e.dataset.srcset)
          }
        }, {
          key: "clearActiveClasses",
          value: function() {
            this.elements.images.forEach(function(e) {
              return e.classList.remove(classes$8.isActive)
            })
          }
        }, {
          key: "renderCurrentIndex",
          value: function() {
            this.elements.currentIndex.textContent = this.state.mediaIndex
          }
        }, {
          key: "enableTransition",
          value: function() {
            this.cacheElement("strip"), this.elements.strip.classList.add(classes$8.transitionReady)
          }
        }, {
          key: "applyTransformation",
          value: function() {
            this.cacheElement("strip");
            var e = 100 * (this.state.mediaIndex - 1);
            this.elements.strip.style.transform = "translateX(-".concat(e, "%)")
          }
        }, {
          key: "resetTransformation",
          value: function() {
            this.cacheElement("strip"), this.elements.strip.classList.remove(classes$8.transitionReady), this.elements.strip.style.transform = "translateX(0)"
          }
        }, {
          key: "addAccessibilityAttr",
          value: function() {
            this.elements.container.setAttribute("aria-roledescription", theme.strings.mediaCarousel), this.elements.container.setAttribute("aria-label", this.elements.container.dataset.label), this.elements.mediaStripWrapper.setAttribute("aria-live", "polite"), this.elements.mediaWrapper.forEach(function(e) {
              e.setAttribute("role", "group"), e.setAttribute("aria-roledescription", theme.strings.mediaSlide), e.setAttribute("aria-label", e.dataset.mediaLabel)
            })
          }
        }, {
          key: "removeAccessibilityAttr",
          value: function() {
            this.elements.container.removeAttribute("aria-roledescription"), this.elements.container.removeAttribute("aria-label"), this.elements.mediaWrapper.forEach(function(e) {
              e.removeAttribute("aria-roledescription"), e.removeAttribute("aria-label"), e.removeAttribute("role")
            }), this.elements.images.forEach(function(e) {
              e.closest(selectors$9.mediaWrapper).removeAttribute("aria-hidden")
            }), this.elements.mediaStripWrapper.removeAttribute("aria-live")
          }
        }, {
          key: "renderGallery",
          value: function() {
            this.clearActiveClasses(), this.applyActiveClass(), this.hideMedia(), this.applyTransformation(), this.renderCurrentIndex(), this.setIndicatorLabel(), this.updateLiveRegion(), this.preloadAdjacentImages()
          }
        }]), e
      }();

    function Listeners() {
      this.entries = []
    }

    function getVariantFromSerializedArray(e, t) {
      return _validateProductStructure(e), getVariantFromOptionArray(e, _createOptionArrayFromOptionCollection(e, t))
    }

    function getVariantFromOptionArray(e, t) {
      return _validateProductStructure(e), _validateOptionsArray(t), e.variants.filter(function(e) {
        return t.every(function(t, n) {
          return e.options[n] === t
        })
      })[0] || null
    }

    function _createOptionArrayFromOptionCollection(e, t) {
      _validateProductStructure(e), _validateSerializedArray(t);
      var n = [];
      return t.forEach(function(t) {
        for (var i = 0; i < e.options.length; i++)
          if (e.options[i].name.toLowerCase() === t.name.toLowerCase()) {
            n[i] = t.value;
            break
          }
      }), n
    }

    function _validateProductStructure(e) {
      if ("object" !== _typeof(e)) throw new TypeError(e + " is not an object.");
      if (0 === Object.keys(e).length && e.constructor === Object) throw new Error(e + " is empty.")
    }

    function _validateSerializedArray(e) {
      if (!Array.isArray(e)) throw new TypeError(e + " is not an array.");
      if (0 === e.length) return [];
      if (!e[0].hasOwnProperty("name")) throw new Error(e[0] + "does not contain name key.");
      if ("string" != typeof e[0].name) throw new TypeError("Invalid value type passed for name of option " + e[0].name + ". Value should be string.")
    }

    function _validateOptionsArray(e) {
      if (Array.isArray(e) && "object" === _typeof(e[0])) throw new Error(e + "is not a valid array of options.")
    }
    Listeners.prototype.add = function(e, t, n) {
      this.entries.push({
        element: e,
        event: t,
        fn: n
      }), e.addEventListener(t, n)
    }, Listeners.prototype.removeAll = function() {
      this.entries = this.entries.filter(function(e) {
        return e.element.removeEventListener(e.event, e.fn), !1
      })
    };
    var selectors$11 = {
      idInput: '[name="id"]',
      optionInput: '[name^="options"]',
      quantityInput: '[name="quantity"]',
      propertyInput: '[name^="properties"]'
    };

    function ProductForm$1(e, t, n) {
      this.element = e, this.product = _validateProductObject(t), n = n || {}, this._listeners = new Listeners, this._listeners.add(this.element, "submit", this._onSubmit.bind(this, n)), this.optionInputs = this._initInputs(selectors$11.optionInput, n.onOptionChange), this.quantityInputs = this._initInputs(selectors$11.quantityInput, n.onQuantityChange), this.propertyInputs = this._initInputs(selectors$11.propertyInput, n.onPropertyChange)
    }

    function _serializeOptionValues(e, t) {
      return e.reduce(function(e, n) {
        return (n.checked || "radio" !== n.type && "checkbox" !== n.type) && e.push(t({
          name: n.name,
          value: n.value
        })), e
      }, [])
    }

    function _serializePropertyValues(e, t) {
      return e.reduce(function(e, n) {
        return (n.checked || "radio" !== n.type && "checkbox" !== n.type) && (e[t(n.name)] = n.value), e
      }, {})
    }

    function _validateProductObject(e) {
      if ("object" !== _typeof(e)) throw new TypeError(e + " is not an object.");
      if (void 0 === e.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from null or from the http://[your-product-url].js route");
      return e
    }
    ProductForm$1.prototype.destroy = function() {
      this._listeners.removeAll()
    }, ProductForm$1.prototype.options = function() {
      return _serializeOptionValues(this.optionInputs, function(e) {
        return e.name = /(?:^(options\[))(.*?)(?:\])/.exec(e.name)[2], e
      })
    }, ProductForm$1.prototype.variant = function() {
      return getVariantFromSerializedArray(this.product, this.options())
    }, ProductForm$1.prototype.properties = function() {
      var e = _serializePropertyValues(this.propertyInputs, function(e) {
        return /(?:^(properties\[))(.*?)(?:\])/.exec(e)[2]
      });
      return 0 === Object.entries(e).length ? null : e
    }, ProductForm$1.prototype.quantity = function() {
      return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1
    }, ProductForm$1.prototype._setIdInputValue = function(e) {
      var t = this.element.querySelector(selectors$11.idInput);
      t || ((t = document.createElement("input")).type = "hidden", t.name = "id", this.element.appendChild(t)), t.value = e.toString()
    }, ProductForm$1.prototype._onSubmit = function(e, t) {
      t.dataset = this._getProductFormEventData(), t.dataset.variant && this._setIdInputValue(t.dataset.variant.id), e.onFormSubmit && e.onFormSubmit(t)
    }, ProductForm$1.prototype._onFormEvent = function(e) {
      return void 0 === e ? Function.prototype : function(t) {
        t.dataset = this._getProductFormEventData(), e(t)
      }.bind(this)
    }, ProductForm$1.prototype._initInputs = function(e, t) {
      return Array.prototype.slice.call(this.element.querySelectorAll(e)).map(function(e) {
        return this._listeners.add(e, "change", this._onFormEvent(t)), e
      }.bind(this))
    }, ProductForm$1.prototype._getProductFormEventData = function() {
      return {
        options: this.options(),
        variant: this.variant(),
        properties: this.properties(),
        quantity: this.quantity()
      }
    };
    var attributes$1 = {
        dataQuantitySelectorIncrease: "data-quantity-selector-increase"
      },
      selectors$10 = {
        addToCart: "[data-add-to-cart]",
        addToCartText: "[data-add-to-cart-text]",
        cartCountBubble: "[data-cart-count-bubble]",
        cartCount: "[data-cart-count]",
        cartPriceBubble: "[data-cart-price-bubble]",
        errorMessageWrapper: "[data-error-message-wrapper]",
        errorMessage: "[data-error-message]",
        price: "[data-price]",
        productForm: "[data-product-form]",
        productJSON: "[data-product-json]",
        productMasterSelect: "[data-product-master-select]",
        productPolicies: "[data-product-policies]",
        regularPrice: "[data-regular-price]",
        productSuccessMessage: "[data-product-success-message]",
        productStatus: "[data-product-status]",
        salePrice: "[data-sale-price]",
        unitPrice: "[data-unit-price]",
        unitPriceBaseUnit: "[data-unit-price-base-unit]",
        quantityInput: "[data-quantity-input]",
        quantityInputWrapper: "[data-quantity-input-wrapper]",
        quantitySelectors: "[data-quantity-selector]",
        quantitySelectorIncrease: "[data-quantity-selector-increase]"
      },
      classes$9 = {
        hidden: "hidden",
        formInputError: "form__input-wrapper--error",
        productOnSale: "price--on-sale",
        productSoldOut: "price--sold-out",
        productUnitAvailable: "price--unit-available",
        productUnavailable: "price--unavailable",
        visuallyHidden: "visually-hidden"
      },
      ProductForm$$1 = function() {
        "use strict";

        function e(t) {
          _classCallCheck(this, e), this.elements = {
            container: t
          }
        }
        return _createClass(e, [{
          key: "init",
          value: function() {
            var e = this;
            if (this.eventHandlers = {}, Object.assign(this.elements, this._getElements()), this.elements.productForm)
              if (this.productId = this.elements.productForm.dataset.productId, this.elements.productJSON) {
                var t = JSON.parse(this.elements.productJSON.innerHTML);
                this._initProductForm(t)
              } else this._getProductJSON(this.elements.productForm.dataset.productHandle).then(function(t) {
                e._initProductForm(t)
              }).catch(function(e) {
                throw new Error(e)
              })
          }
        }, {
          key: "destroy",
          value: function() {
            var e = this;
            Boolean(this.elements.container.dataset.showQuantitySelector) && (this.elements.quantitySelectors.forEach(function(t) {
              t.removeEventListener("click", e.eventHandlers.onQuantitySelectorClick)
            }), this.hasInstantQuantity && (this.elements.quantityInput.removeEventListener("input", this.eventHandlers.onQuantityInputTextChanged), this.elements.quantityInput.removeEventListener("removedFromCart", this.eventHandlers.onProductRemovedFromCart)))
          }
        }, {
          key: "_hideInstantQuantity",
          value: function() {
            this.hasInstantQuantity && this.elements.quantityInputWrapper && (this.elements.quantityInput.value = 1, this._hideErrorMessage(), this.elements.quantityInputWrapper.classList.add(classes$9.hidden), this.elements.addToCart.classList.remove(classes$9.hidden), this.elements.addToCart.focus())
          }
        }, {
          key: "_initProductForm",
          value: function(e) {
            this.productForm = new ProductForm$1(this.elements.productForm, e, {
              onOptionChange: this._onFormOptionChange.bind(this),
              onFormSubmit: this._onFormSubmit.bind(this),
              onQuantityChange: this._onQuantityChange.bind(this)
            }), this._setupEventListeners()
          }
        }, {
          key: "_getElements",
          value: function() {
            return {
              addToCart: this.elements.container.querySelector(selectors$10.addToCart),
              addToCartText: this.elements.container.querySelector(selectors$10.addToCart),
              cartPriceBubble: document.querySelector(selectors$10.cartPriceBubble),
              errorMessageWrapper: this.elements.container.querySelector(selectors$10.errorMessageWrapper),
              errorMessageElement: this.elements.container.querySelector(selectors$10.errorMessage),
              masterSelect: this.elements.container.querySelector(selectors$10.productMasterSelect),
              productForm: this.elements.container.querySelector(selectors$10.productForm),
              productJSON: this.elements.container.querySelector(selectors$10.productJSON),
              productPolicies: this.elements.container.querySelector(selectors$10.productPolicies),
              productStatus: this.elements.container.querySelector(selectors$10.productStatus),
              priceContainer: this.elements.container.querySelector(selectors$10.price),
              regularPrice: this.elements.container.querySelectorAll(selectors$10.regularPrice),
              salePrice: this.elements.container.querySelector(selectors$10.salePrice),
              successMessage: this.elements.container.querySelector(selectors$10.productSuccessMessage),
              quantityInputWrapper: this.elements.container.querySelector(selectors$10.quantityInputWrapper),
              quantityInput: this.elements.container.querySelector(selectors$10.quantityInput),
              quantitySelectors: this.elements.container.querySelectorAll(selectors$10.quantitySelectors),
              quantitySelectorIncrease: this.elements.container.querySelector(selectors$10.quantitySelectorIncrease),
              unitPrice: this.elements.container.querySelector(selectors$10.unitPrice),
              unitPriceBaseUnit: this.elements.container.querySelector(selectors$10.unitPriceBaseUnit)
            }
          }
        }, {
          key: "_getEventHandlers",
          value: function() {
            var e = this;
            return {
              onProductRemovedFromCart: this._hideInstantQuantity.bind(this),
              onQuantitySelectorClick: this._onQuantitySelectorClick.bind(this),
              onQuantityInputTextChanged: debounce(function() {
                e._updateCartQuantity()
              }, 1e3)
            }
          }
        }, {
          key: "_setupEventListeners",
          value: function() {
            var e = this;
            this.elements.container.dataset.showQuantitySelector && (this.eventHandlers = this._getEventHandlers(), this.hasInstantQuantity = Boolean(this.elements.quantityInputWrapper.dataset.quantityInputInstant), this.elements.quantitySelectors.forEach(function(t) {
              t.addEventListener("click", e.eventHandlers.onQuantitySelectorClick)
            }), this.hasInstantQuantity && (this.elements.quantityInput.addEventListener("input", this.eventHandlers.onQuantityInputTextChanged), this.elements.quantityInput.addEventListener("removedFromCart", this.eventHandlers.onProductRemovedFromCart)))
          }
        }, {
          key: "_getProductJSON",
          value: function(e) {
            var t = "/" === theme.rootUrl ? "" : theme.rootUrl;
            return window.fetch("".concat(t, "/products/").concat(e, ".js")).then(function(e) {
              return e.json()
            })
          }
        }, {
          key: "_onFormSubmit",
          value: function(e) {
            e.preventDefault(), this.elements.container.querySelector(selectors$10.addToCart).hasAttribute("aria-disabled") || this._quantityIsInvalid() || this._addItemToCart()
          }
        }, {
          key: "_quantityIsInvalid",
          value: function() {
            return !(!this.elements.quantityInput || !(parseInt(this.elements.quantityInput.value, 10) <= 0 || "" === this.elements.quantityInput.value)) && (this._showErrorMessage(theme.strings.quantityMinimumMessage), !0)
          }
        }, {
          key: "_showInstantQuantity",
          value: function(e) {
            this.hasInstantQuantity && this.elements.quantityInputWrapper && (this.elements.quantityInput.dataset.quantityInputKey = e.key, this.elements.quantityInput.value = e.quantity, this.elements.addToCart.classList.add(classes$9.hidden), this.elements.quantityInputWrapper.classList.remove(classes$9.hidden), this.elements.quantityInput && this.elements.quantityInput.focus())
          }
        }, {
          key: "_addItemToCart",
          value: function() {
            var e = this;
            this._hideErrorMessage(), this._toggleSuccessMessage(!0), addItemFromForm(this.elements.productForm).then(function(t) {
              e._toggleSuccessMessage(!1, e._getSuccessMessage()), e._showInstantQuantity(t), window.carts.length || e._onCartUpdated(), e.isUpdatingCart = !1, document.dispatchEvent(new CustomEvent("productAddedToCart")), window.carts.forEach(function(t) {
                t.onCartUpdated(e.productId)
              }), theme.cartQuantity.updateQuantityInputElements(t.key, t.quantity);
              var n = e._getQuantityUpdatedText(t.quantity, !0);
              e._updateLiveRegion(n)
            }).catch(function(t) {
              e._handleProductError(t), e.isUpdatingCart = !1
            })
          }
        }, {
          key: "_getSuccessMessage",
          value: function() {
            var e = this.elements.quantityInput ? this.elements.quantityInput.value : 1;
            return parseInt(e, 10) > 1 ? theme.strings.itemAddedToCartMulti : theme.strings.itemAddedToCartSingle
          }
        }, {
          key: "_toggleSuccessMessage",
          value: function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
            this.elements.successMessage && (this.elements.successMessage.textContent = t, this.elements.successMessage.classList.toggle(classes$9.hidden, e))
          }
        }, {
          key: "_onCartUpdated",
          value: function() {
            var e = this;
            getState().then(function(t) {
              e._updateCartPriceBubble(t.total_price), e._updateCartCountBubble(t.item_count), theme.cartQuantity.updateLocalCartState(t, e.productId)
            }).catch(function(e) {
              throw new Error(e)
            })
          }
        }, {
          key: "_updateCartPriceBubble",
          value: function(e) {
            this.elements.cartPriceBubble && (this.elements.cartPriceBubble.innerText = this._formatMoney(e))
          }
        }, {
          key: "_updateCartCountBubble",
          value: function(e) {
            this.cartCountBubbles = this.cartCountBubbles || document.querySelectorAll(selectors$10.cartCountBubble), this.cartCounts = this.cartCounts || document.querySelectorAll(selectors$10.cartCount), this.cartCounts.forEach(function(t) {
              return t.innerText = e > 99 ? "99+" : e
            }), this.cartCountBubbles.forEach(function(t) {
              return t.classList.toggle(classes$9.hidden, 0 === e)
            })
          }
        }, {
          key: "_handleProductError",
          value: function(e) {
            var t = this;
            e.json().then(function(e) {
              var n = e.description ? e.description : theme.strings.cartError;
              t._showErrorMessage(n)
            }).catch(function(e) {
              throw e
            })
          }
        }, {
          key: "_getQuantityErrorMessage",
          value: function(e) {
            return theme.strings.quantityError.replace("[quantity]", e.quantity).replace("[title]", e.title)
          }
        }, {
          key: "_showErrorMessage",
          value: function(e) {
            this.elements.errorMessageElement && this.elements.errorMessageWrapper && (this.elements.errorMessageElement.innerHTML = e, this.elements.errorMessageWrapper.classList.remove(classes$9.hidden), this.elements.errorMessageWrapper.setAttribute("aria-hidden", !0), this.elements.errorMessageWrapper.removeAttribute("aria-hidden"), this.elements.quantityInputWrapper && !this.hasInstantQuantity && this.elements.quantityInputWrapper.classList.add(classes$9.formInputError))
          }
        }, {
          key: "_hideErrorMessage",
          value: function() {
            this.elements.errorMessageWrapper && (this.elements.errorMessageWrapper.classList.add(classes$9.hidden), this.elements.quantityInputWrapper && !this.hasInstantQuantity && this.elements.quantityInputWrapper.classList.remove(classes$9.formInputError))
          }
        }, {
          key: "_onFormOptionChange",
          value: function(e) {
            var t = e.dataset.variant;
            this._updateMasterSelect(t), this._hideErrorMessage(), this._toggleSuccessMessage(!0), this._updatePrice(t), this._updateProductPolicies(t), this._updateAddToCart(t), this._updateVariantName(t), this._hideInstantQuantity();
            var n = this._getVariantUpdatedText(t);
            this._updateLiveRegion(n), this._fireEvent("formOptionChanged", {
              variant: t
            })
          }
        }, {
          key: "_fireEvent",
          value: function(e, t) {
            this.elements.container.dispatchEvent(new window.CustomEvent(e, {
              detail: t
            }))
          }
        }, {
          key: "_updateVariantName",
          value: function(e) {
            e && e.name && (this.elements.productForm.dataset.variantName = e.name)
          }
        }, {
          key: "_updateMasterSelect",
          value: function(e) {
            e && this.elements.masterSelect && (this.elements.masterSelect.value = e.id)
          }
        }, {
          key: "_onQuantityChange",
          value: function() {
            this._hideErrorMessage(), this._toggleSuccessMessage(!0)
          }
        }, {
          key: "_calculateNewInputQuantity",
          value: function(e, t) {
            var n = this.hasInstantQuantity ? 0 : 1,
              i = t ? e + 1 : e - 1;
            return Math.max(n, i)
          }
        }, {
          key: "_onQuantitySelectorClick",
          value: function(e) {
            var t = this;
            if (!this.isUpdatingCart) {
              this._hideErrorMessage();
              var n = e.currentTarget.hasAttribute(attributes$1.dataQuantitySelectorIncrease),
                i = this.elements.container.querySelector(selectors$10.quantityInput),
                r = parseInt(i.value, 10),
                s = this._calculateNewInputQuantity(r, n);
              i.value = s, this.hasInstantQuantity && (clearTimeout(this.timeout), this.timeout = setTimeout(function() {
                t.isUpdatingCart = !0, t._updateCartQuantity()
              }, 500))
            }
          }
        }, {
          key: "_updateCartQuantity",
          value: function() {
            var e = this,
              t = this.elements.quantityInput.dataset.quantityInputKey;
            if (t) {
              var n = _slicedToArray(t.split(":"), 1)[0],
                i = parseInt(this.elements.quantityInput.value, 10);
              updateItem(t, {
                quantity: i
              }).then(function(r) {
                e.isUpdatingCart = !1, window.carts.length || e._onCartUpdated(), window.carts.forEach(function(t) {
                  t.onCartUpdated(e.productId)
                }), theme.cartQuantity.updateQuantityInputElements(t, i);
                var s = e._getQuantityUpdatedText(i);
                e._updateLiveRegion(s), document.dispatchEvent(new CustomEvent("productAddedToCart"));
                var o = r.items.find(function(e) {
                    return e.key === t
                  }),
                  a = r.items.reduce(function(e, t) {
                    return t.id === Number(n) ? e + t.quantity : e
                  }, 0);
                i > a && (e.elements.quantityInput.value = a, e.elements.quantityInput.focus(), e._showErrorMessage(e._getQuantityErrorMessage(o))), i || e._hideInstantQuantity()
              })
            }
          }
        }, {
          key: "_updatePrice",
          value: function(e) {
            if (this.elements.priceContainer) {
              if (this.elements.priceContainer.classList.remove(classes$9.productUnavailable, classes$9.productOnSale, classes$9.productUnitAvailable, classes$9.productSoldOut), this.elements.priceContainer.removeAttribute("aria-hidden"), !e) return this.elements.priceContainer.classList.add(classes$9.productUnavailable), void this.elements.priceContainer.setAttribute("aria-hidden", !0);
              e.available || this.elements.priceContainer.classList.add(classes$9.productSoldOut), e.compare_at_price > e.price ? this._renderOnSalePrice(e) : this._renderRegularPrice(e), this._updateUnitPrice(e)
            }
          }
        }, {
          key: "_renderOnSalePrice",
          value: function(e) {
            var t = this;
            this.elements.regularPrice.forEach(function(n) {
              n.innerText = t._formatMoney(e.compare_at_price)
            }), this.elements.salePrice && (this.elements.salePrice.innerText = this._formatMoney(e.price), this.elements.priceContainer.classList.add(classes$9.productOnSale))
          }
        }, {
          key: "_renderRegularPrice",
          value: function(e) {
            var t = this;
            this.elements.regularPrice.forEach(function(n) {
              n.innerText = t._formatMoney(e.price)
            })
          }
        }, {
          key: "_updateUnitPrice",
          value: function(e) {
            e.unit_price && this.elements.unitPrice && this.elements.unitPriceBaseUnit && (this.elements.unitPrice.innerText = this._formatMoney(e.unit_price, theme.moneyFormat), this.elements.unitPriceBaseUnit.innerText = this._getBaseUnit(e), this.elements.priceContainer.classList.add(classes$9.productUnitAvailable))
          }
        }, {
          key: "_getBaseUnit",
          value: function(e) {
            return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit
          }
        }, {
          key: "_updateProductPolicies",
          value: function(e) {
            this.elements.productPolicies && (this.elements.productPolicies.classList.remove(classes$9.visuallyHidden), e || this.elements.productPolicies.classList.add(classes$9.visuallyHidden))
          }
        }, {
          key: "_updateAddToCart",
          value: function(e) {
            this.elements.addToCart && this.elements.addToCartText && (e ? e.available ? (this.elements.addToCart.removeAttribute("aria-disabled"), this.elements.addToCart.setAttribute("aria-label", theme.strings.addToCart)) : (this.elements.addToCart.setAttribute("aria-disabled", !0), this.elements.addToCart.setAttribute("aria-label", theme.strings.soldOut), this.elements.addToCartText.innerText = theme.strings.soldOut) : (this.elements.addToCart.setAttribute("aria-disabled", !0), this.elements.addToCart.setAttribute("aria-label", theme.strings.unavailable), this.elements.addToCartText.innerText = theme.strings.unavailable))
          }
        }, {
          key: "_updateLiveRegion",
          value: function(e) {
            var t = this;
            this.elements.productStatus && (this.elements.productStatus.innerText = e, this.elements.productStatus.setAttribute("aria-hidden", !1), setTimeout(function() {
              t.elements.productStatus.setAttribute("aria-hidden", !0)
            }, 1e3))
          }
        }, {
          key: "_formatMoney",
          value: function(e) {
            return formatMoney(e, theme.moneyFormat)
          }
        }, {
          key: "_getQuantityUpdatedText",
          value: function(e, t) {
            var n = theme.strings.productUpdatedOnCart.replace("[quantity]", e);
            return 0 === e ? n = theme.strings.productRemovedFromCart : 1 === e && t && (n = theme.strings.productAddedToCart), n.replace("[title]", this.elements.productForm.dataset.variantName)
          }
        }, {
          key: "_getVariantUpdatedText",
          value: function(e) {
            if (!e) return theme.strings.unavailable;
            var t = e.compare_at_price > e.price,
              n = e.available ? "" : theme.strings.soldOut,
              i = "",
              r = this._formatMoney(e.price),
              s = "",
              o = "",
              a = "",
              l = "";
            return t && (i = theme.strings.regularPrice, r = this._formatMoney(e.compare_at_price), s = theme.strings.salePrice, o = this._formatMoney(e.price)), e.unit_price && (a = theme.strings.unitPrice, l = "".concat(this._formatMoney(e.unit_price), " ").concat(theme.strings.unitPriceSeparator, " ").concat(this._getBaseUnit(e))), "".concat(n, " ").concat(i, " ").concat(r, " ").concat(s, " ").concat(o, " ").concat(a, " ").concat(l)
          }
        }]), e
      }(),
      selectors$8 = {
        productForm: "[data-product-form]",
        media: "[data-media]",
        singleMedia: "[data-media-image]"
      },
      Product = function() {
        "use strict";

        function e(t) {
          _classCallCheck(this, e), this.container = t, this._prepareGallery(), this.container.querySelector(selectors$8.productForm) && (this._setupEventListeners(), this.productForm = new ProductForm$$1(this.container), this.productForm.init())
        }
        return _createClass(e, [{
          key: "destroy",
          value: function() {
            this.productForm && this.productForm.destroy(), this.container.removeEventListener("formOptionChanged", this.eventHandlers.onFormOptionChange), Boolean(this.gallery) && this.gallery.destroy()
          }
        }, {
          key: "_getEventHandlers",
          value: function() {
            return {
              onFormOptionChange: this._onFormOptionChange.bind(this)
            }
          }
        }, {
          key: "_setupEventListeners",
          value: function() {
            this.eventHandlers = this._getEventHandlers(), this.container.addEventListener("formOptionChanged", this.eventHandlers.onFormOptionChange)
          }
        }, {
          key: "_prepareGallery",
          value: function() {
            if (this.galleryElement = this.container.querySelector(selectors$8.media), this.galleryElement)
              if ("gallery" !== this.container.dataset.mediaType) {
                if (this._addGalleryMediaQueryListener(), this.galleryMediaQueryListener.matches) return this._initializeGallery(), void this.gallery.addAccessibilityAttr();
                this._loadAllGalleryImages()
              } else this._initializeGallery()
          }
        }, {
          key: "_addGalleryMediaQueryListener",
          value: function() {
            var e = this;
            this.galleryMediaQueryListener = window.matchMedia(getMediaQueryString("large", "max")), this.galleryMediaQueryListener.addListener(function(t) {
              t.matches ? e._switchToGalleryMode() : e._switchToStackedMode()
            })
          }
        }, {
          key: "_switchToGalleryMode",
          value: function() {
            var e = this._initializeGallery();
            this.gallery.state.useAriaHidden = !0, this.gallery.hideMedia(), this.gallery.addAccessibilityAttr(), e || this.gallery.bindEvents()
          }
        }, {
          key: "_switchToStackedMode",
          value: function() {
            this._loadAllGalleryImages(), this.gallery.removeAccessibilityAttr(), this.gallery.resetTransformation(), this.gallery.state.useAriaHidden = !1, this.gallery.destroy()
          }
        }, {
          key: "_initializeGallery",
          value: function() {
            var e = this;
            return this.gallery ? (this.gallery.applyTransformation(), window.setTimeout(function() {
              return e.gallery.enableTransition()
            }), !1) : (this.gallery = new Gallery(this.galleryElement), this.gallery.init(), !0)
          }
        }, {
          key: "_loadAllGalleryImages",
          value: function() {
            this.container.querySelectorAll(selectors$8.singleMedia).forEach(function(e) {
              e.getAttribute("src") || e.setAttribute("src", e.getAttribute("data-src")), e.getAttribute("srcset") || e.setAttribute("srcset", e.getAttribute("data-srcset")), e.outerHTML = e.outerHTML
            }), this.gallery && (this.gallery.elements.images = Array.from(this.gallery.elements.container.querySelectorAll(selectors$8.singleMedia)))
          }
        }, {
          key: "_onFormOptionChange",
          value: function(e) {
            var t = e.detail.variant;
            if (t && t.featured_media && this.gallery && (this.gallery.variantMediaSwitch(t.featured_media.id), this.galleryMediaQueryListener)) {
              if (this.galleryMediaQueryListener.matches) return;
              this.gallery.resetTransformation()
            }
          }
        }]), e
      }();
    sections.register("product", {
      onLoad: function() {
        this.product = new Product(this.container), this.mobileGallery = window.innerWidth < 940, this.scents = Array.prototype.slice.call(this.container.querySelectorAll(".scent"), 0), this.scentDesc = Array.prototype.slice.call(this.container.querySelectorAll(".scent-desc"), 0), this.dropdownBtns = Array.prototype.slice.call(this.container.querySelectorAll(".dropdownBTN"), 0), this.dropdowns = Array.prototype.slice.call(this.container.querySelectorAll(".dropdown"), 0), this.productThumbs = Array.prototype.slice.call(this.container.querySelectorAll(".product-thumbnail"), 0), this.productMedia = Array.prototype.slice.call(this.container.querySelectorAll(".gallery-item"), 0), this.curentVideoPlaying = null, this.readMore = Array.prototype.slice.call(this.container.querySelectorAll(".read_more"), 0), this.readMoreDesc = Array.prototype.slice.call(this.container.querySelectorAll(".product__description"), 0), this._setupEventHandlers(), this.mobileGallery && this.initMobileGallery()
      },
      _setupEventHandlers: function() {
        var e = this;
        this.eventHandlers = this._getEventHandlers(), window.addEventListener("resize", e.eventHandlers.productResizeListener), this.scents.forEach(function(t) {
          return t.addEventListener("mouseover", e.eventHandlers.onScentHover)
        }), this.scents.forEach(function(t) {
          return t.addEventListener("mouseleave", e.eventHandlers.onScentLeave)
        }), this.dropdownBtns.forEach(function(t) {
          return t.addEventListener("click", e.eventHandlers.onDropdownClick)
        }), this.productThumbs.forEach(function(t) {
          return t.addEventListener("click", e.eventHandlers.thumbClick)
           }), this.productThumbs.forEach(function(t) {
          return t.addEventListener("keydown", e.eventHandlers.thumbDown)
        }), this.readMore.forEach(function(t) {
          return t.addEventListener("click", e.eventHandlers.onReadMoreClick)
        })
      },
      _getEventHandlers: function() {
        return {
          onScentHover: this.onScentHover.bind(this),
          onScentLeave: this.onScentLeave.bind(this),
          onDropdownClick: this.onDropdownClick.bind(this),
          onReadMoreClick: this.onReadMoreClick.bind(this),
          thumbClick: this.thumbClick.bind(this),
           thumbDown: this.thumbDown.bind(this),
          productResizeListener: this.productResizeListener.bind(this)
        }
      },
      initMobileGallery: function() {
        var e = document.querySelector(".gallery-imgs");
        if (null !== e) {
          var t = new Flickity(e, {
            adaptiveHeight: !0,
            watchCSS: !0,
            pageDots: !0,
            prevNextButtons: !1
          });
          t.on("change", function(e) {
            t.cells.forEach(function(t, n) {
              var i = t.element.querySelector("video");
              i && n == e ? i.play() : i && i.pause()
            })
          })
        }
      },
      onScentHover: function(e) {
        this.scentDesc.forEach(function(e) {
          return e.style.opacity = 0
        }), this.scentDesc.length > 0 && void 0 !== this.scentDesc[e.currentTarget.dataset.scent] && (this.scentDesc[e.currentTarget.dataset.scent].style.opacity = 1)
      },
      onScentLeave: function(e) {
        this.scentDesc.forEach(function(e) {
          return e.style.opacity = 0
        })
      },
      onDropdownClick: function(e) {
        var t = !!e.target.parentElement.classList.contains("active");
        this.dropdowns.forEach(function(e) {
          e.classList.remove("active")
        }), t || e.target.parentElement.classList.add("active")
      },
      onReadMoreClick: function(e) {
        !!this.readMoreDesc[0].classList.contains("active") ? (this.readMoreDesc[0].classList.remove("active"), e.currentTarget.innerHTML = "Read More") : (this.readMoreDesc[0].classList.add("active"), e.currentTarget.innerHTML = "Read Less")
      },
      productResizeListener: function(e) {
        window.innerWidth < 940 && !this.mobileGallery ? (this.initMobileGallery(), this.mobileGallery = !0) : window.innerWidth > 940 && this.mobileGallery && (this.mobileGallery = !1)
      },
      
    

      
      thumbClick: function(e) {
        var t = e.target.getAttribute("data-thumb"),
          n = e.target.getAttribute("data-type");
        if (this.productMedia.forEach(function(e) {
            e.classList.add("hide")
          }), this.productMedia[t].classList.remove("hide"), null !== this.curentVideoPlaying && (this.productMedia.forEach(function(e) {
            var t = e.getElementsByTagName("video")[0];
            void 0 !== t && t.pause()
          }), this.curentVideoPlaying = null), "video" === n) {
          var i = this.productMedia[t].getElementsByTagName("video")[0];
          this.curentVideoPlaying = i, i.play(), i.muted = !1
        }
      },
      
         thumbDown: function(e) {
            if (event.keyCode === 32 || event.keyCode === 13 ) {
        var t = e.target.getAttribute("data-thumb"),
          n = e.target.getAttribute("data-type");
              
        if (this.productMedia.forEach(function(e) {
            e.classList.add("hide")
          }), this.productMedia[t].classList.remove("hide"), null !== this.curentVideoPlaying && (this.productMedia.forEach(function(e) {
            var t = e.getElementsByTagName("video")[0];
            void 0 !== t && t.pause()
          }), this.curentVideoPlaying = null), "video" === n) {
          var i = this.productMedia[t].getElementsByTagName("video")[0];
          this.curentVideoPlaying = i, i.play(), i.muted = !1
        }
               }  
      },
      
      onUnload: function() {
        this.product.destroy()
      }
    }), sections.register("split-page", {
      onLoad: function() {
        this.splitTitles = Array.prototype.slice.call(this.container.querySelectorAll(".split-title"), 0), this.splitDesc = Array.prototype.slice.call(this.container.querySelectorAll(".split-desc"), 0), this.splitImgs = Array.prototype.slice.call(this.container.querySelectorAll(".split-image"), 0), this._setupEventHandlers()
      },
      _setupEventHandlers: function() {
        var e = this;
        this.eventHandlers = this._getEventHandlers(), this.splitTitles.forEach(function(t) {
          return t.addEventListener("click", e.eventHandlers.splitClick)
        })
      },
      _getEventHandlers: function() {
        return {
          splitClick: this.splitClick.bind(this)
        }
      },
      splitClick: function(e) {
        let t = parseInt(e.currentTarget.dataset.number);
        this.splitImgs.forEach(function(e) {
          e.classList.remove("active")
        }), this.splitTitles.forEach(function(e) {
          e.classList.remove("active")
        }), this.splitDesc.forEach(function(e) {
          e.classList.remove("active")
        }), this.splitImgs[t].classList.add("active"), this.splitTitles[t].classList.add("active"), this.splitDesc[t].classList.add("active")
      }
    }), sections.register("split-page-hero", {
      onLoad: function() {
        this.splitCatBtn = Array.prototype.slice.call(this.container.querySelectorAll(".split-page-hero-category"), 0), this.splitContent = Array.prototype.slice.call(this.container.querySelectorAll(".split-hero-content"), 0), this.splitHeroBanners = Array.prototype.slice.call(this.container.querySelectorAll(".split-page-hero-banner-image"), 0), this.splitDropdowns = Array.prototype.slice.call(this.container.querySelectorAll(".split-dropdown"), 0), this._setupEventHandlers()
      },
      _setupEventHandlers: function() {
        var e = this;
        this.eventHandlers = this._getEventHandlers(), this.splitCatBtn.forEach(function(t) {
          return t.addEventListener("click", e.eventHandlers.categoryClick)
        }), this.splitDropdowns.forEach(function(t) {
          return t.addEventListener("click", e.eventHandlers.splitDropDropClick)
        })
      },
      _getEventHandlers: function() {
        return {
          categoryClick: this.categoryClick.bind(this),
          splitDropDropClick: this.splitDropDropClick.bind(this)
        }
      },
      categoryClick: function(e) {
        let t = parseInt(e.currentTarget.dataset.count);
        this.splitHeroBanners.forEach(function(e) {
          e.classList.remove("active")
        }), this.splitCatBtn.forEach(function(e) {
          e.classList.remove("active")
        }), this.splitContent.forEach(function(e) {
          e.classList.remove("active")
        }), this.splitHeroBanners[t].classList.add("active"), this.splitCatBtn[t].classList.add("active"), this.splitContent[t].classList.add("active")
      },
      splitDropDropClick: function(e) {
        var t = !!e.currentTarget.classList.contains("active");
        this.splitDropdowns.forEach(function(e) {
          e.classList.remove("active")
        }), t || e.currentTarget.classList.add("active")
      }
    }), sections.register("testimonials", {
      onLoad: function() {
        this._setupEventHandlers(), this.marquee3k = Array.from(document.querySelectorAll(".marquee3k"))
      },
      _setupEventHandlers: function() {
        this.eventHandlers = this._getEventHandlers(), isIntersectionObserverAvailable() && window.addEventListener("scroll", this.eventHandlers.toggleTestimonials, {
          passive: !0
        })
      },
      _getEventHandlers: function() {
        return {
          toggleTestimonials: this.toggleTestimonials.bind(this)
        }
      },
      toggleTestimonials: function() {
        var e = this.container.querySelector(".testimonials"),
          t = this,
          n = !1;
        this.topObserver = new IntersectionObserver(function(e, i) {
          e.forEach(e => {
            if (e.isIntersecting && !n) {
              n = !0;
              for (var r = 0; r < t.marquee3k.length; r++) "testimonial marquee3k is-init" === t.marquee3k[r].className && Marquee3k.play(r);
              i.unobserve(e.target)
            } else {
              n = !1;
              for (r = 0; r < t.marquee3k.length; r++) "testimonial marquee3k is-init" === t.marquee3k[r].className && Marquee3k.pause(r)
            }
          })
        }), this.topObserver.observe(e)
      }
    }), sections.register("preorder", {
      onLoad: function() {
        this.marquee3k = Array.from(this.container.querySelectorAll(".marquee3k")), setTimeout(function() {
          Marquee3k.playAll()
        }, 500)
      }
    });
    var selectors$14 = {
        productCollectionTitle: "[data-product-collection-title]",
        productImage: "[data-media-image]",
        productRecommendationsContainer: "[product-recommendations-container]",
        productTemplate: "[data-product-template]",
        productViewCartLink: "[data-product-view-cart-link]",
        productCollectionTitleWrapper: "[data-product-collection-title-wrapper]"
      },
      classes$11 = {
        hidden: "hidden",
        isOpen: "is-open",
        productModalContentNoMedia: "product-modal__content--no-media"
      },
      ProductModal = function() {
        "use strict";

        function e(t, n, i) {
          _classCallCheck(this, e), this.elements = {
            productContainer: t,
            productModalContent: n
          }, this.collectionTitle = i || ""
        }
        return _createClass(e, [{
          key: "init",
          value: function() {
            this.eventHandlers = this._getEventHandlers()
          }
        }, {
          key: "setupProductModal",
          value: function(e) {
            var t = this;
            this._getProductModalContent(e).then(function(e) {
              t._setupProductModalContent(e)
            }).catch(function(e) {
              throw new Error(e)
            })
          }
        }, {
          key: "_getEventHandlers",
          value: function() {
            return {
              hideModalShowCart: this._hideModalShowCart.bind(this),
              hideProductModal: this._hideProductModal.bind(this)
            }
          }
        }, {
          key: "_setupEventHandlers",
          value: function() {
            this.elements.productContainer.addEventListener("popup_closed", this.eventHandlers.hideProductModal), this.elements.viewCart = this.elements.productModalContent.querySelector(selectors$14.productViewCartLink), this.elements.viewCart && this.elements.viewCart.addEventListener("click", this.eventHandlers.hideModalShowCart)
          }
        }, {
          key: "_updateSPRReviews",
          value: function() {
            window.SPR && window.SPR.initDomEls && window.SPR.loadProducts && (window.SPR.initDomEls(), window.SPR.loadProducts())
          }
        }, {
          key: "_getProductModalContent",
          value: function(e) {
            return fetch(e).then(function(e) {
              return e.text()
            }).then(function(e) {
              return (new DOMParser).parseFromString(e, "text/html")
            }).then(function(e) {
              return e
            }).catch(function(e) {
              throw new Error(e)
            })
          }
        }, {
          key: "_setupProductModalContent",
          value: function(e) {
            var t = this;
            this.elements.productModalContent.innerHTML = "", this.elements.productModalContent.scrollTo(0, 0);
            var n = e.querySelector(selectors$14.productRecommendationsContainer),
              i = this._getProductSection(e);
            this._productHasMedia(e) || this.elements.productModalContent.classList.add(classes$11.productModalContentNoMedia), this.elements.productModalContent.appendChild(i), n && this._getProductRecommendations(n).then(function(e) {
              t.elements.productModalContent.appendChild(e), t.productRecommendations.resetSafariImages(), t.productPopup = t.productPopup || window.popups.find(function(e) {
                return "product-modal" === e.name
              }), t.productPopup.resetContainerFocus()
            }).catch(function(e) {
              throw new Error(e)
            }), this.elements.productModalContent.querySelectorAll(selectors$14.productImage).forEach(function(e) {
              return e.outerHTML = e.outerHTML
            }), this._showProductModal(i), this._updateSPRReviews(), this._setupEventHandlers()
          }
        }, {
          key: "_getProductSection",
          value: function(e) {
            var t = this,
              n = e.querySelector(selectors$14.productTemplate),
              i = n.querySelectorAll(selectors$14.productCollectionTitle);
            return n.querySelectorAll(selectors$14.productCollectionTitleWrapper).forEach(function(e) {
              return e.classList.toggle(classes$11.hidden, "" === t.collectionTitle)
            }), i.forEach(function(e) {
              e.textContent = t.collectionTitle
            }), n
          }
        }, {
          key: "_getProductRecommendations",
          value: function(e) {
            return this.productRecommendations = new ProductRecommendations(e), this.productRecommendations.init(), this.productRecommendations.setupAndGetHTML()
          }
        }, {
          key: "_productHasMedia",
          value: function(e) {
            return e.querySelectorAll(selectors$14.productImage).length
          }
        }, {
          key: "_showProductModal",
          value: function(e) {
            this.product = new Product(e), this.productPopup = this.productPopup || window.popups.find(function(e) {
              return "product-modal" === e.name
            }), window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(), this.productPopup.elements.stage.classList.contains(classes$11.isOpen) || this.productPopup.openPopup({
              currentTarget: this.elements.productContainer
            })
          }
        }, {
          key: "_hideModalShowCart",
          value: function(e) {
            e.preventDefault(), this.cartPopup = this.cartPopup || window.popups.find(function(e) {
              return "cart" === e.name
            }), this.productPopup.closePopup(), this.cartPopup.openPopup({
              currentTarget: this.productPopup.elements.triggerNode
            }), this._hideProductModal(), this.elements.viewCart && this.elements.viewCart.removeEventListener("click", this.eventHandlers.hideModalShowCart)
          }
        }, {
          key: "_hideProductModal",
          value: function() {
            this.elements.productModalContent.innerHTML = "", this.elements.productModalContent.classList.remove(classes$11.productModalContentNoMedia), this.product.destroy(), this.elements.productContainer.removeEventListener("popup_closed", this.eventHandlers.hideProductModal)
          }
        }]), e
      }(),
      selectors$13 = {
        productCardLink: "[data-product-card-link]",
        productForm: "[data-product-form]",
        productOption: "[data-product-option]",
        showOptionsButton: "[data-show-options-button]"
      },
      classes$10 = {
        hidden: "hidden",
        productCardFormExpanded: "product-card--form-expanded"
      },
      ProductCard = function() {
        "use strict";

        function e(t, n, i) {
          _classCallCheck(this, e), this.elements = {
            productCard: t,
            productModalContent: n
          }, this.collectionTitle = i
        }
        return _createClass(e, [{
          key: "init",
          value: function() {
            Object.assign(this.elements, this._getElements()), this._setupEventHandlers(), this.productModal = new ProductModal(this.elements.productCard, this.elements.productModalContent, this.collectionTitle), this.productModal.init(), this.elements.productForm && (this.productForm = new ProductForm$$1(this.elements.productCard), this.productForm.init())
          }
        }, {
          key: "_getElements",
          value: function() {
            return {
              productCardLinks: this.elements.productCard.querySelectorAll(selectors$13.productCardLink),
              productForm: this.elements.productCard.querySelector(selectors$13.productForm),
              showOptionsButton: this.elements.productCard.querySelector(selectors$13.showOptionsButton)
            }
          }
        }, {
          key: "_getEventHandlers",
          value: function() {
            return {
              onProductLinkClick: this._onProductLinkClick.bind(this)
            }
          }
        }, {
          key: "_setupEventHandlers",
          value: function() {
            var e = this;
            this.eventHandlers = this._getEventHandlers(), this.elements.showOptionsButton && (this.elements.showOptionsButton.addEventListener("click", function() {
              e._toggleShowOptions(!0)
            }), this.elements.productCard.addEventListener("mouseleave", function(t) {
              t.relatedTarget && e._toggleShowOptions(!1)
            }), this.elements.productCard.addEventListener("focusout", function(t) {
              t.relatedTarget && !e.elements.productCard.contains(t.relatedTarget) && e._toggleShowOptions(!1)
            })), this.elements.productCardLinks && this.elements.productModalContent && this.elements.productCardLinks.forEach(function(t) {
              return t.addEventListener("click", e.eventHandlers.onProductLinkClick)
            })
          }
        }, {
          key: "_toggleShowOptions",
          value: function(e) {
            if (this.elements.productCard.classList.toggle(classes$10.productCardFormExpanded, e), this.elements.showOptionsButton.classList.toggle(classes$10.hidden, e), e) {
              var t = this.elements.productForm.querySelector(selectors$13.productOption);
              t && t.focus()
            }
          }
        }, {
          key: "_onProductLinkClick",
          value: function(e) {
            e.preventDefault();
            var t = e.currentTarget.href || e.currentTarget.dataset.productCardLinkUrl;
            this.productModal.setupProductModal(t)
          }
        }]), e
      }(),
      selectors$12 = {
        productCard: "[data-product-card]",
        productCardImage: "[data-product-card-image]",
        productModalContent: "[data-product-modal-content]",
        productRecommendations: "[data-product-recommendations]"
      },
      ProductRecommendations = function() {
        "use strict";

        function e(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          _classCallCheck(this, e), this.elements = {
            container: t
          }, this.setupRecommendationsOnInit = n, this.recommendationsLoaded = !1, this.isProductModalEnabled = Boolean(this.elements.container.dataset.productModal), this.isQuickAddEnabled = Boolean(this.elements.container.dataset.quickAdd)
        }
        return _createClass(e, [{
          key: "init",
          value: function() {
            Object.assign(this.elements, this._getElements()), this.setupRecommendationsOnInit && this._setupProductRecommendations()
          }
        }, {
          key: "setupAndGetHTML",
          value: function() {
            var e = this;
            return new Promise(function(t, n) {
              e._getProductRecommendationsHTML().then(function(i) {
                if (e._showProductRecommendations(i, !1), e.recommendationsLoaded) t(e.elements.container);
                else {
                  n("Product recommendations are not available")
                }
              }).catch(function(e) {
                throw new Error(e)
              })
            })
          }
        }, {
          key: "resetSafariImages",
          value: function() {
            this.elements.container.querySelectorAll(selectors$12.productCardImage).forEach(function(e) {
              return e.outerHTML = e.outerHTML
            })
          }
        }, {
          key: "_getProductRecommendationsHTML",
          value: function() {
            var e = this.elements.container.dataset.baseUrl,
              t = this.elements.container.dataset.productId,
              n = "".concat(e, "?section_id=product-recommendations&product_id=").concat(t, "&limit=4");
            return fetch(n).then(function(e) {
              return e.text()
            }).then(function(e) {
              return (new DOMParser).parseFromString(e, "text/html")
            }).catch(function(e) {
              throw new Error(e)
            })
          }
        }, {
          key: "_showProductRecommendations",
          value: function(e) {
            var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
              n = e.querySelector(selectors$12.productRecommendations);
            n && (this.elements.container.appendChild(n), this._setupProductCards(), t && this.resetSafariImages(), this.recommendationsLoaded = !0)
          }
        }, {
          key: "_getElements",
          value: function() {
            return {
              productModalContent: document.querySelector(selectors$12.productModalContent)
            }
          }
        }, {
          key: "_setupProductRecommendations",
          value: function() {
            var e = this;
            this._getProductRecommendationsHTML().then(function(t) {
              e._showProductRecommendations(t)
            })
          }
        }, {
          key: "_setupProductCards",
          value: function() {
            var e = this;
            (theme.cartQuantity.updateQuantityIndicatorElements(!1, this.elements.container), this.isProductModalEnabled || this.isQuickAddEnabled) && this.elements.container.querySelectorAll(selectors$12.productCard).forEach(function(t) {
              new ProductCard(t, e.elements.productModalContent, "").init()
            })
          }
        }]), e
      }();
    sections.register("product-recommendations", {
      onLoad: function() {
        this.productRecommendations = new ProductRecommendations(this.container, !0), this.productRecommendations.init()
      }
    });
    var selectors$16 = {
        stickyElement: "[data-sticky-element]",
        stickySentinelTop: "[data-sticky-sentinel-top]",
        stickySentinelBottom: "[data-sticky-sentinel-bottom]"
      },
      classes$13 = {
        stickyContainer: "sticky__container",
        stickySentinel: "sticky__sentinel",
        stickySentinelTop: "sticky__sentinel--top",
        stickySentinelBottom: "sticky__sentinel--bottom",
        stickyElement: "sticky__element"
      },
      StickyElement = function() {
        "use strict";

        function e(t) {
          _classCallCheck(this, e), this.container = t
        }
        return _createClass(e, [{
          key: "init",
          value: function() {
            isIntersectionObserverAvailable() && (this.stickyElement = this.container.querySelector(selectors$16.stickyElement), this.stickyElement && (this.sticky = !1, this._addSentinels(), this._observeTopSentinel(), this._observeBottomSentinel()))
          }
        }, {
          key: "destroy",
          value: function() {
            this.topObserver && this.topObserver.disconnect(), this.bottomObserver && this.bottomObserver.disconnect()
          }
        }, {
          key: "isSticky",
          value: function() {
            return this.sticky
          }
        }, {
          key: "_fireEvent",
          value: function() {
            document.dispatchEvent(new window.CustomEvent("elementSticky", {
              detail: {
                stickyElement: this.stickyElement,
                isSticky: this.sticky,
                container: this.container
              }
            }))
          }
        }, {
          key: "_addSentinels",
          value: function() {
            var e = document.createElement("div");
            e.classList.add(classes$13.stickySentinel, classes$13.stickySentinelTop), e.dataset.stickySentinelTop = "", this.container.classList.add(classes$13.stickyContainer), this.stickyElement.insertAdjacentElement("beforebegin", e);
            var t = document.createElement("div");
            t.classList.add(classes$13.stickySentinel, classes$13.stickySentinelBottom), t.dataset.stickySentinelBottom = "", this.stickyElement.parentElement.appendChild(t)
          }
        }, {
          key: "_observeTopSentinel",
          value: function() {
            var e = this,
              t = this.container.querySelector(selectors$16.stickySentinelTop);
            t && (this.topObserver = new IntersectionObserver(function(t) {
              t.forEach(function(t) {
                var n = t.boundingClientRect,
                  i = t.rootBounds,
                  r = n.bottom < i.top,
                  s = n.bottom >= i.top && n.bottom < i.bottom;
                r && (e.sticky = !0, e.stickyElement.classList.add(classes$13.stickyElement), e._fireEvent()), s && (e.sticky = !1, e.stickyElement.classList.remove(classes$13.stickyElement), e._fireEvent())
              })
            }), this.topObserver.observe(t))
          }
        }, {
          key: "_observeBottomSentinel",
          value: function() {
            var e = this,
              t = this.container.querySelector(selectors$16.stickySentinelBottom);
            if (t) {
              var n = 0;
              this.bottomObserver = new IntersectionObserver(function(t) {
                t.forEach(function(t) {
                  var i = t.boundingClientRect,
                    r = t.rootBounds,
                    s = t.intersectionRatio,
                    o = n > t.boundingClientRect.y;
                  n = t.boundingClientRect.y;
                  var a = i.bottom > r.top && 1 === s,
                    l = i.top < r.top && i.bottom < r.bottom;
                  !o && a && (e.sticky = !0, e.stickyElement.classList.add(classes$13.stickyElement), e._fireEvent()), l && (e.sticky = !1, e.stickyElement.classList.remove(classes$13.stickyElement), e._fireEvent())
                })
              }), this.bottomObserver.observe(t)
            }
          }
        }]), e
      }(),
      selectors$17 = {
        viewMoreButton: "[data-view-more-button]",
        viewMoreItem: "[data-view-more-item]",
        viewMoreStatus: "[data-view-more-status]"
      },
      classes$14 = {
        hidden: "hidden"
      },
      events = {
        success: "viewmore_loaded"
      },
      ViewMore = function() {
        "use strict";

        function e(t) {
          _classCallCheck(this, e), this.container = t
        }
        return _createClass(e, [{
          key: "init",
          value: function() {
            this.container && (this.viewMoreButton = this.container.querySelector(selectors$17.viewMoreButton), this.viewMoreButton && (this.maxCount = parseInt(this.viewMoreButton.dataset.viewMoreMax, 10), this.countPerPage = parseInt(this.viewMoreButton.dataset.viewMoreStep, 10), this.currentCount = parseInt(this.viewMoreButton.dataset.viewMoreCurrent, 10), this.isLoading = !1, this._setupEventHandlers()))
          }
        }, {
          key: "_getEventHandlers",
          value: function() {
            return {
              onClickViewMoreHandler: this._onClickViewMoreHandler.bind(this)
            }
          }
        }, {
          key: "_setupEventHandlers",
          value: function() {
            this.eventHandlers = this._getEventHandlers(), this.viewMoreButton.addEventListener("click", this.eventHandlers.onClickViewMoreHandler)
          }
        }, {
          key: "_onClickViewMoreHandler",
          value: function() {
            this._loadItems()
          }
        }, {
          key: "_getNextPage",
          value: function() {
            var e = Math.floor(this.currentCount / this.countPerPage) + 1;
            return this.viewMoreButton.dataset.viewMoreNext.replace("[pagination]", e)
          }
        }, {
          key: "_fireEvent",
          value: function(e, t) {
            this.container.dispatchEvent(new window.CustomEvent(e, {
              detail: t
            }))
          }
        }, {
          key: "_loadItems",
          value: function() {
            var e = this;
            if (!(this.isLoading || this.currentCount >= this.maxCount)) {
              var t = this._getNextPage();
              this.isLoading = !0, fetch(t).then(function(e) {
                return e.text()
              }).then(function(e) {
                return (new DOMParser).parseFromString(e, "text/html")
              }).then(function(t) {
                var n = _toConsumableArray(t.querySelectorAll(selectors$17.viewMoreItem));
                e.currentCount < e.countPerPage && n.splice(0, e.currentCount), e.isLoading = !1, e.currentCount += n.length, e._updateButton(), e._updateLiveRegion(), e._fireEvent(events.success, {
                  items: n
                })
              }).then(function() {
                e._updateSPRBadges()
              }).catch(function(t) {
                throw e.isLoading = !1, new Error(t)
              })
            }
          }
        }, {
          key: "_updateSPRBadges",
          value: function() {
            window.SPR && window.SPR.initDomEls && window.SPR.loadBadges && (window.SPR.initDomEls(), window.SPR.loadBadges())
          }
        }, {
          key: "_updateButton",
          value: function() {
            this.viewMoreButton.dataset.viewMoreCurrent = this.currentCount, this.currentCount >= this.maxCount && this.viewMoreButton.classList.add(classes$14.hidden)
          }
        }, {
          key: "_updateLiveRegion",
          value: function() {
            var e = this.container.querySelector(selectors$17.viewMoreStatus),
              t = e.dataset.viewMoreStatusMessage.replace("[item_count]", this.currentCount).replace("[item_max]", this.maxCount);
            e.innerText = t, e.setAttribute("aria-hidden", !1), setTimeout(function() {
              e.setAttribute("aria-hidden", !0)
            }, 1e3)
          }
        }]), e
      }(),
      selectors$15 = {
        scrollerContent: "[data-scroller-content]",
        featuredCollectionsTabs: "[data-featured-collections-tab]",
        featuredCollectionsSelectedTab: "[data-featured-collections-selected-tab]",
        featuredCollectionsTabsPanel: "[data-featured-collections-tab-panel]",
        featuredCollectionsWrapper: "[data-featured-collections-wrapper]",
        productCard: "[data-product-card]",
        productCardLink: "[data-product-card-link]",
        productModalContent: "[data-product-modal-content]",
        viewMoreContent: "[data-view-more-content]"
      },
      classes$12 = {
        featuredCollectionsPanelActive: "featured-collections__panel--active",
        featuredCollectionsPanelVisible: "featured-collections__panel--visible",
        featuredCollectionsTabActive: "featured-collections-tab__item--active"
      };
    sections.register("featured-collections", {
      onLoad: function() {
        this.elements = this._getElements(), this.scroller = new Scroller(this.container), this.scroller.init(), this.stickyNav = new StickyElement(this.container), this.stickyNav.init(), this.isProductModalEnabled = Boolean(this.container.dataset.productModal), this.isQuickAddEnabled = Boolean(this.container.dataset.quickAdd), this.hasSingleCollection = Boolean(this.container.dataset.singleCollection), this.isProductModalEnabled && (this.elements.productModalContent = document.querySelector(selectors$15.productModalContent)), this._setupProductCards(), this._setupEventHandlers(), theme.cartQuantity && theme.cartQuantity.updateQuantityIndicatorElements(!1, this.container)
      },
      onUnload: function() {
        var e = this;
        this.elements.tabs && (this.stickyNav.destroy(), this.scroller.destroy(), this.elements.tabs.forEach(function(t) {
          t.removeEventListener("click", e.eventHandlers.onClickTabHandler), t.removeEventListener("keydown", e.eventHandlers.onKeyDownTabHandler)
        }))
      },
      onBlockSelect: function(e) {
        if (!this.hasSingleCollection) {
          var t = this.container.querySelector('[data-featured-collections-block-id="'.concat(e, '"]'));
          if (t) {
            var n = t.dataset.featuredCollectionsTabNumber;
            this.showCollectionPanel(n)
          }
        }
      },
      _getElements: function() {
        return {
          tabs: this.container.querySelectorAll(selectors$15.featuredCollectionsTabs),
          tabsPanel: this.container.querySelectorAll(selectors$15.featuredCollectionsTabsPanel),
          tabsPanelWrapper: this.container.querySelector(selectors$15.featuredCollectionsWrapper)
        }
      },
      _getEventHandlers: function() {
        return {
          onClickTabHandler: this.onClickTabHandler.bind(this),
          onKeyDownTabHandler: this.onKeyDownTabHandler.bind(this),
          onKeyUpTabHandler: this.onKeyUpTabHandler.bind(this),
          onViewMoreLoaded: this.onViewMoreLoaded.bind(this)
        }
      },
      _setupEventHandlers: function() {
        var e = this;
        this.eventHandlers = this._getEventHandlers(), this.elements.tabsPanel.forEach(function(t) {
          t.dataset.viewMore && (new ViewMore(t).init(), t.addEventListener("viewmore_loaded", e.eventHandlers.onViewMoreLoaded))
        }), this.elements.tabs && !this.hasSingleCollection && this.elements.tabs.forEach(function(t) {
          t.addEventListener("click", e.eventHandlers.onClickTabHandler), t.addEventListener("keydown", e.eventHandlers.onKeyDownTabHandler), t.addEventListener("keyup", e.eventHandlers.onKeyUpTabHandler)
        })
      },
      _setupProductCards: function() {
        var e = this;
        (this.isProductModalEnabled || this.isQuickAddEnabled) && this.elements.tabsPanel.forEach(function(t) {
          var n = t.querySelectorAll(selectors$15.productCard),
            i = t.dataset.collectionTitle;
          n.forEach(function(t) {
            new ProductCard(t, e.elements.productModalContent, i).init()
          })
        })
      },
      onViewMoreLoaded: function(e) {
        var t = this,
          n = e.detail.items,
          i = e.target,
          r = i.dataset.collectionTitle,
          s = i.querySelector(selectors$15.viewMoreContent),
          o = [];
        n.forEach(function(e, n) {
          var i = e.querySelector(selectors$15.productCard);
          o.push(i.dataset.productId);
          var a = s.appendChild(e).querySelector(selectors$15.productCardLink);
          (a && 0 === n && a.focus(), t.isProductModalEnabled || t.isQuickAddEnabled) && new ProductCard(i, t.elements.productModalContent, r).init()
        }), theme.cartQuantity.updateQuantityIndicatorElements(o, this.viewMoreContent, !0)
      },
      onKeyDownTabHandler: function(e) {
        [keyCodes.HOME, keyCodes.END, keyCodes.RIGHT, keyCodes.LEFT].includes(e.key.toLowerCase()) && e.preventDefault()
      },
      onKeyUpTabHandler: function(e) {
        var t = e.currentTarget,
          n = this.elements.tabs.length - 1,
          i = Number(t.dataset.featuredCollectionsTabNumber),
          r = -1;
        switch (e.key.toLowerCase()) {
          case keyCodes.HOME:
            r = 0;
            break;
          case keyCodes.END:
            r = n;
            break;
          case keyCodes.RIGHT:
            r = i === n ? 0 : i + 1;
            break;
          case keyCodes.LEFT:
            r = 0 === i ? n : i - 1
        } - 1 !== r && i !== r && (e.preventDefault(), this.showCollectionPanel(r))
      },
      onClickTabHandler: function(e) {
        var t = e.currentTarget.dataset.featuredCollectionsTabNumber;
        this.showCollectionPanel(t)
      },
      showCollectionPanel: function(e) {
        var t = this.elements.tabs[e],
          n = this.elements.tabsPanelWrapper.getBoundingClientRect().top + window.pageYOffset - 105;
        this.stickyNav.isSticky() && (document.dispatchEvent(new CustomEvent("featuredCollectionTabClicked")), window.scrollTo({
          top: n
        })), this.elements.tabs.forEach(function(e) {
          e.classList.remove(classes$12.featuredCollectionsTabActive), e.setAttribute("aria-selected", !1), e.setAttribute("tabindex", -1), delete e.dataset.featuredCollectionsSelectedTab, e.blur()
        }), t.classList.add(classes$12.featuredCollectionsTabActive), t.setAttribute("aria-selected", !0), t.setAttribute("tabindex", 0), t.dataset.featuredCollectionsSelectedTab = !0, t.focus(), this.scroller.makeElementVisible(t);
        var i = this.elements.tabsPanel[e];
        i && (this.elements.tabsPanel.forEach(function(e) {
          e.classList.remove(classes$12.featuredCollectionsPanelVisible), e.classList.remove(classes$12.featuredCollectionsPanelActive)
        }), i.classList.add(classes$12.featuredCollectionsPanelActive), window.requestAnimationFrame(function() {
          return i.classList.add(classes$12.featuredCollectionsPanelVisible)
        }))
      }
    });
    var selectors$18 = {
      productCard: "[data-product-card]",
      productModalContent: "[data-product-modal-content]",
      dataSlide: "[data-slide]"
    };
    sections.register("custom-content", {
      onLoad: function() {
        this.elements = this._getElements();
        var e = this.container.querySelectorAll(selectors$18.productCard);
        this.container.dataset.slider && this._prepareGallery(), this.isProductModalEnabled = Boolean(this.container.dataset.productModal), this.isProductModalEnabled && e.length > 0 && this._setupProductCards()
      },
      onUnload: function() {
        Boolean(this.gallery) && this.gallery.destroy()
      },
      _getElements: function() {
        return {
          productModalContent: document.querySelector(selectors$18.productModalContent)
        }
      },
      _setupProductCards: function() {
        var e = this;
        this.container.querySelectorAll(selectors$18.productCard).forEach(function(t) {
          new ProductCard(t, e.elements.productModalContent).init()
        })
      },
      _prepareGallery: function() {
        this.galleryElement = this.container.querySelector(selectors$18.dataSlide), this.galleryElement && (this._addGalleryMediaQueryListener(), this.galleryMediaQueryListener.matches && (this._initializeGallery(), this.gallery.addAccessibilityAttr()))
      },
      _disableGalleryMode: function() {
        this.gallery.removeAccessibilityAttr(), this.gallery.resetTransformation(), this.gallery.state.useAriaHidden = !1, this.gallery.destroy()
      },
      _switchToGalleryMode: function() {
        var e = this._initializeGallery();
        this.gallery.state.useAriaHidden = !0, this.gallery.hideMedia(), this.gallery.addAccessibilityAttr(), e || this.gallery.bindEvents()
      },
      _addGalleryMediaQueryListener: function() {
        var e = this;
        this.galleryMediaQueryListener = window.matchMedia(getMediaQueryString("medium", "max")), this.galleryMediaQueryListener.addListener(function(t) {
          t.matches ? e._switchToGalleryMode() : e._disableGalleryMode()
        })
      },
      _initializeGallery: function() {
        var e = this;
        return this.gallery ? (this.gallery.applyTransformation(), window.setTimeout(function() {
          return e.gallery.enableTransition()
        }), !1) : (this.gallery = new Gallery(this.galleryElement), this.gallery.init(), !0)
      }
    });
    var selectors$19 = {
        blogTagFilter: "[data-blog-tag-filter]"
      },
      blogTagFilter;
    blogTagFilter = document.querySelector(selectors$19.blogTagFilter), blogTagFilter && (resizeSelectInput(blogTagFilter), blogTagFilter.addEventListener("change", function(e) {
      location.href = e.target.value
    }));
    var selectors$20 = {
        passwordButton: "[data-password-button]",
        passwordInput: "[data-password-input]"
      },
      attributes$2 = {
        error: "data-error",
        templatePassword: "data-template-password"
      };
    ! function() {
      document.body.hasAttribute(attributes$2.templatePassword) && (document.querySelector(selectors$20.passwordInput).hasAttribute(attributes$2.error) && window.addEventListener("DOMContentLoaded", function() {
        setTimeout(function() {
          window.popups.find(function(e) {
            return "password-modal" === e.name
          }).openPopup({
            currentTarget: document.querySelector(selectors$20.passwordButton)
          })
        }, 50)
      }))
    }();
    var selectors$21 = {
        addNewAddressToggle: "[data-add-new-address-toggle]",
        addressCountrySelect: "[data-address-country-select]",
        addressFormNew: "[data-address-form-new]",
        cancelEditAddressToggle: "[data-cancel-edit-address-toggle]",
        cancelNewAddressToggle: "[data-cancel-new-address-toggle]",
        customerAddresses: "[data-customer-addresses]",
        deleteAddressButton: "[data-delete-address-button]",
        editAddressToggle: "[data-edit-address-toggle]",
        editAddressId: function(e) {
          return '[data-edit-address-id="'.concat(e, '"]')
        },
        form: "[data-form]"
      },
      attributes$3 = {
        addNewAddressToggle: "data-add-new-address-toggle"
      },
      classes$15 = {
        hidden: "hidden"
      };
    ! function() {
      var e = document.querySelector(selectors$21.customerAddresses);
      if (e) {
        var t, n, i, r, s, o = e.querySelector(selectors$21.addressFormNew);
        if (o) ! function() {
          Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
            hideElement: "AddressProvinceContainerNew"
          });
          e.querySelectorAll(selectors$21.addressCountrySelect).forEach(function(e) {
            var t = e.dataset.formId,
              n = "AddressCountry_".concat(t),
              i = "AddressProvince_".concat(t),
              r = "AddressProvinceContainer_".concat(t);
            new Shopify.CountryProvinceSelector(n, i, {
              hideElement: r
            })
          })
        }(), t = e.querySelector(selectors$21.addNewAddressToggle), n = e.querySelector(selectors$21.cancelNewAddressToggle), i = e.querySelectorAll(selectors$21.editAddressToggle), r = e.querySelectorAll(selectors$21.cancelEditAddressToggle), s = e.querySelectorAll(selectors$21.deleteAddressButton), t.addEventListener("click", function(e) {
          return a(e, t, o)
        }), n.addEventListener("click", function(e) {
          return a(e, t, o)
        }), i.forEach(function(e) {
          return e.addEventListener("click", function(e) {
            return l(e, i)
          })
        }), r.forEach(function(e) {
          return e.addEventListener("click", function() {
            l(event, i)
          })
        }), s.forEach(function(e) {
          return e.addEventListener("click", c)
        })
      }

      function a(e, t, n) {
        var i = e.currentTarget;
        "false" === t.getAttribute("aria-expanded") ? (n.classList.remove(classes$15.hidden), t.setAttribute("aria-expanded", !0)) : (n.classList.add(classes$15.hidden), t.setAttribute("aria-expanded", !1)), i.hasAttribute(attributes$3.addNewAddressToggle) || t.focus()
      }

      function l(t, n) {
        var i = t.currentTarget,
          r = i.dataset.addressId,
          s = e.querySelector(selectors$21.editAddressId(r)),
          o = Array.from(n).find(function(e) {
            return e.dataset.addressId === r
          });
        "false" === o.getAttribute("aria-expanded") ? (s.classList.remove(classes$15.hidden), o.setAttribute("aria-expanded", !0)) : (s.classList.add(classes$15.hidden), o.setAttribute("aria-expanded", !1)), i.hasAttribute(attributes$3.editAddressFormToggle) || o.focus()
      }

      function c(e) {
        var t = e.currentTarget,
          n = t.dataset.target,
          i = t.dataset.confirmMessage || "Are you sure you wish to delete this address?";
        confirm(i) && Shopify.postLink(n, {
          parameters: {
            _method: "delete"
          }
        })
      }
    }();
    var selectors$22 = {
        cancelResetPasswordLink: "[data-cancel-reset-password-link]",
        customerLogin: "[data-customer-login]",
        loginContainer: "[data-login-container]",
        loginHeading: "[data-login-heading]",
        resetPasswordHeading: "[data-reset-password-heading]",
        resetPasswordLink: "[data-reset-password-link]",
        resetPasswordContainer: "[data-reset-password-container]",
        resetPasswordSuccess: "[data-reset-password-success]",
        resetPasswordSuccessMessage: "[data-reset-password-success-message]"
      },
      classes$16 = {
        hidden: "hidden"
      };

    function initPIXI() {
      console.log("here:", PIXI);
      var e = {
          uniforms: {
            iResolution: {
              type: "v2",
              value: [window.innerWidth, window.innerHeight]
            },
            vTextureSize: {
              type: "v2",
              value: [0, 0]
            },
            uTextureForeground: {
              type: "sampler2D",
              value: null
            },
            uTextureBackground: {
              type: "sampler2D",
              value: null
            },
            uTextureDropShine: {
              type: "sampler2D",
              value: null
            }
          },
          fragment: '\n        precision mediump float;\n    \n        //Textures\n        uniform sampler2D uTextureForeground;\n        uniform sampler2D uTextureBackground;\n        uniform sampler2D uTextureDropShine;\n        \n        //Canvas image data\n        uniform sampler2D uSampler;\n    \n        //The resolution and coordinates of the current pixel\n        uniform vec2 iResolution;\n        uniform vec2 vTextureSize;\n        varying vec2 vTextureCoord;\n        \n        //Function to get the vec2 value of the current coordinate\n        vec2 texCoord(){\n            return vec2(gl_FragCoord.x, iResolution.y - gl_FragCoord.y) / iResolution;\n        }\n\n        //Scales the bg up and proportionally to fill the container\n        vec2 scaledTextureCoordinate(){\n            float ratioCanvas = iResolution.x / iResolution.y;\n            float ratioImage = vTextureSize.x / vTextureSize.y;\n            \n            vec2 scale = vec2(1, 1);\n            vec2 offset = vec2(0, 0);\n            float ratioDelta = ratioCanvas - ratioImage;\n\n            if(ratioDelta >= 0.0){\n                scale.y = (1.0 + ratioDelta);\n                offset.y = ratioDelta / 2.0;\n            }else{\n                scale.x = (1.0 - ratioDelta);\n                offset.x = -(ratioDelta / 2.0);\n            }\n\n            return (texCoord() + offset) / scale;\n        }\n        \n        //Alpha-blends two colors\n        vec4 blend(vec4 bg, vec4 fg){\n            vec3 bgm = bg.rgb * bg.a;\n            vec3 fgm = fg.rgb * fg.a;\n            float ia = 1.0 - fg.a;\n            float a = (fg.a + bg.a * ia);\n            \n            vec3 rgb;\n            \n            if(a != 0.0){\n                rgb = (fgm + bgm * ia) / a;\n            }else{\n                rgb = vec3(0.0,0.0,0.0);\n            }\n            \n            return vec4(rgb,a);\n        }\n        \n        vec2 pixel(){\n            return vec2(1.0, 1.0) / iResolution;\n        }\n        \n        //Get color from fg\n        vec4 fgColor(){\n            return texture2D(uSampler, vTextureCoord);\n        }\n                \n        void main(){\n            vec4 bg = texture2D(uTextureBackground, scaledTextureCoordinate());\n            vec4 cur = fgColor();\n\n            float d = cur.b; // "thickness"\n            float x = cur.g;\n            float y = cur.r;\n            float a = smoothstep(0.65, 0.7, cur.a);\n            \n            vec4 smoothstepped = vec4(y, x, d, a);\n\n            vec2 refraction = (vec2(x, y) - 0.5) * 2.0;\n            vec2 refractionPos = scaledTextureCoordinate() + (pixel() * refraction * (256.0 + (d * 512.0)));\n            vec4 tex = texture2D(uTextureForeground, refractionPos);\n            \n            float maxShine = 390.0;\n            float minShine = maxShine * 0.18;\n            vec2 shinePos = vec2(0.5, 0.5) + ((1.0 / 512.0) * refraction) * -(minShine + ((maxShine-minShine) * d));\n            vec4 shine = texture2D(uTextureDropShine, shinePos);\n            tex = blend(tex,shine);\n            \n            vec4 fg = vec4(tex.rgb, a);\n            gl_FragColor = blend(bg, fg);\n        }\n    '
        },
        t = function() {
          "use strict";

          function e(t, n, i, r) {
            var s = this;
            _classCallCheck(this, e), this.width = r.offsetWidth, this.height = r.offsetHeight, this.alpha = t, this.shine = n, this.backgroundIMG = i, this.element = r, this.loader = new PIXI.loaders.Loader, this.loader.add(this.alpha).add(this.shine).add(this.backgroundIMG).load(function() {
              return s.initialize()
            })
          }
          return _createClass(e, [{
            key: "initialize",
            value: function() {
              var e = this;
              this.width = this.element.offsetWidth, this.height = this.element.offsetHeight, this.effectCanvas = new n(this.width, this.height, this.loader, this.alpha, this.shine, this.backgroundIMG, this.element), this.effectCanvas.interactive = !1, window.addEventListener("resize", function() {
                return e.resizeCanvas()
              }, !1), this.loop(), setTimeout(function() {
                e.resizeCanvas()
              }, 500)
            }
          }, {
            key: "resizeCanvas",
            value: function() {
              this.width = this.element.offsetWidth, this.height = this.element.offsetHeight, this.effectCanvas.resize(this.width, this.height)
            }
          }, {
            key: "loop",
            value: function() {
              var e = this;
              window.requestAnimationFrame(function() {
                return e.loop()
              }), this.effectCanvas.update(this.width, this.height), this.effectCanvas.render()
            }
          }]), e
        }(),
        n = function() {
          "use strict";

          function t(n, r, s, o, a, l, c) {
            _classCallCheck(this, t), this.renderer = new PIXI.autoDetectRenderer(n, r, {
              antialias: !1,
              transparent: !1
            }), this.renderer.autoResize = !0, this.renderer.view.style.touchAction = "none", c.appendChild(this.renderer.view), this.stage = new PIXI.Container, this.background = new PIXI.Graphics, this.background.fillAlphanumber = 0, this.background.beginFill("0xFFFFFF"), this.background.drawRect(0, 0, n, r), this.background.endFill(), this.background.alpha = 0, this.stage.addChild(this.background), this.dropletManager = new i(this.stage, s, o), e.uniforms.uTextureDropShine.value = s.resources[a].texture, e.uniforms.uTextureBackground.value = s.resources[l].texture, e.uniforms.uTextureForeground.value = s.resources[l].texture, e.uniforms.vTextureSize.value = [s.resources[l].texture.width, s.resources[l].texture.height], this.dropletShader = new PIXI.Filter("", e.fragment, e.uniforms), this.stage.filters = [this.dropletShader]
          }
          return _createClass(t, [{
            key: "resize",
            value: function(e, t) {
              this.renderer.resize(e, t), this.background.clear(), this.background.beginFill("0xFFFFFF"), this.background.drawRect(0, 0, e, t), this.background.endFill()
            }
          }, {
            key: "update",
            value: function(e, t) {
              this.updateShader(e, t), this.dropletManager.update(e, t)
            }
          }, {
            key: "updateShader",
            value: function(e, t) {
              this.dropletShader.uniforms.iResolution = [e, t]
            }
          }, {
            key: "render",
            value: function() {
              this.renderer.render(this.stage)
            }
          }]), t
        }(),
        i = function() {
          "use strict";

          function e(t, n, i) {
            _classCallCheck(this, e);
            var a = 3e3,
              l = 20;
            t.width < 700 && (a = 800, l = 8), this.options = {
              spawnRate: {
                small: .6,
                large: .05
              },
              spawnsPerFrame: {
                small: 200,
                large: 5
              },
              spawnMass: {
                small: {
                  min: 1,
                  max: 2
                },
                large: {
                  min: 6,
                  max: 10
                }
              },
              poolDroplets: {
                small: {
                  min: a - 500,
                  max: a
                },
                large: {
                  min: l - 10,
                  max: l
                }
              },
              maximumMassGravity: 5e3,
              maximumMass: 10,
              dropletGrowSpeed: 1,
              dropletShrinkSpeed: 2,
              dropletContainerSize: 100
            }, this.positionMatrix = [
              [-1, -1],
              [1, -1],
              [-1, 1],
              [1, 1]
            ], this.smallDroplets = [], this.largeDroplets = [], this.dropletSmallTexture = n.resources[i].texture, this.dropletLargeTexture = n.resources[i].texture, this.smallDropletContainer = new r(s, this.dropletSmallTexture, this.options.poolDroplets.small.min, this.options.poolDroplets.small.max), this.largeDropletContainer = new r(o, this.dropletLargeTexture, this.options.poolDroplets.large.min, this.options.poolDroplets.large.max), t.addChild(this.largeDropletContainer), t.addChild(this.smallDropletContainer)
          }
          return _createClass(e, [{
            key: "update",
            value: function(t, n) {
              e.removeLargeOffscreenDroplets(t, n, this.largeDroplets, this.largeDropletContainer);
              for (var i = 0; i < this.options.spawnsPerFrame.small; i++) this.spawnNewSmallDroplet(t, n);
              for (var r = 0; r < this.options.spawnsPerFrame.large; r++) this.spawnNewLargeDroplet(t, n);
              this.checkLargeDropletLogic()
            }
          }, {
            key: "checkLargeDropletLogic",
            value: function() {
              for (var e = this.largeDroplets.length - 1; e >= 0; e--) this.updateLargeDropletSize(this.largeDroplets[e]), this.checkDropletMovement(this.largeDroplets[e]), this.checkLargeToSmallDropletCollision(this.largeDroplets[e]), this.checkLargeToLargeDropletCollision(this.largeDroplets[e]), this.removeLargeDroplets(e)
            }
          }, {
            key: "removeLargeDroplets",
            value: function(e) {
              0 === this.largeDroplets[e].mass && !0 === this.largeDroplets[e].toBeRemoved && (this.largeDropletContainer.destroy(this.largeDroplets[e]), this.largeDroplets.splice(e, 1))
            }
          }, {
            key: "updateLargeDropletSize",
            value: function(e) {
              !0 === e.toBeRemoved ? this.shrinkDropletSize(e) : this.growDropletSize(e), e.width = 6 * e.mass, e.height = 7 * e.mass
            }
          }, {
            key: "shrinkDropletSize",
            value: function(e) {
              e.mass - this.options.dropletShrinkSpeed <= 0 ? e.mass = 0 : e.mass -= this.options.dropletShrinkSpeed
            }
          }, {
            key: "growDropletSize",
            value: function(e) {
              e.mass !== e.targetMass && (e.mass + this.options.dropletGrowSpeed >= e.targetMass ? e.mass = e.targetMass : e.mass += this.options.dropletGrowSpeed)
            }
          }, {
            key: "checkDropletMovement",
            value: function(e) {
              !0 !== e.toBeRemoved && (e.mass < this.options.maximumMassGravity && 0 === e.dropletVelocity.y && 0 === e.dropletVelocity.x ? Math.random() < .01 && (e.dropletVelocity.y = a.getRandomInt(.5, 3)) : e.mass < this.options.maximumMassGravity && 0 !== e.dropletVelocity.y ? (Math.random() < .1 && (e.x += a.getRandomInt(-10, 10) / 10), Math.random() < .1 && (e.dropletVelocity.y = 0)) : e.mass >= this.options.maximumMassGravity && e.dropletVelocity.y < 10 && (e.dropletVelocity.y = a.getRandomInt(10, 20), e.dropletVelocity.x = a.getRandomInt(-10, 10) / 10), e.y += e.dropletVelocity.y, e.x += e.dropletVelocity.x)
            }
          }, {
            key: "getDropletPresenceArray",
            value: function(e) {
              for (var t = [], n = this.positionMatrix.length, i = 0; i < n; i++) {
                var r = {
                  x: Math.floor((e.x + e.width / 7 * this.positionMatrix[i][0]) / this.options.dropletContainerSize),
                  y: Math.floor((e.y + e.height / 7 * this.positionMatrix[i][1]) / this.options.dropletContainerSize)
                };
                0 !== i ? t[0].x === r.x && t[0].y === r.y || t.push(r) : t.push(r)
              }
              return t
            }
          }, {
            key: "checkLargeToLargeDropletCollision",
            value: function(e) {
              if (!0 !== e.toBeRemoved)
                for (var t = this.largeDroplets.length - 1; t >= 0; t--)
                  if (e.x !== this.largeDroplets[t].x || e.y !== this.largeDroplets[t].y) {
                    var n = e.x - this.largeDroplets[t].x,
                      i = e.y - this.largeDroplets[t].y;
                    Math.sqrt(n * n + i * i) <= e.width / 7 + this.largeDroplets[t].width / 7 && (e.mass + this.largeDroplets[t].mass <= this.options.maximumMass ? e.targetMass = e.mass + this.largeDroplets[t].mass : e.targetMass = this.options.maximumMass, this.largeDroplets[t].toBeRemoved = !0)
                  }
            }
          }, {
            key: "checkLargeToSmallDropletCollision",
            value: function(e) {
              if (!0 !== e.toBeRemoved)
                for (var t = this.getDropletPresenceArray(e), n = 0; n < t.length; n++)
                  if (void 0 !== this.smallDroplets[t[n].x] && void 0 !== this.smallDroplets[t[n].x][t[n].y])
                    for (var i = this.smallDroplets[t[n].x][t[n].y].length - 1; i >= 0; i--) {
                      var r = e.x - this.smallDroplets[t[n].x][t[n].y][i].x,
                        s = e.y - this.smallDroplets[t[n].x][t[n].y][i].y;
                      Math.sqrt(r * r + s * s) <= e.width / 7 + this.smallDroplets[t[n].x][t[n].y][i].width / 7 && (e.mass + this.smallDroplets[t[n].x][t[n].y][i].mass / 3 <= this.options.maximumMass && (e.targetMass = e.mass + this.smallDroplets[t[n].x][t[n].y][i].mass / 3), this.smallDropletContainer.destroy(this.smallDroplets[t[n].x][t[n].y][i]), this.smallDroplets[t[n].x][t[n].y].splice(i, 1))
                    }
            }
          }, {
            key: "spawnNewSmallDroplet",
            value: function(e, t) {
              if (!(Math.random() > this.options.spawnRate.small)) {
                var n = this.smallDropletContainer.get();
                if (null !== n) {
                  var i = {
                      x: a.getRandomInt(0, e),
                      y: a.getRandomInt(0, t)
                    },
                    r = a.getRandomInt(this.options.spawnMass.small.min, this.options.spawnMass.small.max),
                    s = Math.floor(i.x / this.options.dropletContainerSize),
                    o = Math.floor(i.y / this.options.dropletContainerSize);
                  n.x = i.x, n.y = i.y, n.mass = r, n.width = 8 * n.mass, n.height = 8 * n.mass, void 0 === this.smallDroplets[s] && (this.smallDroplets[s] = []), void 0 === this.smallDroplets[s][o] && (this.smallDroplets[s][o] = []), this.smallDroplets[s][o].push(n)
                }
              }
            }
          }, {
            key: "spawnNewLargeDroplet",
            value: function(e, t) {
              if (!(Math.random() > this.options.spawnRate.large)) {
                var n = this.largeDropletContainer.get();
                if (null !== n) {
                  var i = a.getRandomInt(this.options.spawnMass.large.min, this.options.spawnMass.large.max);
                  n.x = a.getRandomInt(0, e), n.y = a.getRandomInt(-100, t / 1.5), n.mass = i / 2, n.targetMass = i, n.width = 6 * n.mass, n.height = 7 * n.mass, n.dropletVelocity.x = 0, n.toBeRemoved = !1, this.largeDroplets.push(n)
                }
              }
            }
          }], [{
            key: "removeLargeOffscreenDroplets",
            value: function(e, t, n, i) {
              for (var r = n.length - 1; r >= 0; r--)(n[r].x > e + 10 || n[r].x < -10 || n[r].y > t + 10 || n[r].y < -100) && (i.destroy(n[r]), n.splice(r, 1))
            }
          }]), e
        }(),
        r = function(e) {
          "use strict";
          _inherits(n, PIXI.particles.ParticleContainer);
          var t = _createSuper(n);

          function n(e, i, r, s) {
            var o;
            return _classCallCheck(this, n), (o = t.call(this, s, {
              scale: !0,
              position: !0,
              rotation: !1,
              uvs: !1,
              alpha: !1
            })).ObjectToCreate = e, o.objectTexture = i, o.pool = [], o.inUse = 0, o.startingSize = r, o.maximumSize = s, o.initialize(), o
          }
          return _createClass(n, [{
            key: "initialize",
            value: function() {
              for (var e = 0; e < this.startingSize; e += 1) {
                var t = new this.ObjectToCreate(this.objectTexture);
                t.x = -100, t.y = -100, t.anchor.set(.5), this.addChild(t), this.pool.push(t)
              }
            }
          }, {
            key: "get",
            value: function() {
              if (this.inUse >= this.maximumSize) return null;
              if (this.inUse++, this.pool.length > 0) return this.pool.pop();
              var e = new this.ObjectToCreate(this.objectTexture);
              return e.x = -100, e.y = -100, e.anchor.set(.5, .5), this.addChild(e), e
            }
          }, {
            key: "destroy",
            value: function(e) {
              this.inUse - 1 < 0 ? console.error("Something went wrong, you cant remove more elements than there are in the total pool") : (e.x = -100, e.y = -100, this.inUse -= 1, this.pool.push(e))
            }
          }]), n
        }(),
        s = function(e) {
          "use strict";
          _inherits(n, PIXI.Sprite);
          var t = _createSuper(n);

          function n(e) {
            var i;
            return _classCallCheck(this, n), (i = t.call(this, e)).mass = 0, i
          }
          return n
        }(),
        o = function(e) {
          "use strict";
          _inherits(n, s);
          var t = _createSuper(n);

          function n(e) {
            var i;
            return _classCallCheck(this, n), (i = t.call(this, e)).dropletVelocity = new PIXI.Point(0, 0), i.toBeRemoved = !1, i.targetMass = 0, i
          }
          return n
        }(),
        a = function() {
          "use strict";

          function e() {
            _classCallCheck(this, e)
          }
          return _createClass(e, null, [{
            key: "getRandomInt",
            value: function(e, t) {
              return Math.floor(Math.random() * (t - e + 1)) + e
            }
          }]), e
        }();
      Array.prototype.slice.call(document.body.querySelectorAll(".sweat"), 0).forEach(function(e) {
        new t(e.dataset.alpha, e.dataset.shine, e.dataset.bg, e)
      })
    }

    function loadJS(url, onDone, onError) {
      onDone || (onDone = function() {}), onError || (onError = function() {});
      var xhr = new XMLHttpRequest;
      xhr.onreadystatechange = function() {
        if (4 == xhr.readyState)
          if (200 == xhr.status || 0 == xhr.status) {
            try {
              eval(xhr.responseText)
            } catch (e) {
              return void onError(e)
            }
            onDone()
          } else onError(xhr.status)
      }.bind(this);
      try {
        xhr.open("GET", url, !0), xhr.send()
      } catch (e) {
        onError(e)
      }
    }! function() {
      var e, t, n = document.querySelector(selectors$22.customerLogin);
      n && (! function() {
        if ("#recover" === window.location.hash) {
          var e = n.querySelector(selectors$22.resetPasswordHeading);
          i(e, !0)
        }
      }(), function() {
        var e = n.querySelector(selectors$22.resetPasswordSuccess),
          t = n.querySelector(selectors$22.resetPasswordSuccessMessage);
        if (!e) return;
        t.classList.remove(classes$16.hidden), t.focus()
      }(), e = n.querySelector(selectors$22.resetPasswordLink), t = n.querySelector(selectors$22.cancelResetPasswordLink), e.addEventListener("click", function(e) {
        e.preventDefault();
        var t = n.querySelector(selectors$22.resetPasswordHeading);
        i(t, !0)
      }), t.addEventListener("click", function(e) {
        e.preventDefault();
        var t = n.querySelector(selectors$22.loginHeading);
        i(t, !1)
      }));

      function i(e, t) {
        var i = n.querySelector(selectors$22.loginContainer),
          r = n.querySelector(selectors$22.resetPasswordContainer);
        t ? (i.classList.add(classes$16.hidden), r.classList.remove(classes$16.hidden)) : (i.classList.remove(classes$16.hidden), r.classList.add(classes$16.hidden)), e.setAttribute("tabindex", "-1"), e.focus(), e.addEventListener("blur", function() {
          e.removeAttribute("tabindex")
        })
      }
    }(), window.addEventListener("DOMContentLoaded", function() {
      new Form, sections.load("*"), window.carts = Array.from(document.querySelectorAll("[data-cart]"), function(e) {
        var t = new Cart(e);
        return t.init(), t
      }), window.popups = Array.from(document.querySelectorAll("[data-popup]"), function(e) {
        var t = new Popup(e.dataset.popup);
        return t.init(), t
      }), _shopify_themeA11y.accessibleLinks("a[href]:not([aria-describedby]", {
        messages: {
          newWindow: theme.strings.newWindow,
          external: theme.strings.external,
          newWindowExternal: theme.strings.newWindowExternal
        }
      }), theme.cartQuantity = new CartQuantity, theme.cartQuantity.updateLocalCartState();
      var e = document.querySelector("[data-cart-template]");
      e && new CartTemplate(e).init();
  if (window.innerWidth > 780 && document.querySelector('.multiple-items') != null || document.querySelector('.pre-order-marquee') != null ) {
      Array.from(document.querySelectorAll(".marquee3k")).length > 0 && (Marquee3k.init(), Marquee3k.pauseAll())
  }
    }), window.addEventListener("load", function() {
      if (window.innerWidth > 200000000740) {
        Array.prototype.slice.call(document.body.querySelectorAll(".sweat")).length > 0 && loadJS("//cdn.shopify.com/s/files/1/0533/5426/6819/t/2/assets/pixi.min.js?v=11456403420155925378", function() {
          initPIXI()
        })
      }
    })
  }(Shopify.theme.sections, Shopify.theme.a11y);

window.addEventListener("DOMContentLoaded", function() {
  const triggers = document.querySelectorAll('.js-slide-toggle');
  if (triggers) {
    if (typeof triggers == 'object') {
      for (var i = 0; i < triggers.length; i++) {
        var trigger = triggers[i];
        triggerAction(trigger);
      }
    } else {
      triggerAction(triggers);
    }
  }
})

function getChild(element, className) {
  for (var i = 0; i < element.childNodes.length; i++) {
    const child = element.childNodes[i];
    if ((child.classList) && (child.classList.contains(className))) {
      return child;
    }
  }
}

function getHeight(el) {
  var el_style      = window.getComputedStyle(el),
    el_display    = el_style.display,
    el_position   = el_style.position,
    el_visibility = el_style.visibility,
    el_max_height = el_style.maxHeight.replace('px', '').replace('%', ''),

    wanted_height = 0;

  // if its not hidden we just return normal height
  if(el_display !== 'none' && el_max_height !== '0') {
      return el.offsetHeight;
  }

  // the element is hidden so:
  // making the el block so we can meassure its height but still be hidden
  el.style.position   = 'absolute';
  el.style.visibility = 'hidden';
  el.style.display    = 'block';

  wanted_height     = el.offsetHeight;

  // reverting to the original values
  el.style.display    = el_display;
  el.style.position   = el_position;
  el.style.visibility = el_visibility;

  return wanted_height;
}

function triggerAction (trigger) {
  trigger.addEventListener('click', function() {
    const wrapper = trigger.closest(".js-slide-wrapper");

    if (!wrapper) return false;

    if (wrapper.classList.contains('active')) {
      trigger.innerHTML = 'view'
    } else {
      trigger.innerHTML = 'close'
    }

    wrapper.classList.toggle('active');

    const content = getChild(wrapper, 'js-slide-content');
    if (typeof content != 'undefined') {
      const contentInner = getChild(content, 'js-slide-content-inner');
      var maxHeight = getHeight(contentInner);

      if (!wrapper.classList.contains('active')) {
        maxHeight = 0
      }

      content.style.maxHeight = maxHeight + 'px';
    }
  })
}


function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              resolve(document.querySelector(selector));
              observer.disconnect();
          }
      });

      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}

waitForElm('.rc-container').then((elm) => {

    var radios = document.querySelectorAll('.rc-template input');
  
  
  function changeHandler(event) {
    window.setTimeout(function () { 
      for (const single_price of document.querySelectorAll(".product-form__add-to-cart.with-js .price__regular .price-item--regular")) {
        const single_price_is = single_price.textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
        
        document.querySelector('.product-header-price i span').innerHTML = single_price_is;
        document.querySelector('.product-header-price-mobile i span').innerHTML = single_price_is;
        single_price.parentNode.closest('.product-form__add-to-cart').setAttribute('aria-label', single_price_is + ' - Add to Cart');
     
        }
    }, 100); 
    
  }
  Array.prototype.forEach.call(radios, function(radio) {
     radio.addEventListener('change', changeHandler);
  });
});


waitForElm('#conjured_advocate_share_type').then((elm) => {
  document.querySelector('.template_advocate_share_type_button_email img').setAttribute('alt', 'email icon');
  document.querySelector('.template_advocate_share_type_button_twitter img').setAttribute('alt', 'twitter icon');
  document.querySelector('.template_advocate_share_type_button_facebook img').setAttribute('alt', 'facebook icon');
  document.querySelector('.template_advocate_share_type_button_whatsapp img').setAttribute('alt', 'whatsapp icon');
  document.querySelector('.template_advocate_share_type_button_link img').setAttribute('alt', 'share icon');
  document.querySelector('.template_advocate_share_type_button_sms img').setAttribute('alt', 'sms icon');
  document.querySelector('#conjured_referral_email').setAttribute('title', 'Enter email address');
  document.querySelector('#conjured_referral_name').setAttribute('title', 'Enter First and Last name');
  document.querySelector('#conjured_emails').setAttribute('title', 'Email Subject');
  document.querySelector('#conjured_subject').setAttribute('title', 'Email Subject');
  document.querySelector('#conjured_link').setAttribute('title', 'Enter Link');
  document.querySelector('#conjured_message').setAttribute('title', 'Enter Message');
  document.querySelector('.template_advocate_signup_heading').remove();
  
});

waitForElm('.jdgm-random-link').then((elm) => {
  document.querySelector('.jdgm-random-link').remove();
});



if ( document.querySelector(".price-item--regular") != null) {
  
      for (const single_price of document.querySelectorAll(".product-form__add-to-cart.with-js .price__regular .price-item--regular")) {
        const single_price_is = single_price.textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
        console.log(single_price_is);
        single_price.parentNode.closest('.product-form__add-to-cart').setAttribute('aria-label', single_price_is + ' - Add to Cart');
     
        }
}


if ( document.querySelector(".price-item--regular") != null) {
  // Do this instead
setInterval(function() {
  const getprice = document.querySelector(".price-item--regular").textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
  document.querySelector(".product-form__add-to-cart").setAttribute('aria-label', getprice);
}, 3000);
}


if ( document.querySelector(".ctc-item") != null) {
document.querySelector(".ctc-item iframe").setAttribute('aria-label', 'login via socal media');
}



if (window.location.href.indexOf("faq") != -1) {
  if (window.location.pathname.split("/").pop() == '' || window.location.pathname.split("/").pop() == 'faq' ) {
    document.querySelector(".split-page-hero-category:first-child").setAttribute('aria-expanded', 'true');
    
  }
  else {
    
    var url_value = window.location.pathname.split("/").pop();
    
    const url_buttons = document.querySelectorAll(".split-dropdown")
    const url_buttons_wrapper = document.querySelectorAll(".split-hero-content");
    const url_buttons_cat = document.querySelectorAll(".split-page-hero-category");
    
    for (const button_wrapper of url_buttons_wrapper) {
      button_wrapper.classList.remove('active');
        }
    
    for (const button_cat of url_buttons_cat) {
      button_cat.classList.remove('active');
        }
    
for (const button of url_buttons) {
   button.classList.remove('active');
   if (button.getAttribute('data-url') === url_value) {
    button.classList.add('active');
      button.firstElementChild.setAttribute('aria-expanded', 'true');
  	button.closest('.split-hero-content').classList.add('active');
     
     
    var cat_is = button.closest('.split-hero-content').getAttribute('data-cat');
     
        for (const button_cat of url_buttons_cat) {
       if (button_cat.getAttribute('data-cat') === cat_is) {
         button_cat.classList.add('active');
          button_cat.setAttribute('aria-expanded', 'true');
       }
        }
  }
  else {
  for (const button_cat of url_buttons_cat) {
       if (button_cat.getAttribute('data-cat') === url_value) {
         button_cat.classList.add('active');
          button_cat.setAttribute('aria-expanded', 'true');
       }
        }
    
      for (const button_wrapper of url_buttons_wrapper) {
      if (button_wrapper.getAttribute('data-cat') === url_value) {
         button_wrapper.classList.add('active');
       }
        }
   
  }
  
 
 
}
  }
  
}


const url_buttons_cat = document.querySelectorAll(".split-page-hero-category");

const accordion_buttons = document.querySelectorAll(".dropdownBTN");
for ( const accordion_button of accordion_buttons) {
    accordion_button.addEventListener('click', function(event) {
      
          for (const button_cat_inner_fix of accordion_buttons) {
       button_cat_inner_fix.setAttribute('aria-expanded', 'false');
    }
      
    accordion_button.setAttribute('aria-expanded', 'false');
      if( accordion_button.getAttribute('aria-expanded') == 'false') {
           accordion_button.setAttribute('aria-expanded', 'true');
      }
      else {
           accordion_button.setAttribute('aria-expanded', 'false');
      }
      
          })
}

for (const button_cat of url_buttons_cat) {
  button_cat.addEventListener('click', function(event) {
    
    for (const button_cat_inner of url_buttons_cat) {
       button_cat_inner.setAttribute('aria-expanded', 'false');
    }
    
    button_cat.setAttribute('aria-expanded', 'true');
    window.setTimeout(function () { 
      document.getElementById(button_cat.getAttribute('data-cat')).focus();
      }, 100); 
     document.getElementById(button_cat.getAttribute('data-cat')).setAttribute('tabindex', '0');
    history.pushState({}, null, 'https://offcourt.com/pages/faq/'+ button_cat.getAttribute('data-cat'));
  })
}




const url_buttons = document.querySelectorAll(".split-dropdown")
for (const button of url_buttons) {
  button.addEventListener('click', function(event) {
    history.pushState({}, null, 'https://offcourt.com/pages/faq/'+ button.getAttribute('data-url'));
  })
}




    if (window.location.href.indexOf("subscriptions") > -1) {
      document.querySelector('.js-subscriptions-page').classList.add('active__sub');
       document.querySelector('.nav__list--mobile .js-subscriptions-page').classList.add('hidden-li');
    }

   if (window.location.href.indexOf("schedule") > -1) {
      document.querySelector('.js-schedule-page').classList.add('active__sub');
            document.querySelector('.nav__list--mobile .js-schedule-page').classList.add('hidden-li');

    }

 if (window.location.href.indexOf("orders") > -1) {
      document.querySelector('.js-orders-page').classList.add('active__sub');
               document.querySelector('.nav__list--mobile .js-orders-page').classList.add('hidden-li');

    }

 if (window.location.href.indexOf("addresses") > -1) {
      document.querySelector('.js-addresses-page').classList.add('active__sub');
    document.querySelector('.nav__list--mobile .js-addresses-page').classList.add('hidden-li');
    }

 if (window.location.href.indexOf("payment_sources") > -1) {
      document.querySelector('.js-payment_sources-page').classList.add('active__sub');
      document.querySelector('.nav__list--mobile .js-payment_sources-page').classList.add('hidden-li');
    }



/*
window.addEventListener('resize', function(event) {
   if (window.innerWidth <= 820) {
  document.querySelector('#hero-slideshow .flickity-page-dots').style.top = document.querySelector('.hero-slideshow .hero-mobile-img').offsetHeight + 'px';
}
}, true);


window.addEventListener('load', (event) => {
  if (window.innerWidth <= 820) {
  document.querySelector('#hero-slideshow .flickity-page-dots').style.top = document.querySelector('.hero-slideshow .hero-mobile-img').offsetHeight + 'px';
}
});
*/

if (document.querySelector('.form__input--select') != null) {
  console.log('test');
document.querySelector(".form__input--select").addEventListener("change", function() {
  console.log('test-2');
  if (this.options[this.selectedIndex].value == '3.4 Oz') {
    document.querySelector('.product-gallery').classList.add('small-active');

    document.querySelector('.weight').textContent = '3.4 Oz';

    const all_galleryimg = document.querySelectorAll(".gallery-item")
    for (const galleryimg of all_galleryimg) {
      galleryimg.classList.add('hide');
    }
    document.querySelector('.gallery-item:nth-child(2)').classList.add('animate');
    document.querySelector('.gallery-item:nth-child(2)').classList.remove('hide');

  }
  if (this.options[this.selectedIndex].value == '14 Oz') {
    document.querySelector('.product-gallery').classList.remove('small-active');

    document.querySelector('.weight').textContent = '14 Oz';

    const all_galleryimg = document.querySelectorAll(".gallery-item")
    for (const galleryimg of all_galleryimg) {
      galleryimg.classList.add('hide');
    }

    document.querySelector('.gallery-item:first-child').classList.remove('hide');

  }
});
}


document.addEventListener('focus', function() {
if( document.querySelector('.link--has-dropdown') != null) {
  document.querySelector('.link--has-dropdown').classList.add('is-here')
if (document.activeElement === document.querySelector('.link--has-dropdown')) {
         document.querySelector(".menu-dropdown--second-level").classList.add("hover");   
}
  
  if (document.activeElement === document.querySelector('.menu-navigation__item--link')) {
         document.querySelector(".menu-dropdown--second-level").classList.remove("hover");   
}
  
    if (document.activeElement === document.querySelector('.header-logo')) {
         document.querySelector(".menu-dropdown--second-level").classList.remove("hover");   
}
}
  }, true);


  
  
  document.addEventListener('focusin', function() {
}, true);
  

if (document.querySelector('.multiple-items') != null) {
$('.multiple-items-left').slick({
  infinite: true,
  slidesToShow: 1,
   pauseOnHover: false,
    autoplay: true,
  autoplaySpeed: 5000,
  asNavFor: '.multiple-items-right',
   fade: true,
   dots: true,
   loop: true,
   centerMode: true,
  slidesToScroll: 1,
   regionLabel: 'Featured Products'
});

$('.multiple-items-right').slick({
  dots: true,
  infinite: true,
  speed: 300,
  autoplay: true,
  arrows: false,
  slidesToShow: 1.2,
  slidesToShow: 1,
  asNavFor: '.multiple-items-left',
  centerPadding: 100,
  centerMode: true,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        centerMode: false,
        slidesToShow: 1,
        centerPadding: 0,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },

    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
}

var prevScrollPos = window.pageYOffset || document.documentElement.scrollTop;
var body = document.body;

window.addEventListener('scroll', function() {
  console.log('what');
  var currentScrollPos = window.pageYOffset || document.documentElement.scrollTop;

  if (currentScrollPos > prevScrollPos) {
    body.classList.add('scroll-down');
    body.classList.remove('scroll-up');
  } else {
    body.classList.remove('scroll-down');
    body.classList.add('scroll-up');
  }

  prevScrollPos = currentScrollPos;
});







if (document.querySelector('.about-nav') != null ) {
const aboutItem = document.querySelector('.about-item');
const aboutNav = document.querySelector('.about-nav');

aboutItem.addEventListener('mouseenter', () => {
  aboutNav.classList.remove('closed');
});

aboutItem.addEventListener('mouseleave', () => {
  aboutNav.classList.remove('closed');
});

aboutNav.addEventListener('mouseleave', () => {
  aboutNav.classList.add('closed');
});

aboutNav.addEventListener('mouseenter', () => {
  aboutNav.classList.remove('closed');
});

aboutNav.addEventListener('mouseleave', () => {
  aboutNav.classList.add('closed');
});
}




if (document.querySelector('.bundles-slider') != null && window.innerWidth >= 780 ) {
  $(document).ready(function() {
  $('.bundles-slider').slick({
    infinite: true,
    slidesToShow: 1,
     loop: true,
     dots: true,
    slidesToScroll: 1,
          regionLabel: 'All Products',
  });
});
}

  if (window.innerWidth > 780 && document.querySelector('.multiple-items-product') != null) {
$(document).ready(function() {
  
 
  
  

  

 
  

  
  /*
  window.innerWidth > 780 &&
  var $status = $('.pagingInfo');
var $slickElement = $('.multiple-items');


$slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $status.text('0'+ i + '–' + '0'+ slick.slideCount);
});*/
  
  
   $('.multiple-items-product').slick({
  infinite: true,
  slidesToShow: 4,
   loop: true,
  slidesToScroll: 4,
        regionLabel: 'All Products',
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
 
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
});
 
                  }

  if (window.innerWidth > 780 && document.querySelector('.product-gallery') != null) {
$('body').on("keyup", function(e) {
  var code = e.which;

  // get current .open element
  var $currentImage = $('.gallery-item:not(".hide")');

  // if any of the figure is having class open then only proceed
  if ($currentImage.length > 0) {
    if (code == 38) { // left arrow
      e.preventDefault();      
      // get previous figure element
      var prev = $currentImage.prev('div');
      // if length is 0 then it means current one is first. So select last sibling
      if (prev.length == 0) {
        prev = $($currentImage).siblings("div:last")
      }
      // remove all open class
      $('.gallery-item').addClass('hide');
      // add open class to prev element
      $(prev).removeClass('hide');
    } else if (code == 40) { // right arrow
      e.preventDefault();      
      // get next figure element
      var next = $currentImage.next('div');
       // if length is 0 then it means current one is last. So select first sibling
      if (next.length == 0) {
        next = $($currentImage).siblings("div:first")
      }
      // remove all open class
      $('.gallery-item').addClass('hide');
      // add open class to next element
      console.log($currentImage.next('div'));
      $(next).removeClass('hide');
    };
  }
});
  }




  /*
  if (document.querySelector('#Option-product-bundles-all-0') != null) {

    document.querySelector('.gallery-item:first-child').classList.add('hide');
    document.querySelector('.gallery-item:nth-child(2)').classList.remove('hide');
    document.querySelector('.gallery-item:nth-child(3)').classList.add('hide');
  }*/


  if (document.querySelector('.radio-select') != null) {
    var radios = document.querySelectorAll('.radio-select input');
    
    Array.prototype.forEach.call(radios, function(radio) {
      radio.addEventListener('click', (event) => {

        console.log(radio.id)

        if (radio.id == 'size1') {

          //white


          if (document.querySelector('#Option-product-bundles-gym-0') != null) {
            document.querySelector('.gallery-item:first-child').classList.remove('hide');
            document.querySelector('.gallery-item:nth-child(2)').classList.add('hide');
            document.querySelector('.gallery-item:nth-child(3)').classList.add('hide');
          }
          else {
            document.querySelector('.gallery-item:first-child').classList.add('hide');
            document.querySelector('.gallery-item:nth-child(2)').classList.add('hide');
            document.querySelector('.gallery-item:nth-child(3)').classList.remove('hide');
          }

       

        //  document.querySelector('.white-slider').classList.add('hide-slider');
       //   document.querySelector('.green-slider').classList.add('hide-slider');
       //   document.querySelector('.blue-slider').classList.remove('hide-slider');

          document.querySelector('.black-list').classList.add('hide-list');
          document.querySelector('.green-list').classList.add('hide-list');
          document.querySelector('.blue-list').classList.remove('hide-list');

          document.querySelector('.text-black').classList.add('hide-desc');
          document.querySelector('.text-green').classList.add('hide-desc');
          document.querySelector('.text-blue').classList.remove('hide-desc');
  
        }

        if (radio.id == 'size2') {


          if (document.querySelector('#Option-product-bundles-all-0') != null) {
            document.querySelector('.gallery-item:first-child').classList.add('hide');
            document.querySelector('.gallery-item:nth-child(2)').classList.remove('hide');
            document.querySelector('.gallery-item:nth-child(3)').classList.add('hide');
        }
        else if (document.querySelector('#Option-product-bundles-gym-0') != null) {
          document.querySelector('.gallery-item:first-child').classList.add('hide');
          document.querySelector('.gallery-item:nth-child(2)').classList.remove('hide');
          document.querySelector('.gallery-item:nth-child(3)').classList.add('hide');
        }
        else {
          document.querySelector('.gallery-item:first-child').classList.remove('hide');
          document.querySelector('.gallery-item:nth-child(2)').classList.add('hide');
          document.querySelector('.gallery-item:nth-child(3)').classList.add('hide');
        }

        

         // document.querySelector('.white-slider').classList.add('hide-slider');
       //   document.querySelector('.green-slider').classList.remove('hide-slider');
        //  document.querySelector('.blue-slider').classList.add('hide-slider');

          document.querySelector('.black-list').classList.add('hide-list');
          document.querySelector('.green-list').classList.remove('hide-list');
          document.querySelector('.blue-list').classList.add('hide-list');

          document.querySelector('.text-black').classList.add('hide-desc');
          document.querySelector('.text-green').classList.remove('hide-desc');
          document.querySelector('.text-blue').classList.add('hide-desc');

     
        }

        if (radio.id == 'size3') {
          //black

          if (document.querySelector('#Option-product-bundles-all-0') != null) {
            document.querySelector('.gallery-item:first-child').classList.remove('hide');
            document.querySelector('.gallery-item:nth-child(2)').classList.add('hide');
            document.querySelector('.gallery-item:nth-child(3)').classList.add('hide');
        }
        else if (document.querySelector('#Option-product-bundles-gym-0') != null) {
          document.querySelector('.gallery-item:first-child').classList.add('hide');
          document.querySelector('.gallery-item:nth-child(2)').classList.add('hide');
          document.querySelector('.gallery-item:nth-child(3)').classList.remove('hide');
        }
        else {
          document.querySelector('.gallery-item:first-child').classList.add('hide');
          document.querySelector('.gallery-item:nth-child(2)').classList.remove('hide');
          document.querySelector('.gallery-item:nth-child(3)').classList.add('hide');
        }



          document.querySelector('.text-black').classList.remove('hide-desc');
          document.querySelector('.text-green').classList.add('hide-desc');
          document.querySelector('.text-blue').classList.add('hide-desc');


         // document.querySelector('.white-slider').classList.remove('hide-slider');
        //  document.querySelector('.green-slider').classList.add('hide-slider');
       //   document.querySelector('.blue-slider').classList.add('hide-slider');

          document.querySelector('.black-list').classList.remove('hide-list');
          document.querySelector('.green-list').classList.add('hide-list');
          document.querySelector('.blue-list').classList.add('hide-list');

        }
        document.querySelector('.f-type').innerHTML = radio.value;
        if (document.querySelector('.f-type-third') != null) {
        document.querySelector('.f-type-third').innerHTML = radio.value;
        }

        if (document.querySelector('#Option-product-bundles-gym-0') != null) {
          document.querySelector('#Option-product-bundles-gym-0').value = radio.value;
        }

        if (document.querySelector('#Option-product-bundles-all-0') != null) {
          document.querySelector('#Option-product-bundles-all-0').value = radio.value;
        }

        if (document.querySelector('#Option-product-bundles-check-gym-0') != null) {
          document.querySelector('#Option-product-bundles-check-gym-0').value = radio.value;
        }

        if (document.querySelector('#Option-product-bundles-check-all-0') != null) {
          document.querySelector('#Option-product-bundles-check-all-0').value = radio.value;
        }


        if (document.querySelector('#Option-product-bundles-0') != null) {
          document.querySelector('#Option-product-bundles-0').value = radio.value;
        }

        if (document.querySelector('#Option-product-bundles-check-0') != null) {
          document.querySelector('#Option-product-bundles-check-0').value = radio.value;
        }

      });
    });
  }



 


  if (document.querySelector('.collection-all-wrapper') != null) {
  const items = document.getElementsByClassName("product-block"); 
  //window.location.href.includes('design') 
  
  showTag = (event, tag) => {
    // console.log(window.location.hash)
    console.log('showing... ', tag)


    if (tag == 'coconut-water-sandalwood') {
      // document.querySelector(".thumbnail-bundle-all-1").style.display = 'block';
      // document.querySelector(".thumbnail-bundle-triple-2").style.display = 'block';
      // document.querySelector(".thumbnail-bundle-gym-3").style.display = 'block';
    }
    else {
      // document.querySelector(".thumbnail-bundle-all-1").style.display = 'none';
      // document.querySelector(".thumbnail-bundle-triple-2").style.display = 'none';
      // document.querySelector(".thumbnail-bundle-gym-3").style.display = 'none';
    }

    if (tag == 'fig-leaves-white-musk') {
      // document.querySelector(".thumbnail-bundle-all-2").style.display = 'block';
      // document.querySelector(".thumbnail-bundle-triple-1").style.display = 'block';
      // document.querySelector(".thumbnail-bundle-gym-2").style.display = 'block';
    }
    else {
      // document.querySelector(".thumbnail-bundle-all-2").style.display = 'none';
      // document.querySelector(".thumbnail-bundle-triple-1").style.display = 'none';
      // document.querySelector(".thumbnail-bundle-gym-2").style.display = 'none';
    }

    if (tag == 'fresh-citron-driftwood') {
      // document.querySelector(".thumbnail-bundle-all-3").style.display = 'block';
      // document.querySelector(".thumbnail-bundle-triple-3").style.display = 'block';
      // document.querySelector(".thumbnail-bundle-gym-1").style.display = 'block';
    }
    else {
      // document.querySelector(".thumbnail-bundle-all-3").style.display = 'none';
      // document.querySelector(".thumbnail-bundle-triple-3").style.display = 'none';
      // document.querySelector(".thumbnail-bundle-gym-1").style.display = 'none';
    }


    for(let i = 0; i< items.length; i++){
      if(items[i].dataset.tags.includes(tag)){
        items[i].style.display = "block";
      }else{
        items[i].style.display = "none";
      }
    }
  }
  
  document.getElementById("body-sprayBtn").addEventListener("click", (event) => showTag(event, 'body-spray'));
  document.getElementById("body-washBtn").addEventListener("click", (event) => showTag(event, 'body-wash'));
  document.getElementById("facial-hydratorBtn").addEventListener("click", (event) => showTag(event, 'facial-hydrator'));
  document.getElementById("fragranceBtn").addEventListener("click", (event) => showTag(event, 'fragrance'));
  document.getElementById("setsBtn").addEventListener("click", (event) => showTag(event, 'set'));
  document.getElementById("soapBtn").addEventListener("click", (event) => showTag(event, 'soap'));
  document.getElementById("gift-cardBtn").addEventListener("click", (event) => showTag(event, 'gift-card'));


  document.getElementById("coconut-water-sandalwoodBtn").addEventListener("click", (event) => showTag(event, 'coconut-water-sandalwood'));
  document.getElementById("fig-leaves-white-muskBtn").addEventListener("click", (event) => showTag(event, 'fig-leaves-white-musk'));
  document.getElementById("fresh-citron-driftwoodBtn").addEventListener("click", (event) => showTag(event, 'fresh-citron-driftwood'));
  document.getElementById("citrus-suedeBtn").addEventListener("click", (event) => showTag(event, 'citrus-suede'));



  const all_filter_buttons = document.querySelectorAll(".filter-button")
  for (const filter_button of all_filter_buttons) {
    filter_button.addEventListener('click', function() {
      for (const filter_button_remove of all_filter_buttons) {
        filter_button_remove.classList.remove('active');
      }
      filter_button.classList.add('active');

    });
  }

  function triggerFilterFromURLHash() {
    // Check if the current URL path contains 'all-products'
    if(window.location.pathname.includes('all-products')) {
      const urlHash = window.location.hash.substring(1); // remove the '#' from the hash
      if(urlHash) {
        const buttonId = urlHash + 'Btn';
        const buttonElement = document.getElementById(buttonId);
        if(buttonElement) {
          buttonElement.click(); // Trigger the click event on the button
        }
      }
    }
  }

  // Call the function to check URL hash and apply filter on page load
  triggerFilterFromURLHash();
  
  document.querySelector('#allBtn').addEventListener('click', function() {

    // document.querySelector(".thumbnail-bundle-all-1").style.display = 'none';
    // document.querySelector(".thumbnail-bundle-all-2").style.display = 'none';
    // document.querySelector(".thumbnail-bundle-all-3").style.display = 'none';
    // document.querySelector(".thumbnail-bundle-gym-1").style.display = 'none';
    // document.querySelector(".thumbnail-bundle-gym-2").style.display = 'none';
    // document.querySelector(".thumbnail-bundle-gym-3").style.display = 'none';
    // document.querySelector(".thumbnail-bundle-triple-1").style.display = 'none';
    // document.querySelector(".thumbnail-bundle-triple-2").style.display = 'none';
    // document.querySelector(".thumbnail-bundle-triple-3").style.display = 'none';

    const all_products = document.querySelectorAll(".product-block")
for (const product of all_products) {
  product.style.display = "block";
}

  });

  document.querySelector('#allBtn-f').addEventListener('click', function() {


    // document.querySelector(".thumbnail-bundle-all-1").style.display = 'none';
    // document.querySelector(".thumbnail-bundle-all-2").style.display = 'none';
    // document.querySelector(".thumbnail-bundle-all-3").style.display = 'none';
    // document.querySelector(".thumbnail-bundle-gym-1").style.display = 'none';
    // document.querySelector(".thumbnail-bundle-gym-2").style.display = 'none';
    // document.querySelector(".thumbnail-bundle-gym-3").style.display = 'none';
    // document.querySelector(".thumbnail-bundle-triple-1").style.display = 'none';
    // document.querySelector(".thumbnail-bundle-triple-2").style.display = 'none';
    // document.querySelector(".thumbnail-bundle-triple-3").style.display = 'none';

    const all_products = document.querySelectorAll(".product-block")
for (const product of all_products) {
  product.style.display = "block";
}

  });
  }








